/**
 * DO NOT EDIT THIS FILE DIRECTLY
 *
 * It is automatically generated using yarn icons:generate.
 */
import * as React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var IconArrowCompressCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm9.641-3.641a.75.75 0 0 1 0 1.06l-1.339 1.34h.782a.75.75 0 1 1 0 1.5H8.492a.748.748 0 0 1-.293-.06c.038.09.06.189.06.293v2.592a.75.75 0 1 1-1.5 0v-.782l-1.34 1.34a.75.75 0 0 1-1.06-1.061l1.339-1.34h-.782a.75.75 0 1 1 0-1.5h2.592c.104 0 .203.022.293.06a.748.748 0 0 1-.06-.293V4.916a.75.75 0 0 1 1.5 0v.782l1.34-1.34a.75.75 0 0 1 1.06 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm5.197-14.197a.75.75 0 0 1 0 1.06l-2.649 2.65h2.078a.75.75 0 0 1 0 1.5h-3.889a.75.75 0 0 1-.75-.75v-3.89a.75.75 0 0 1 1.5 0v2.079l2.65-2.649a.75.75 0 0 1 1.06 0Zm-9.823 6.684h2.078l-2.649 2.65a.75.75 0 0 0 1.06 1.06l2.65-2.65v2.08a.75.75 0 0 0 1.5 0v-3.89a.75.75 0 0 0-.75-.75h-3.89a.75.75 0 0 0 0 1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCompressCircleFill };
var IconArchiveFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.85 3c-.442 0-.85.291-.85.7v1.61c0 .367.328.639.714.691h8.572c.386-.052.714-.324.714-.691V3.7c0-.409-.408-.7-.85-.7h-8.3ZM12 10.778c0 1.06-.888 2.222-1.943 2.222H5.943C4.888 13 4 11.838 4 10.778V7h8v3.778ZM6.25 8.5a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.19 5C5.57 5 5 5.485 5 6.167v2.679c0 .611.459 1.064 1 1.152h12c.541-.088 1-.541 1-1.152v-2.68C19 5.487 18.43 5 17.81 5H6.19ZM18 16.167C18 17.757 16.668 19 15.086 19H8.914C7.332 19 6 17.758 6 16.167V11h12v5.167Zm-8.625-3.375a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5h-3.75a.75.75 0 0 1-.75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArchiveFill };
var IconArrowCompressSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833Zm.141-8.974a.75.75 0 0 1 0 1.06l-1.339 1.34h.782a.75.75 0 0 1 0 1.5H8.492a.748.748 0 0 1-.293-.06c.038.09.06.189.06.293v2.592a.75.75 0 1 1-1.5 0v-.782l-1.34 1.34a.75.75 0 0 1-1.06-1.061l1.339-1.34h-.782a.75.75 0 1 1 0-1.5h2.592c.104 0 .203.022.293.06a.748.748 0 0 1-.06-.293V4.916a.75.75 0 0 1 1.5 0v.782l1.34-1.34a.75.75 0 0 1 1.06 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-.053-13.197a.75.75 0 0 1 0 1.06l-2.649 2.65h2.078a.75.75 0 0 1 0 1.5h-3.889a.75.75 0 0 1-.75-.75v-3.89a.75.75 0 0 1 1.5 0v2.079l2.65-2.649a.75.75 0 0 1 1.06 0Zm-9.823 6.684h2.078l-2.649 2.65a.75.75 0 0 0 1.06 1.06l2.65-2.65v2.08a.75.75 0 0 0 1.5 0v-3.89a.75.75 0 0 0-.75-.75h-3.89a.75.75 0 0 0 0 1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCompressSquareFill };
var IconArrowDownCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm5.47 3.53a.75.75 0 0 0 1.06 0l2.223-2.222a.75.75 0 1 0-1.061-1.06l-.942.941V5a.75.75 0 0 0-1.5 0v4.19l-.942-.943a.75.75 0 1 0-1.06 1.061L7.47 11.53Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm2.803-8.364L12.75 14.69V7.5a.75.75 0 1 0-1.5 0v7.19l-2.053-2.054a.75.75 0 1 0-1.06 1.061l3.333 3.333a.75.75 0 0 0 1.06 0l3.334-3.333a.75.75 0 0 0-1.061-1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownCircleFill };
var IconArrowDownLeftCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm7.59-2.652L6.63 8.311V6.979a.75.75 0 1 0-1.5 0v3.142c0 .415.335.75.75.75h3.14a.75.75 0 0 0 0-1.5H7.69l2.963-2.962a.75.75 0 1 0-1.061-1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm1.532-6.568H10.63l5.083-5.084a.75.75 0 1 0-1.06-1.06L9.568 13.37v-2.903a.75.75 0 0 0-1.5 0v4.714c0 .414.336.75.75.75h4.714a.75.75 0 0 0 0-1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownLeftCircleFill };
var IconArrowDownLeftSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833ZM9.591 5.571 6.629 8.533V7.2a.75.75 0 1 0-1.5 0v3.143c0 .414.335.75.75.75H9.02a.75.75 0 1 0 0-1.5H7.69l2.963-2.963a.75.75 0 1 0-1.061-1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-3.718-5.235H10.63l5.083-5.083a.75.75 0 1 0-1.06-1.061l-5.084 5.084V10.8a.75.75 0 0 0-1.5 0v4.714c0 .415.336.75.75.75h4.714a.75.75 0 0 0 0-1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownLeftSquareFill };
var IconArrowDownRightCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm3.348-1.591 2.963 2.962H6.979a.75.75 0 1 0 0 1.5h3.142a.75.75 0 0 0 .75-.75V6.98a.75.75 0 1 0-1.5 0v1.33L6.41 5.348a.75.75 0 0 0-1.06 1.061Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm2.432-10.532v2.903L9.348 8.288a.75.75 0 0 0-1.06 1.06l5.083 5.084h-2.903a.75.75 0 0 0 0 1.5h4.714a.75.75 0 0 0 .75-.75v-4.714a.75.75 0 0 0-1.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownRightCircleFill };
var IconArrowDownRightSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833ZM5.348 6.631l2.963 2.963H6.979a.75.75 0 1 0 0 1.5h3.142a.75.75 0 0 0 .75-.75V7.2a.75.75 0 0 0-1.5 0v1.332L6.41 5.57a.75.75 0 0 0-1.06 1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-2.818-9.199v2.904L9.348 8.62a.75.75 0 1 0-1.06 1.06l5.083 5.084h-2.903a.75.75 0 0 0 0 1.5h4.714a.75.75 0 0 0 .75-.75V10.8a.75.75 0 1 0-1.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownRightSquareFill };
var IconArrowDownSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.835 1.835 0 0 1-1.833 1.833Zm-4.25-8.11v4.189l-.942-.942a.75.75 0 1 0-1.06 1.06l2.222 2.223a.75.75 0 0 0 1.06 0l2.222-2.223a.75.75 0 0 0-1.06-1.06l-.942.942v-4.19a.75.75 0 0 0-1.5 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-2.447-7.03-2.053 2.053v-7.19a.75.75 0 1 0-1.5 0v7.19L9.197 12.97a.75.75 0 0 0-1.06 1.06l3.333 3.334a.75.75 0 0 0 1.06 0l3.334-3.334a.75.75 0 1 0-1.061-1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownSquareFill };
var IconArrowLeftCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM4.47 8.53a.75.75 0 0 1 0-1.06l2.222-2.223a.75.75 0 0 1 1.06 1.061l-.941.942H11a.75.75 0 0 1 0 1.5H6.81l.943.942a.75.75 0 0 1-1.061 1.06L4.47 8.53Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-5.03-8.47a.75.75 0 0 1 0-1.06l3.333-3.334a.75.75 0 0 1 1.06 1.061L9.312 11.25H16.5a.75.75 0 0 1 0 1.5H9.31l2.054 2.053a.75.75 0 0 1-1.061 1.06L6.97 12.53Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeftCircleFill };
var IconArrowLeftRightCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm10.236.53a.75.75 0 0 0 0-1.06l-1.833-1.834a.75.75 0 0 0-1.06 1.061l.552.553h-3.79l.552-.553a.75.75 0 0 0-1.06-1.06L3.763 7.47a.75.75 0 0 0 0 1.06l1.834 1.834a.75.75 0 1 0 1.06-1.061l-.553-.553h3.791l-.552.553a.75.75 0 0 0 1.06 1.06l1.833-1.833Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm6.09-8.47a.75.75 0 0 0 0-1.06l-2.75-2.75a.75.75 0 1 0-1.06 1.06l1.469 1.47H8.25l1.47-1.47a.75.75 0 0 0-1.06-1.06l-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75a.75.75 0 1 0 1.06-1.06l-1.47-1.47h7.498l-1.47 1.47a.75.75 0 0 0 1.06 1.06l2.75-2.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeftRightCircleFill };
var IconArrowLeftRightSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833Zm.736-4.803a.75.75 0 0 0 0-1.06l-1.833-1.834a.75.75 0 0 0-1.06 1.061l.552.553h-3.79l.552-.553a.75.75 0 0 0-1.06-1.06L3.763 7.47a.75.75 0 0 0 0 1.06l1.834 1.834a.75.75 0 1 0 1.06-1.061l-.553-.553h3.791l-.552.553a.75.75 0 0 0 1.06 1.06l1.833-1.833Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm.84-7.47a.75.75 0 0 0 0-1.06l-2.75-2.75a.75.75 0 1 0-1.06 1.06l1.469 1.47H8.25l1.47-1.47a.75.75 0 0 0-1.06-1.06l-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75a.75.75 0 1 0 1.06-1.06l-1.47-1.47h7.498l-1.47 1.47a.75.75 0 0 0 1.06 1.06l2.75-2.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeftRightSquareFill };
var IconArrowRightCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm3.53-5.47a.75.75 0 0 0 0-1.06L9.308 5.247a.75.75 0 0 0-1.06 1.061l.941.942H5a.75.75 0 0 0 0 1.5h4.19l-.943.942a.75.75 0 0 0 1.061 1.06L11.53 8.53Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm5.03-8.47-3.333 3.334a.75.75 0 0 1-1.06-1.061l2.052-2.053H7.5a.75.75 0 0 1 0-1.5h7.19l-2.054-2.053a.75.75 0 1 1 1.061-1.06l3.333 3.333a.75.75 0 0 1 0 1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowRightCircleFill };
var IconArrowLeftSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.835 1.835 0 0 1-1.833 1.833Zm-7.03-4.58a.75.75 0 0 1 0-1.061L6.692 5.47a.75.75 0 0 1 1.06 1.06l-.941.942H11a.75.75 0 0 1 0 1.5H6.81l.943.942a.75.75 0 1 1-1.061 1.06L4.47 8.754Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20ZM6.97 12.864a.75.75 0 0 1 0-1.061l3.333-3.333a.75.75 0 0 1 1.06 1.06l-2.052 2.053H16.5a.75.75 0 0 1 0 1.5H9.31l2.054 2.053a.75.75 0 0 1-1.061 1.061L6.97 12.864Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeftSquareFill };
var IconArrowRightSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.835 1.835 0 0 1-1.833 1.833Zm.03-4.58-2.222 2.222a.75.75 0 1 1-1.06-1.06l.941-.943H5a.75.75 0 1 1 0-1.5h4.19l-.943-.942a.75.75 0 1 1 1.061-1.06l2.222 2.222a.75.75 0 0 1 0 1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-.22-7.136-3.333 3.333a.75.75 0 0 1-1.06-1.06l2.052-2.054H7.5a.75.75 0 0 1 0-1.5h7.19L12.635 9.53a.75.75 0 1 1 1.061-1.06l3.333 3.333a.75.75 0 0 1 0 1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowRightSquareFill };
var IconArrowTriangularDownFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.23 4.667H3.77a.436.436 0 0 0-.391.253.47.47 0 0 0 .044.477l4.23 5.758a.433.433 0 0 0 .347.178.432.432 0 0 0 .348-.178l4.229-5.758a.47.47 0 0 0 .044-.477.435.435 0 0 0-.392-.253Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M18.344 7H5.656a.654.654 0 0 0-.588.38.705.705 0 0 0 .066.715l6.344 8.637A.65.65 0 0 0 12 17c.205 0 .397-.1.522-.268l6.343-8.637a.704.704 0 0 0 .067-.715.653.653 0 0 0-.588-.38Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowTriangularDownFill };
var IconArrowUpCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0ZM8.53 4.47a.75.75 0 0 0-1.06 0L5.248 6.692a.75.75 0 1 0 1.06 1.06l.942-.941V11a.75.75 0 0 0 1.5 0V6.81l.942.943a.75.75 0 1 0 1.06-1.061L8.53 4.47Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-.53-14.03a.75.75 0 0 1 1.06 0l3.334 3.333a.75.75 0 0 1-1.061 1.06L12.75 9.312V16.5a.75.75 0 1 1-1.5 0V9.31l-2.053 2.054a.75.75 0 1 1-1.06-1.061L11.47 6.97Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpCircleFill };
var IconArrowTriangularRightFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.667 3.77v8.46c0 .165.098.318.253.391a.47.47 0 0 0 .477-.044l5.758-4.23A.433.433 0 0 0 11.333 8a.432.432 0 0 0-.178-.348L5.397 3.423a.47.47 0 0 0-.477-.044.436.436 0 0 0-.253.392Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M7 5.656v12.688c0 .249.147.477.38.588.232.11.51.085.715-.066l8.637-6.344A.649.649 0 0 0 17 12c0-.205-.1-.397-.268-.522L8.095 5.135a.704.704 0 0 0-.715-.067.653.653 0 0 0-.38.588Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowTriangularRightFill };
var IconArrowUpDownCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm5.47 3.792a.75.75 0 0 0 1.06 0l1.834-1.833a.75.75 0 1 0-1.061-1.06l-.553.552V6.55l.553.553a.75.75 0 1 0 1.06-1.06L8.53 4.207a.75.75 0 0 0-1.06 0L5.636 6.041a.75.75 0 1 0 1.061 1.06l.553-.552V9.45l-.553-.553a.75.75 0 1 0-1.06 1.06l1.833 1.834Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-.53-3.577a.75.75 0 0 0 1.06 0l2.75-2.75a.75.75 0 0 0-1.06-1.06l-1.47 1.469V8.918l1.47 1.47a.75.75 0 0 0 1.06-1.061l-2.75-2.75a.75.75 0 0 0-1.06 0l-2.75 2.75a.75.75 0 1 0 1.06 1.06l1.47-1.469v6.164l-1.47-1.47a.75.75 0 0 0-1.06 1.061l2.75 2.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownCircleFill };
var IconArrowUpDownLeftCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '17',
      height: '16',
      viewBox: '0 0 17 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 8a6 6 0 1 1 12 0A6 6 0 0 1 3 8Zm9.278-2.778a.75.75 0 0 0-.75-.75H8.935a.75.75 0 0 0 0 1.5h.782L6.722 8.967v-.782a.75.75 0 0 0-1.5 0v2.593c0 .414.336.75.75.75h2.593a.75.75 0 0 0 0-1.5h-.782l2.995-2.995v.782a.75.75 0 0 0 1.5 0V5.222Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm4.917-13.167a.75.75 0 0 0-.75-.75h-3.89a.75.75 0 0 0 0 1.5h2.079l-5.773 5.773v-2.078a.75.75 0 0 0-1.5 0v3.889c0 .414.336.75.75.75h3.89a.75.75 0 0 0 0-1.5h-2.08l5.773-5.773v2.078a.75.75 0 0 0 1.5 0V7.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownLeftCircleFill };
var IconArrowUpDownLeftSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833Zm.028-8.11a.75.75 0 0 0-.75-.75H8.185a.75.75 0 0 0 0 1.5h.782L5.972 8.966v-.782a.75.75 0 0 0-1.5 0v2.593c0 .414.336.75.75.75h2.593a.75.75 0 0 0 0-1.5h-.782l2.995-2.995v.782a.75.75 0 0 0 1.5 0V5.222Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-.333-12.167a.75.75 0 0 0-.75-.75h-3.89a.75.75 0 0 0 0 1.5h2.079l-5.773 5.773v-2.078a.75.75 0 0 0-1.5 0v3.889c0 .414.336.75.75.75h3.89a.75.75 0 0 0 0-1.5h-2.08l5.773-5.773v2.078a.75.75 0 0 0 1.5 0V7.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownLeftSquareFill };
var IconArrowUpDownRightSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833Zm-.722-1.805a.75.75 0 0 0 .75-.75V8.185a.75.75 0 1 0-1.5 0v.782L7.033 5.972h.782a.75.75 0 0 0 0-1.5H5.222a.75.75 0 0 0-.75.75v2.593a.75.75 0 1 0 1.5 0v-.782l2.995 2.995h-.782a.75.75 0 0 0 0 1.5h2.593Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-1.083-3.083a.75.75 0 0 0 .75-.75v-3.89a.75.75 0 0 0-1.5 0v2.08L9.644 8.582h2.078a.75.75 0 0 0 0-1.5H7.833a.75.75 0 0 0-.75.75v3.89a.75.75 0 0 0 1.5 0V9.643l5.773 5.773h-2.078a.75.75 0 0 0 0 1.5h3.889Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownRightSquareFill };
var IconArrowUpDownRightCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm8.778 3.528a.75.75 0 0 0 .75-.75V8.185a.75.75 0 0 0-1.5 0v.782L7.033 5.972h.782a.75.75 0 0 0 0-1.5H5.222a.75.75 0 0 0-.75.75v2.593a.75.75 0 1 0 1.5 0v-.782l2.995 2.995h-.782a.75.75 0 0 0 0 1.5h2.593Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm4.167-4.083a.75.75 0 0 0 .75-.75v-3.89a.75.75 0 0 0-1.5 0v2.08L9.644 8.582h2.078a.75.75 0 0 0 0-1.5H7.833a.75.75 0 0 0-.75.75v3.89a.75.75 0 0 0 1.5 0V9.643l5.773 5.773h-2.078a.75.75 0 0 0 0 1.5h3.889Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownRightCircleFill };
var IconArrowUpDownSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833Zm-4.03-1.541a.75.75 0 0 0 1.06 0l1.834-1.833a.75.75 0 1 0-1.061-1.06l-.553.552V6.55l.553.553a.75.75 0 1 0 1.06-1.06L8.53 4.207a.75.75 0 0 0-1.06 0L5.636 6.041a.75.75 0 1 0 1.061 1.06l.553-.552V9.45l-.553-.553a.75.75 0 0 0-1.06 1.06l1.833 1.834Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-5.78-2.577a.75.75 0 0 0 1.06 0l2.75-2.75a.75.75 0 0 0-1.06-1.06l-1.47 1.469V8.918l1.47 1.47a.75.75 0 0 0 1.06-1.061l-2.75-2.75a.75.75 0 0 0-1.06 0l-2.75 2.75a.75.75 0 1 0 1.06 1.06l1.47-1.469v6.164l-1.47-1.47a.75.75 0 0 0-1.06 1.061l2.75 2.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownSquareFill };
var IconArrowUpLeftCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm8.652 1.591L7.689 6.629h1.332a.75.75 0 0 0 0-1.5H5.88a.75.75 0 0 0-.75.75V9.02a.75.75 0 1 0 1.5 0V7.69l2.962 2.963a.75.75 0 0 0 1.06-1.061Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-2.432-7.468V10.63l5.084 5.083a.75.75 0 0 0 1.06-1.06L10.63 9.568h2.903a.75.75 0 0 0 0-1.5H8.818a.75.75 0 0 0-.75.75v4.714a.75.75 0 0 0 1.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpLeftCircleFill };
var IconArrowUpLeftSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.835 1.835 0 0 1-1.833 1.833Zm-.848-3.52L7.689 6.851h1.332a.75.75 0 0 0 0-1.5H5.88a.75.75 0 0 0-.75.75v3.143a.75.75 0 0 0 1.5 0V7.912l2.962 2.962a.75.75 0 0 0 1.06-1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20Zm-7.682-6.135v-2.903l5.084 5.084a.75.75 0 0 0 1.06-1.061L10.63 9.901h2.903a.75.75 0 0 0 0-1.5H8.818a.75.75 0 0 0-.75.75v4.714a.75.75 0 0 0 1.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpLeftSquareFill };
var IconArrowUpRightCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm4.409 2.652 2.962-2.963v1.332a.75.75 0 1 0 1.5 0V5.88a.75.75 0 0 0-.75-.75H6.98a.75.75 0 1 0 0 1.5h1.33L5.348 9.59a.75.75 0 1 0 1.061 1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM10.468 9.568h2.903l-5.083 5.084a.75.75 0 0 0 1.06 1.06l5.084-5.083v2.903a.75.75 0 0 0 1.5 0V8.818a.75.75 0 0 0-.75-.75h-4.714a.75.75 0 0 0 0 1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpRightCircleFill };
var IconArrowUpRightSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.836 1.836 0 0 1-1.833 1.833Zm-5.091-2.46 2.962-2.961v1.332a.75.75 0 1 0 1.5 0V6.1a.75.75 0 0 0-.75-.75H6.98a.75.75 0 1 0 0 1.5h1.33L5.348 9.813a.75.75 0 0 0 1.061 1.06Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20ZM10.468 9.901h2.903l-5.083 5.084a.75.75 0 1 0 1.06 1.06l5.084-5.083v2.903a.75.75 0 0 0 1.5 0V9.151a.75.75 0 0 0-.75-.75h-4.714a.75.75 0 0 0 0 1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpRightSquareFill };
var IconArrowUpSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 13.333h-7A1.835 1.835 0 0 1 2.667 11.5v-7c0-1.011.822-1.833 1.833-1.833h7c1.01 0 1.833.822 1.833 1.833v7a1.835 1.835 0 0 1-1.833 1.833ZM7.47 4.692a.75.75 0 0 1 1.06 0l2.222 2.222a.75.75 0 0 1-1.06 1.06l-.942-.941v4.19a.75.75 0 0 1-1.5 0v-4.19l-.942.942a.75.75 0 1 1-1.06-1.06L7.47 4.691Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.25 20H6.75A2.753 2.753 0 0 1 4 17.25V6.75A2.753 2.753 0 0 1 6.75 4h10.5A2.753 2.753 0 0 1 20 6.75v10.5A2.753 2.753 0 0 1 17.25 20ZM11.47 7.303a.75.75 0 0 1 1.06 0l3.334 3.333a.75.75 0 0 1-1.061 1.061L12.75 9.644v7.19a.75.75 0 1 1-1.5 0v-7.19l-2.053 2.053a.75.75 0 1 1-1.06-1.06l3.333-3.334Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpSquareFill };
var IconBagFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.174 5.333a1.834 1.834 0 0 1 3.652 0H6.174Zm-1.003 0a2.834 2.834 0 0 1 5.657 0h.418c.608 0 1.107.48 1.133 1.086l.239 5.734a1.133 1.133 0 0 1-1.133 1.18h-6.97c-.645 0-1.16-.536-1.132-1.18l.238-5.734a1.133 1.133 0 0 1 1.133-1.086h.417Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.261 8a2.75 2.75 0 0 1 5.478 0H9.26ZM7.757 8a4.25 4.25 0 0 1 8.486 0h.626a1.7 1.7 0 0 1 1.699 1.63l.358 8.6A1.7 1.7 0 0 1 17.228 20H6.772a1.7 1.7 0 0 1-1.698-1.77l.358-8.6A1.7 1.7 0 0 1 7.131 8h.626Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBagFill };
var IconBlankFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3.833 11.333a1.5 1.5 0 0 0 1.5 1.5h5.334a1.5 1.5 0 0 0 1.5-1.5V7.288a1.5 1.5 0 0 0-.44-1.06L9.106 3.605a1.5 1.5 0 0 0-1.06-.44H5.332a1.5 1.5 0 0 0-1.5 1.5v6.667Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M5.75 17A2.25 2.25 0 0 0 8 19.25h8A2.25 2.25 0 0 0 18.25 17v-6.068a2.25 2.25 0 0 0-.659-1.591l-3.932-3.932a2.25 2.25 0 0 0-1.591-.659H8A2.25 2.25 0 0 0 5.75 7v10Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBlankFill };
var IconBoltFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M11.855 6.309a.416.416 0 0 0-.383-.253H9.526l1.75-2.984a.417.417 0 0 0-.36-.628H7.584a.416.416 0 0 0-.365.216L4.163 8.216a.417.417 0 0 0 .365.617H6.41L4.698 12.98a.417.417 0 0 0 .686.447l6.389-6.666a.416.416 0 0 0 .082-.452Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M17.783 9.463a.624.624 0 0 0-.575-.38H14.29l2.625-4.475a.625.625 0 0 0-.539-.941h-5a.625.625 0 0 0-.547.323l-4.584 8.334a.625.625 0 0 0 .548.926h2.823l-2.568 6.22a.625.625 0 0 0 1.03.67l9.583-10a.624.624 0 0 0 .123-.677Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBoltFill };
var IconBoxArrowFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M5.196 3.417h5.608c.247 0 .482.11.64.3l.946 1.134c.125.15.193.339.193.534v6.087a1.11 1.11 0 0 1-1.11 1.111H4.527a1.111 1.111 0 0 1-1.111-1.11V5.384c0-.195.068-.384.193-.534l.946-1.135c.158-.19.393-.3.64-.3Z',
      stroke: 'currentColor',
      strokeWidth: '.833',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 11.472V5.453a.51.51 0 0 1 .509-.509h8.982a.51.51 0 0 1 .509.51v6.018c0 .844-.684 1.528-1.528 1.528H4.528A1.528 1.528 0 0 1 3 11.472Zm4.646-5.015a.5.5 0 0 1 .708 0l1.839 1.839a.5.5 0 0 1-.707.707L8.5 8.017v2.84a.5.5 0 1 1-1 0v-2.84l-.986.986a.5.5 0 1 1-.707-.707l1.84-1.84Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.313 5.975a.625.625 0 0 1 .48-.225h8.413c.186 0 .362.082.48.225l1.202 1.442H6.112l1.201-1.442ZM4.5 8.18v-.102c0-.44.154-.864.434-1.2v-.001l1.42-1.703a1.875 1.875 0 0 1 1.44-.674h8.412c.556 0 1.084.247 1.44.674l1.42 1.703c.28.337.434.762.434 1.2v9.131a2.294 2.294 0 0 1-2.292 2.292H6.792A2.292 2.292 0 0 1 4.5 17.208m8.03-7.523a.75.75 0 0 0-1.06 0l-2.76 2.759a.75.75 0 0 0 1.06 1.06l1.479-1.478v4.259a.75.75 0 1 0 1.5 0v-4.259l1.478 1.479a.75.75 0 0 0 1.061-1.061L12.53 9.685Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBoxArrowFill };
var IconCalendarFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.333 4.472v.417H2.667v-.417c0-.995.81-1.805 1.805-1.805h7.056c.995 0 1.805.81 1.805 1.805ZM2.667 11.528V5.722h10.666v5.806c0 .995-.81 1.805-1.805 1.805H4.472c-.995 0-1.805-.81-1.805-1.805Zm3.028-.195a.694.694 0 1 1 0-1.388.694.694 0 0 1 0 1.388Zm0-2.5a.694.694 0 1 1 0-1.388.694.694 0 0 1 0 1.388Zm2.36 2.5a.694.694 0 1 1 0-1.388.694.694 0 0 1 0 1.388Zm0-2.5a.694.694 0 1 1 0-1.388.694.694 0 0 1 0 1.388Zm2.362 0a.694.694 0 1 1 0-1.388.694.694 0 0 1 0 1.388Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20 6.708v.625H4v-.625A2.711 2.711 0 0 1 6.708 4h10.584A2.711 2.711 0 0 1 20 6.708ZM4 17.292V8.583h16v8.709A2.711 2.711 0 0 1 17.292 20H6.708A2.711 2.711 0 0 1 4 17.292ZM8.542 17a1.041 1.041 0 1 1 0-2.083 1.041 1.041 0 0 1 0 2.083Zm0-3.75a1.041 1.041 0 1 1 0-2.083 1.041 1.041 0 0 1 0 2.083ZM12.083 17a1.041 1.041 0 1 1 0-2.083 1.041 1.041 0 0 1 0 2.083Zm0-3.75a1.041 1.041 0 1 1 0-2.083 1.041 1.041 0 0 1 0 2.083Zm3.542 0a1.042 1.042 0 1 1 0-2.083 1.042 1.042 0 0 1 0 2.083Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCalendarFill };
var IconCardDefaultFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.167 5.833C2.167 4.821 2.987 4 4 4h8c1.012 0 1.833.82 1.833 1.833v4.334c0 1.012-.82 1.833-1.833 1.833H4a1.833 1.833 0 0 1-1.833-1.833V5.833ZM4 5a.833.833 0 0 0-.833.833v4.334c0 .46.373.833.833.833h8c.46 0 .833-.373.833-.833V5.833A.833.833 0 0 0 12 5H4Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.25 8.75A2.75 2.75 0 0 1 6 6h12a2.75 2.75 0 0 1 2.75 2.75v6.5A2.75 2.75 0 0 1 18 18H6a2.75 2.75 0 0 1-2.75-2.75v-6.5ZM6 7.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H6Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardDefaultFill };
var IconCardMinimalFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 3.875C2 2.839 2.84 2 3.875 2h8.25C13.161 2 14 2.84 14 3.875v8.25C14 13.161 13.16 14 12.125 14h-8.25A1.875 1.875 0 0 1 2 12.125v-8.25ZM3.875 3A.875.875 0 0 0 3 3.875v8.25c0 .483.392.875.875.875h8.25a.875.875 0 0 0 .875-.875v-8.25A.875.875 0 0 0 12.125 3h-8.25Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 5.813A2.813 2.813 0 0 1 5.813 3h12.375A2.813 2.813 0 0 1 21 5.813v12.375A2.813 2.813 0 0 1 18.187 21H5.813A2.813 2.813 0 0 1 3 18.187V5.813ZM5.813 4.5c-.725 0-1.313.588-1.313 1.313v12.375c0 .724.588 1.312 1.313 1.312h12.375c.724 0 1.312-.588 1.312-1.313V5.813c0-.724-.588-1.312-1.313-1.312H5.813Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardMinimalFill };
var IconBookFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M7.5 3.667a.617.617 0 0 0-.376-.58 5.027 5.027 0 0 0-4.825.598.726.726 0 0 0-.299.588v8.445c0 .56.606.908 1.09.627 1.137-.661 2.658-.618 3.869-.05.24.112.541-.053.541-.318v-9.31Zm1 9.317c0 .266.3.431.542.318 1.209-.568 2.736-.617 3.87.043A.724.724 0 0 0 14 12.719V4.272c0-.232-.11-.45-.298-.586a5.01 5.01 0 0 0-4.828-.594.617.617 0 0 0-.374.58v9.312Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M11.25 6.501a.926.926 0 0 0-.564-.871 7.54 7.54 0 0 0-7.237.898A1.09 1.09 0 0 0 3 7.409v10.668c0 .839.909 1.362 1.634.94 1.706-.991 3.988-.927 5.804-.075.361.169.812-.078.812-.477V6.5Zm1.5 11.976c0 .399.451.646.812.476 1.814-.852 4.105-.926 5.805.064.724.422 1.633-.1 1.633-.938V7.409c0-.348-.166-.675-.448-.88a7.514 7.514 0 0 0-7.241-.891.925.925 0 0 0-.561.87v11.969Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBookFill };
var IconCardProFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.167 3.833C4.167 2.821 4.987 2 6 2h4c1.012 0 1.833.82 1.833 1.833v8.334c0 1.012-.82 1.833-1.833 1.833H6a1.833 1.833 0 0 1-1.833-1.833V3.833ZM6 3a.833.833 0 0 0-.833.833v8.334c0 .46.373.833.833.833h4c.46 0 .833-.373.833-.833V3.833A.833.833 0 0 0 10 3H6Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.25 5.75A2.75 2.75 0 0 1 9 3h6a2.75 2.75 0 0 1 2.75 2.75v12.5A2.75 2.75 0 0 1 15 21H9a2.75 2.75 0 0 1-2.75-2.75V5.75ZM9 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h6c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25H9Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardProFill };
var IconCheckCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167Zm2.437 4.937a.5.5 0 0 0-.707-.708L7.306 8.821 6.27 7.785a.5.5 0 1 0-.707.707l1.389 1.39a.5.5 0 0 0 .707 0l2.778-2.778Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm3.655 7.405a.75.75 0 1 0-1.06-1.06l-3.637 3.636-1.553-1.553a.75.75 0 1 0-1.06 1.06l2.083 2.084a.75.75 0 0 0 1.06 0l4.167-4.167Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCheckCircleFill };
var IconChatBubbleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.667 8a5.333 5.333 0 1 1 2.742 4.66l-2.376.662a.288.288 0 0 1-.355-.355l.663-2.375A5.305 5.305 0 0 1 2.667 8Zm3.166.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM8.667 8a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Zm1.5.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 12a8 8 0 1 1 8 8 7.961 7.961 0 0 1-3.886-1.011l-3.564.994a.432.432 0 0 1-.533-.532l.995-3.562A7.957 7.957 0 0 1 4 11.999Zm4.75 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.25 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChatBubbleFill };
var IconCheckboxFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236ZM10.611 6.42a.5.5 0 1 0-.806-.592L7.4 9.11 6.145 7.855a.5.5 0 0 0-.707.707l1.667 1.667a.5.5 0 0 0 .757-.058l2.75-3.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854Zm-1.51 5.631a.75.75 0 1 0-1.21-.887l-3.607 4.92-1.882-1.882a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.134-.086l4.125-5.625Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCheckboxFill };
var IconChevronDownSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M13.333 11.5v-7c0-1.01-.822-1.833-1.833-1.833h-7A1.836 1.836 0 0 0 2.667 4.5v7c0 1.01.822 1.833 1.833 1.833h7a1.835 1.835 0 0 0 1.833-1.833ZM11.02 7.52l-2.666 2.667a.498.498 0 0 1-.708 0L4.98 7.52a.5.5 0 1 1 .707-.707L8 9.126l2.313-2.313a.5.5 0 1 1 .707.707Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M20 17.25V6.75A2.753 2.753 0 0 0 17.25 4H6.75A2.753 2.753 0 0 0 4 6.75v10.5A2.753 2.753 0 0 0 6.75 20h10.5A2.753 2.753 0 0 0 20 17.25Zm-3.47-5.97-4 4a.748.748 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L12 13.69l3.47-3.47a.75.75 0 1 1 1.06 1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronDownSquareFill };
var IconChevronLeftSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.5 13.333h7c1.01 0 1.833-.822 1.833-1.833v-7A1.836 1.836 0 0 0 11.5 2.667h-7c-1.01 0-1.833.822-1.833 1.833v7c0 1.011.822 1.833 1.833 1.833Zm3.98-2.313L5.813 8.354a.498.498 0 0 1 0-.708L8.48 4.98a.5.5 0 1 1 .707.707L6.874 8l2.313 2.313a.5.5 0 1 1-.707.707Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M6.75 20h10.5A2.753 2.753 0 0 0 20 17.25V6.75A2.753 2.753 0 0 0 17.25 4H6.75A2.753 2.753 0 0 0 4 6.75v10.5A2.753 2.753 0 0 0 6.75 20Zm5.97-3.47-4-4a.748.748 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06L10.31 12l3.47 3.47a.75.75 0 1 1-1.06 1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronLeftSquareFill };
var IconChevronRightSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M11.5 2.667h-7c-1.01 0-1.833.822-1.833 1.833v7c0 1.011.822 1.833 1.833 1.833h7c1.01 0 1.833-.822 1.833-1.833v-7A1.836 1.836 0 0 0 11.5 2.667ZM7.52 4.98l2.667 2.666a.499.499 0 0 1 0 .708L7.52 11.02a.5.5 0 1 1-.707-.707L9.126 8 6.813 5.687a.5.5 0 1 1 .707-.707Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M17.25 4H6.75A2.753 2.753 0 0 0 4 6.75v10.5A2.753 2.753 0 0 0 6.75 20h10.5A2.753 2.753 0 0 0 20 17.25V6.75A2.753 2.753 0 0 0 17.25 4Zm-5.97 3.47 4 4a.748.748 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L13.69 12l-3.47-3.47a.75.75 0 1 1 1.06-1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronRightSquareFill };
var IconCloudFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.157 6.12C5.573 5.139 6.547 4.214 8 4.214c1.594 0 2.897 1.188 3.225 2.918.404.085.831.264 1.194.534.5.372.914.951.914 1.727 0 1.535-1.384 2.395-2.626 2.395H5.68c-.776 0-1.522-.327-2.073-.833-.552-.506-.94-1.222-.94-2.026 0-1.525 1.253-2.55 2.49-2.807Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.735 9.181C8.36 7.708 9.822 6.32 12 6.32c2.39 0 4.345 1.782 4.837 4.376a4.654 4.654 0 0 1 1.792.801c.749.559 1.37 1.427 1.37 2.591 0 2.302-2.075 3.592-3.94 3.592H8.52c-1.164 0-2.283-.49-3.11-1.249C4.583 15.672 4 14.597 4 13.392c0-2.288 1.88-3.825 3.735-4.21Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCloudFill };
var IconChevronTopSquareFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M2.667 4.5v7c0 1.01.822 1.833 1.833 1.833h7a1.835 1.835 0 0 0 1.833-1.833v-7c0-1.01-.822-1.833-1.833-1.833h-7A1.835 1.835 0 0 0 2.667 4.5ZM4.98 8.48l2.666-2.667a.498.498 0 0 1 .708 0L11.02 8.48a.5.5 0 1 1-.707.707L8 6.874 5.687 9.187a.5.5 0 1 1-.707-.707Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4 6.75v10.5A2.753 2.753 0 0 0 6.75 20h10.5A2.753 2.753 0 0 0 20 17.25V6.75A2.753 2.753 0 0 0 17.25 4H6.75A2.753 2.753 0 0 0 4 6.75Zm3.47 5.97 4-4a.748.748 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12 10.31l-3.47 3.47a.75.75 0 1 1-1.06-1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronTopSquareFill };
var IconCogFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.447 2.204a.502.502 0 0 0-.37.524c.029.379-.196.726-.527.912a4.97 4.97 0 0 0-.102.059c-.326.193-.739.213-1.052-.001a.502.502 0 0 0-.698.698c.215.314.195.727.001 1.054l-.058.1c-.186.332-.534.555-.913.526a.502.502 0 0 0-.256.954c.343.164.531.531.527.91v.118c.005.38-.184.748-.527.912a.502.502 0 0 0 .256.954c.379-.03.726.195.912.526l.059.102c.193.326.213.739 0 1.052a.502.502 0 0 0 .697.698c.314-.215.727-.195 1.054-.001a4.9 4.9 0 0 0 .1.058c.332.186.556.534.527.913a.502.502 0 0 0 .953.256c.164-.343.531-.531.91-.527h.118c.38-.005.748.184.912.527a.502.502 0 0 0 .954-.256c-.03-.379.195-.726.526-.912l.102-.059c.327-.193.739-.213 1.052.001a.502.502 0 0 0 .698-.698c-.215-.314-.195-.727-.001-1.054l.058-.1c.186-.332.534-.555.913-.526a.502.502 0 0 0 .256-.954c-.343-.164-.531-.531-.527-.91v-.118c-.005-.38.184-.748.527-.912a.502.502 0 0 0-.256-.954c-.379.03-.726-.195-.912-.526a5.189 5.189 0 0 0-.059-.102c-.193-.326-.213-.739.001-1.052a.502.502 0 0 0-.698-.698c-.314.215-.727.195-1.054.001a5.127 5.127 0 0 0-.1-.058c-.332-.186-.555-.534-.526-.913a.502.502 0 0 0-.954-.256c-.164.343-.531.531-.91.527h-.118c-.38.005-.748-.184-.912-.527a.502.502 0 0 0-.583-.268ZM12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.67 3.307a.753.753 0 0 0-.555.785c.043.568-.293 1.09-.79 1.368a7.42 7.42 0 0 0-.153.088c-.49.29-1.108.32-1.578-.001a.753.753 0 0 0-1.047 1.047c.322.47.293 1.09.002 1.581l-.087.15c-.28.498-.801.833-1.37.79a.753.753 0 0 0-.384 1.43c.514.246.797.797.79 1.366v.176c.008.57-.275 1.122-.79 1.368a.753.753 0 0 0 .384 1.43c.568-.043 1.09.293 1.368.79l.088.153c.29.49.32 1.108 0 1.578a.753.753 0 0 0 1.046 1.047c.47-.322 1.09-.293 1.581-.002l.15.087c.498.28.833.802.79 1.37a.753.753 0 0 0 1.43.384c.246-.514.797-.797 1.366-.79h.176c.57-.008 1.122.276 1.369.79a.753.753 0 0 0 1.43-.384c-.044-.568.292-1.09.79-1.368l.152-.088c.49-.29 1.108-.32 1.578.001a.753.753 0 0 0 1.047-1.047c-.322-.47-.292-1.09-.002-1.581l.087-.15c.28-.498.802-.833 1.37-.79a.753.753 0 0 0 .384-1.43c-.514-.246-.797-.797-.79-1.366v-.176c-.008-.57.276-1.122.79-1.368a.753.753 0 0 0-.384-1.43c-.568.043-1.09-.293-1.368-.79a7.546 7.546 0 0 0-.088-.153c-.29-.49-.32-1.108.001-1.578a.753.753 0 0 0-1.047-1.047c-.47.322-1.09.292-1.581.002a7.77 7.77 0 0 0-.15-.087c-.498-.28-.833-.801-.79-1.37a.753.753 0 0 0-1.43-.384c-.246.514-.797.797-1.366.79h-.176c-.57.008-1.122-.275-1.368-.79a.753.753 0 0 0-.874-.401ZM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-8.25 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCogFill };
var IconCommentAddFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.281 13.998c.605 0 2.112-.66 2.968-1.27a.366.366 0 0 1 .227-.091c.066.01.131.01.197.01 3.633 0 6.042-2.066 6.042-4.575 0-2.535-2.54-4.58-5.715-4.58-3.174 0-5.714 2.045-5.714 4.58 0 1.617.993 3.033 2.61 3.895.076.04.101.116.06.196-.281.464-.785 1.018-.977 1.27-.196.252-.086.565.302.565Zm3.71-3.543c-.278 0-.43-.201-.43-.494v-1.4H6.076c-.292 0-.498-.157-.498-.429 0-.287.196-.443.498-.443h1.487V6.192c0-.292.151-.494.428-.494.282 0 .449.192.449.494v1.497h1.486c.308 0 .5.156.5.443 0 .272-.208.428-.5.428H8.44v1.401c0 .303-.167.494-.449.494Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M6.422 20.996c.907 0 3.167-.99 4.452-1.904.129-.099.234-.137.34-.137.099.016.197.016.295.016 5.45 0 9.063-3.1 9.063-6.864 0-3.802-3.81-6.87-8.572-6.87-4.762 0-8.571 3.068-8.571 6.87 0 2.427 1.489 4.55 3.915 5.843.114.06.151.174.091.295-.423.695-1.18 1.527-1.466 1.905-.295.378-.129.846.453.846Zm5.563-5.313c-.415 0-.642-.303-.642-.741V12.84h-2.23c-.438 0-.748-.235-.748-.643 0-.43.294-.665.748-.665h2.23V9.288c0-.438.226-.74.642-.74.424 0 .673.286.673.74v2.245h2.23c.46 0 .748.234.748.665 0 .408-.31.643-.748.643h-2.23v2.1c0 .454-.25.742-.673.742Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCommentAddFill };
var IconConstellationFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.766 6.87c.064-.24.404-.24.468 0l.315 1.17a2 2 0 0 0 1.411 1.41l1.17.316c.24.064.24.404 0 .468l-1.17.315a2 2 0 0 0-1.41 1.411l-.316 1.17c-.064.24-.404.24-.468 0l-.315-1.17a2 2 0 0 0-1.411-1.41l-1.17-.316c-.24-.064-.24-.404 0-.468l1.17-.315A2 2 0 0 0 9.45 8.04l.316-1.17ZM5.854 4.71c.04-.15.252-.15.292 0l.197.731c.116.43.452.767.882.882l.732.197c.15.04.15.253 0 .293l-.732.197a1.25 1.25 0 0 0-.882.882l-.197.731c-.04.15-.252.15-.292 0l-.197-.731a1.25 1.25 0 0 0-.882-.882l-.732-.197c-.15-.04-.15-.252 0-.293l.732-.197a1.25 1.25 0 0 0 .882-.882l.197-.73Zm2.725-1.884c.024-.09.151-.09.175 0l.119.439a.75.75 0 0 0 .529.53l.439.117c.09.024.09.152 0 .176l-.44.118a.75.75 0 0 0-.528.53l-.119.438c-.024.09-.151.09-.175 0l-.118-.439a.75.75 0 0 0-.53-.53l-.438-.117c-.09-.024-.09-.152 0-.176l.438-.118a.75.75 0 0 0 .53-.53l.118-.438Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.132 4.24a.137.137 0 0 0-.264 0l-.177.657c-.104.387-.407.69-.794.794l-.658.177a.137.137 0 0 0 0 .264l.658.177c.387.104.69.407.794.794l.177.658c.037.134.227.134.264 0l.177-.658c.104-.387.407-.69.794-.794l.658-.177a.137.137 0 0 0 0-.264l-.658-.177a1.125 1.125 0 0 1-.794-.794l-.177-.658ZM8.78 7.064c.06-.224.378-.224.438 0l.296 1.097c.174.645.678 1.15 1.323 1.323l1.097.296c.224.06.224.378 0 .438l-1.097.296a1.875 1.875 0 0 0-1.323 1.323l-.296 1.097c-.06.224-.378.224-.438 0l-.296-1.097a1.875 1.875 0 0 0-1.323-1.323l-1.097-.296c-.224-.06-.224-.378 0-.438l1.097-.296a1.875 1.875 0 0 0 1.323-1.323l.296-1.097Zm5.868 3.24c.097-.36.606-.36.702 0l.473 1.754a3 3 0 0 0 2.117 2.117l1.755.473c.359.097.359.606 0 .702l-1.755.473a3 3 0 0 0-2.117 2.117l-.473 1.755c-.097.359-.606.359-.702 0l-.473-1.755a3 3 0 0 0-2.117-2.117l-1.755-.473c-.359-.097-.359-.606 0-.702l1.755-.473a3 3 0 0 0 2.117-2.117l.473-1.755Z',
      fill: 'currentColor'
    }));
  }
});
export { IconConstellationFill };
var IconEditCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167Zm2.025 5.166.36-.36a.962.962 0 0 0-.678-1.64c-.257 0-.499.1-.68.281l-.36.36 1.358 1.36Zm-1.621-1L5.92 8.816a.482.482 0 0 0-.117.19l-.46 1.39a.206.206 0 0 0 .26.26l1.39-.46a.482.482 0 0 0 .19-.117l2.483-2.483-1.263-1.263Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM15.038 11l.54-.54a1.443 1.443 0 0 0 0-2.039A1.431 1.431 0 0 0 14.56 8c-.386 0-.748.15-1.02.421l-.54.541L15.038 11Zm-2.433-1.5-3.724 3.724a.723.723 0 0 0-.175.284l-.69 2.086a.309.309 0 0 0 .39.39l2.086-.69a.721.721 0 0 0 .284-.175l3.724-3.724L12.605 9.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEditCircleFill };
var IconEditFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm12.05 6.667.721-.722a1.924 1.924 0 0 0 0-2.717 1.908 1.908 0 0 0-1.358-.561c-.514 0-.997.2-1.359.562l-.72.72 2.716 2.718Zm-3.243-2L3.84 9.632a.965.965 0 0 0-.233.378l-.92 2.782a.412.412 0 0 0 .52.52l2.781-.92a.96.96 0 0 0 .379-.234l4.965-4.965-2.526-2.526Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.157 8.918 18.076 10 14 5.924l1.081-1.081A2.862 2.862 0 0 1 17.12 4c.771 0 1.494.299 2.038.842a2.886 2.886 0 0 1 0 4.076Zm-13.395 5.53L13.211 7 17 10.79l-7.448 7.447c-.159.16-.355.28-.568.35l-4.17 1.382a.622.622 0 0 1-.633-.15.618.618 0 0 1-.15-.631l1.381-4.173c.07-.212.191-.408.35-.567Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEditFill };
var IconEmojiFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M13.139 8A5.14 5.14 0 1 1 2.86 8a5.14 5.14 0 0 1 10.278 0Zm-2.523 1.786a.417.417 0 0 0-.654-.516A2.481 2.481 0 0 1 8 10.222a2.48 2.48 0 0 1-1.962-.952.416.416 0 1 0-.654.515A3.31 3.31 0 0 0 8 11.055a3.31 3.31 0 0 0 2.616-1.27Zm-4.283-3.87a.694.694 0 1 0 0 1.39.694.694 0 0 0 0-1.39Zm3.334 0a.694.694 0 1 0 0 1.39.694.694 0 0 0 0-1.39Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M19.708 12a7.708 7.708 0 1 1-15.416 0 7.708 7.708 0 0 1 15.416 0Zm-3.783 2.678a.625.625 0 0 0-.982-.773A3.722 3.722 0 0 1 12 15.333a3.721 3.721 0 0 1-2.943-1.428.624.624 0 1 0-.982.773A4.964 4.964 0 0 0 12 16.583a4.965 4.965 0 0 0 3.925-1.905ZM9.5 8.875a1.042 1.042 0 1 0 0 2.083 1.042 1.042 0 0 0 0-2.083Zm5 0a1.042 1.042 0 1 0 0 2.083 1.042 1.042 0 0 0 0-2.083Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEmojiFill };
var IconFolderCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm5.41-2.162a.792.792 0 0 0-.514-.171H5.847a.667.667 0 0 0-.666.666v3.334c0 .368.298.666.666.666h4.306a.667.667 0 0 0 .666-.666V7.832H5.181v-.5h5.638V7a.667.667 0 0 0-.666-.667H8.019l-.608-.495Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9Zm8.116-3.242a1.188 1.188 0 0 0-.772-.258H8.771a1 1 0 0 0-1 1v1.499h8.458V10.5a1 1 0 0 0-1-1h-3.2l-.913-.742ZM7.77 14.5v-2.751h8.458V14.5a1 1 0 0 1-1 1H8.771a1 1 0 0 1-1-1Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFolderCircleFill };
var IconFolderClosedFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.821 3.677c-.315-.262-.692-.344-1.029-.344H3.694c-.736 0-1.333.597-1.333 1.334v1.998H13.64V6c0-.737-.597-1.333-1.333-1.333H8.039l-1.218-.99Zm6.818 3.988H2.362v3.668c0 .737.596 1.334 1.332 1.334h8.612c.736 0 1.333-.597 1.333-1.334V7.665Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.688 5c.505 0 1.07.123 1.544.515L12.058 7h6.4a2 2 0 0 1 2 2v.997H3.542V7a2 2 0 0 1 2-2h3.146Zm11.77 6.497H3.542V17a2 2 0 0 0 2 2h12.916a2 2 0 0 0 2-2v-5.503Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFolderClosedFill };
var IconForwardFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.333 5.022a.778.778 0 0 1 1.28-.594l2.943 2.48V5.022a.778.778 0 0 1 1.279-.594l3.532 2.977a.778.778 0 0 1 0 1.19l-3.532 2.977a.778.778 0 0 1-1.28-.595V9.092l-2.943 2.48a.778.778 0 0 1-1.279-.595V5.022Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 7.534c0-.993 1.16-1.531 1.918-.892l4.415 3.72V7.535c0-.993 1.16-1.531 1.919-.892l5.299 4.465a1.167 1.167 0 0 1 0 1.785l-5.3 4.466c-.758.64-1.918.1-1.918-.892v-2.829l-4.413 3.72c-.76.64-1.919.1-1.919-.892V7.534Z',
      fill: 'currentColor'
    }));
  }
});
export { IconForwardFill };
var IconGroupFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.946 3.667c-.1 0-.193.044-.256.12l-.757.907h8.134l-.757-.908a.333.333 0 0 0-.256-.12H4.946Zm-1.28 8.055V5.694h8.667v6.028a.611.611 0 0 1-.61.611H4.277a.611.611 0 0 1-.611-.61Zm.255-8.576c.254-.304.63-.48 1.025-.48h6.108c.396 0 .771.176 1.024.48l.946 1.135c.2.24.31.542.31.854v6.587c0 .89-.722 1.611-1.612 1.611H4.278a1.61 1.61 0 0 1-1.611-1.61V5.134c0-.312.11-.614.308-.853l.946-1.136Zm2.746 3.66a.5.5 0 1 0 0 1h2.5a.5.5 0 0 0 0-1h-2.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.419 5.5a.5.5 0 0 0-.384.18L5.9 7.042h12.2L16.965 5.68a.5.5 0 0 0-.384-.18H7.42ZM5.5 17.583V8.542h13v9.041c0 .507-.41.917-.917.917H6.417a.917.917 0 0 1-.917-.917ZM5.882 4.72A2 2 0 0 1 7.42 4h9.162a2 2 0 0 1 1.537.72l1.419 1.702c.3.36.463.813.463 1.28v9.881A2.417 2.417 0 0 1 17.583 20H6.417A2.417 2.417 0 0 1 4 17.583v-9.88c0-.469.164-.921.463-1.28v-.001l1.42-1.703ZM10 10.21a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H10Z',
      fill: 'currentColor'
    }));
  }
});
export { IconGroupFill };
var IconInfoFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.167 8a5.833 5.833 0 1 1 11.666 0A5.833 5.833 0 0 1 2.167 8ZM8 6.638a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332Zm.5 1a.5.5 0 0 0-1 0v3.056a.5.5 0 0 0 1 0V7.64Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0ZM12 9.957a1 1 0 1 0 0-1.998 1 1 0 0 0 0 1.998Zm.75 1.5a.75.75 0 0 0-1.5 0v4.584a.75.75 0 0 0 1.5 0v-4.583Z',
      fill: 'currentColor'
    }));
  }
});
export { IconInfoFill };
var IconImageMapFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm-4.951 2A.667.667 0 0 0 6 5.333v4c0 .369.298.667.667.667h4a.667.667 0 0 0 .666-.667v-4a.667.667 0 0 0-.666-.666h-4Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM10 7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-6Z',
      fill: 'currentColor'
    }));
  }
});
export { IconImageMapFill };
var IconHeartFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.361 6.333A3.139 3.139 0 0 1 5.5 3.194c.99 0 1.817.476 2.5 1.31.683-.834 1.51-1.31 2.5-1.31a3.139 3.139 0 0 1 3.139 3.14c0 1.83-.84 3.337-1.929 4.462-1.084 1.12-2.44 1.89-3.552 2.262a.5.5 0 0 1-.316 0c-1.113-.371-2.468-1.142-3.552-2.262C3.202 9.67 2.36 8.163 2.36 6.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.542 9.5c0-2.6 2.108-4.708 4.708-4.708 1.485 0 2.725.713 3.75 1.965 1.025-1.252 2.265-1.965 3.75-1.965 2.6 0 4.708 2.108 4.708 4.708 0 2.745-1.26 5.006-2.893 6.693-1.626 1.682-3.66 2.837-5.328 3.393a.75.75 0 0 1-.474 0c-1.669-.556-3.702-1.711-5.328-3.393-1.632-1.687-2.893-3.948-2.893-6.693Z',
      fill: 'currentColor'
    }));
  }
});
export { IconHeartFill };
var IconKeyFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.76 3.333h6.48c.787 0 1.427.64 1.427 1.426v6.482c0 .786-.64 1.426-1.426 1.426H4.759c-.786 0-1.426-.64-1.426-1.426V4.759c0-.786.64-1.426 1.426-1.426Zm.822 6.522v-.469l-.221-.002A.693.693 0 1 1 5.363 8c.38 0 .692.314.692.694v.215h.47v-.215c0-.38.313-.694.693-.694.386 0 .696.314.696.694a.694.694 0 0 1-.694.69l-.224.002v.469h.224a.695.695 0 0 1 .694.69.695.695 0 0 1-1.388 0v-.216h-.47v.216a.694.694 0 1 1-1.388 0 .692.692 0 0 1 .693-.69h.221Zm-.436-1.159c0 .12.099.218.234.218h.2v-.2c0-.136-.101-.235-.217-.235a.214.214 0 0 0-.217.217ZM7 8.914h.2c.136 0 .235-.097.235-.218a.216.216 0 0 0-.217-.217c-.116 0-.218.1-.218.234v.2Zm-.945.47v.47h.469v-.47h-.469Zm-.475.941h-.2c-.135 0-.234.097-.234.218 0 .122.095.217.217.217.116 0 .217-.1.217-.234v-.2Zm1.855.218c0-.12-.1-.218-.234-.218H7v.2c0 .136.1.235.217.235.12 0 .217-.095.217-.217Zm1.908.24c0 .258-.142.403-.387.403-.244 0-.388-.145-.388-.403V8.452c0-.258.144-.403.388-.403.245 0 .387.145.387.403v.915h.016l1.037-1.148c.11-.122.206-.173.337-.173a.36.36 0 0 1 .365.357c0 .114-.04.198-.143.31l-.728.768.778.954c.127.156.18.272.18.38 0 .21-.16.373-.372.373-.162 0-.274-.06-.399-.22l-.789-.985-.282.296v.504Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.139 5h9.722C18.041 5 19 5.96 19 7.139v9.722c0 1.18-.96 2.139-2.139 2.139H7.14C5.959 19 5 18.04 5 16.861V7.14C5 5.959 5.96 5 7.139 5Zm1.235 9.782v-.703l-.333-.003A1.039 1.039 0 0 1 7 13.041C7 12.471 7.462 12 8.044 12c.57 0 1.039.472 1.039 1.041v.323h.705v-.323c0-.57.469-1.041 1.039-1.041.579 0 1.044.472 1.044 1.041a1.04 1.04 0 0 1-1.041 1.035l-.336.003v.703h.336a1.043 1.043 0 0 1 1.041 1.035 1.042 1.042 0 0 1-2.083.001v-.324h-.705v.323a1.04 1.04 0 1 1-2.083 0 1.04 1.04 0 0 1 1.041-1.035h.333Zm-.656-1.738c0 .18.15.326.352.326h.3v-.3c0-.203-.151-.351-.326-.351a.322.322 0 0 0-.326.325Zm2.783.326h.3c.203 0 .352-.145.352-.325a.324.324 0 0 0-.326-.326c-.175 0-.326.148-.326.35v.301Zm-1.418.706v.706h.702v-.706h-.702Zm-.713 1.412h-.3c-.203 0-.352.146-.352.326 0 .184.143.326.326.326.175 0 .326-.149.326-.351v-.301Zm2.783.326c0-.18-.15-.326-.352-.326h-.3v.3c0 .203.152.352.326.352.18 0 .326-.143.326-.326Zm2.86.36c0 .387-.211.605-.578.605s-.583-.218-.583-.604v-3.498c0-.386.216-.604.583-.604s.579.218.579.604v1.374h.025l1.554-1.722c.165-.183.31-.26.507-.26a.54.54 0 0 1 .547.535c0 .171-.06.298-.215.466l-1.092 1.152 1.168 1.43c.19.235.269.409.269.57 0 .317-.24.56-.557.56-.244 0-.411-.091-.598-.329l-1.184-1.478-.424.443v.757Z',
      fill: 'currentColor'
    }));
  }
});
export { IconKeyFill };
var IconLockFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.694 4.667a1.306 1.306 0 1 1 2.612 0V6H6.694V4.667ZM5.694 6V4.667a2.306 2.306 0 1 1 4.612 0V6h.389c.736 0 1.333.597 1.333 1.333V12c0 .736-.597 1.333-1.334 1.333H5.306A1.333 1.333 0 0 1 3.972 12V7.333C3.972 6.597 4.57 6 5.306 6h.388Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.042 7a1.958 1.958 0 1 1 3.916 0v2h-3.916V7Zm-1.5 2V7a3.458 3.458 0 1 1 6.916 0v2h.584a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7.958a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h.584Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLockFill };
var IconMinusCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167ZM5.5 7.5a.5.5 0 0 0 0 1V8v.5h5a.5.5 0 1 0 0-1H5.501L5.5 8v-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm-3.5 8a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMinusCircleFill };
var IconMenuFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3 4.667C3 4.298 3.344 4 3.77 4h8.46c.426 0 .77.298.77.667 0 .368-.344.666-.77.666H3.77c-.426 0-.77-.298-.77-.666ZM3 8c0-.368.344-.667.77-.667h8.46c.426 0 .77.299.77.667 0 .368-.344.667-.77.667H3.77C3.343 8.667 3 8.368 3 8Zm.77 2.667c-.426 0-.77.298-.77.666 0 .368.344.667.77.667h8.46c.426 0 .77-.299.77-.667 0-.368-.344-.666-.77-.666H3.77Z',
      fill: 'currentColor',
      fillOpacity: '.7'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M6 7a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H7Z',
      fill: 'currentColor',
      fillOpacity: '.7'
    }));
  }
});
export { IconMenuFill };
var IconPartialFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11 11.8c-.8.7-1.9 1.1-3 1.1-2.7 0-4.9-2.2-4.9-4.9 0-1.1.4-2.2 1.1-3l6.7 6.7c.1 0 .1.1.1.1zm.8-.8-.1-.1L5 4.2c.8-.7 1.9-1.1 3-1.1 2.7 0 4.9 2.2 4.9 4.9 0 1.2-.4 2.2-1.1 3zM14 8c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6 6 2.7 6 6z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.5 17.7c-1.2 1-2.8 1.6-4.5 1.6-4 0-7.2-3.2-7.2-7.2 0-1.7.6-3.3 1.6-4.5l10 10s0 .1.1.1zm1.1-1.1c0-.1-.1-.1-.1-.2l-10-10c1.2-1 2.8-1.6 4.5-1.6 4 0 7.2 3.2 7.2 7.2 0 1.8-.6 3.3-1.6 4.6zm3.3-4.5c0 4.9-4 8.9-8.9 8.9s-8.9-4-8.9-8.9 4-8.9 8.9-8.9 8.9 4 8.9 8.9z',
      fill: 'currentColor'
    }));
  }
});
export { IconPartialFill };
var IconPauseCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6.924 1.8a.6.6 0 1 0 1.2 0V6.2a.6.6 0 1 0-1.2 0v3.6Zm-3 0a.6.6 0 1 0 1.2 0V6.2a.6.6 0 1 0-1.2 0v3.6Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9Zm10.386 2.7a.9.9 0 1 0 1.8 0V9.3a.9.9 0 1 0-1.8 0v5.4Zm-4.5 0a.9.9 0 1 0 1.8 0V9.3a.9.9 0 1 0-1.8 0v5.4Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPauseCircleFill };
var IconPeopleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.406 7.41c.355.38.808.59 1.277.59.47 0 .923-.21 1.277-.59.344-.37.555-.864.593-1.391.04-.557-.132-1.073-.485-1.452a1.864 1.864 0 0 0-1.385-.582c-.547 0-1.038.203-1.388.58-.351.376-.522.892-.483 1.454a2.28 2.28 0 0 0 .594 1.391Zm-1.73 4.605h6.015a.631.631 0 0 0 .5-.242.691.691 0 0 0 .121-.588c-.19-.78-.667-1.424-1.377-1.86-.632-.39-1.411-.595-2.252-.595-.824 0-1.624.214-2.253.604-.708.438-1.184 1.078-1.376 1.85a.69.69 0 0 0 .12.588.632.632 0 0 0 .502.243ZM5.586 8c-.374 0-.737-.17-1.021-.476-.276-.3-.445-.7-.475-1.125-.031-.454.106-.871.386-1.175.28-.305.673-.469 1.11-.469.436 0 .83.167 1.109.47.282.307.42.724.388 1.174-.03.426-.2.825-.475 1.124-.283.308-.646.477-1.021.477Zm-.161 3.025a3.64 3.64 0 0 1 1.548-2.169 3.576 3.576 0 0 0-1.386-.266c-.66 0-1.3.173-1.802.488a2.428 2.428 0 0 0-1.101 1.494.562.562 0 0 0 .096.476.506.506 0 0 0 .401.197h2.207c.006-.074.018-.148.037-.22Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.608 11.116c.533.57 1.213.884 1.917.884s1.383-.314 1.915-.885a3.428 3.428 0 0 0 .89-2.087c.059-.835-.199-1.609-.728-2.177-.524-.564-1.262-.874-2.077-.874-.822 0-1.557.305-2.083.87-.526.564-.783 1.339-.723 2.181.055.79.372 1.532.89 2.088Zm-2.594 6.907h9.022a.946.946 0 0 0 .75-.364 1.035 1.035 0 0 0 .183-.882c-.287-1.17-1.002-2.136-2.067-2.79-.948-.584-2.116-.892-3.377-.892-1.237 0-2.437.322-3.38.905-1.062.659-1.776 1.618-2.064 2.775a1.034 1.034 0 0 0 .18.883.948.948 0 0 0 .753.365ZM8.38 12c-.562 0-1.107-.254-1.533-.715A2.776 2.776 0 0 1 6.136 9.6c-.048-.681.158-1.307.578-1.764.421-.456 1.01-.702 1.666-.702.653 0 1.243.25 1.662.706.424.46.63 1.084.582 1.76a2.785 2.785 0 0 1-.712 1.686c-.425.461-.969.715-1.532.715Zm-.243 4.537c.337-1.349 1.15-2.472 2.322-3.253a5.364 5.364 0 0 0-2.079-.4c-.989 0-1.949.26-2.703.733-.85.531-1.42 1.307-1.651 2.242a.844.844 0 0 0 .144.713.76.76 0 0 0 .602.295h3.31c.01-.111.028-.221.055-.33Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPeopleFill };
var IconPauseFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.579 4.439c0-.61.495-1.106 1.105-1.106h1.228c.61 0 1.106.495 1.106 1.106v7.122c0 .61-.495 1.106-1.106 1.106H4.684c-.61 0-1.105-.495-1.105-1.106V4.44Zm6.509-1.106c-.61 0-1.105.495-1.105 1.106v7.122c0 .61.494 1.106 1.105 1.106h1.228c.61 0 1.105-.495 1.105-1.106V4.44c0-.61-.495-1.106-1.105-1.106h-1.228Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.368 6.658C5.368 5.742 6.111 5 7.026 5h1.842c.916 0 1.658.742 1.658 1.658v10.684c0 .916-.742 1.658-1.658 1.658H7.026a1.658 1.658 0 0 1-1.658-1.658V6.658ZM15.132 5c-.916 0-1.658.742-1.658 1.658v10.684c0 .916.742 1.658 1.658 1.658h1.842c.915 0 1.658-.742 1.658-1.658V6.658c0-.916-.743-1.658-1.658-1.658h-1.842Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPauseFill };
var IconPersonCircleAddFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.248 6.816a5.833 5.833 0 1 1 3.732 6.85c.274-.242.514-.52.713-.827a4.81 4.81 0 0 0 1.232.159 4.818 4.818 0 0 0 3.38-1.378 3.676 3.676 0 0 0-.866-.732c-.721-.444-1.594-.669-2.514-.669-.206 0-.41.013-.613.036a3.975 3.975 0 0 0-.26-1.064c.27.135.566.21.873.21.572 0 1.103-.257 1.501-.685.388-.416.619-.965.66-1.542.045-.62-.147-1.22-.564-1.667a2.157 2.157 0 0 0-1.597-.678c-.614 0-1.187.23-1.6.675-.417.446-.607 1.046-.563 1.67.009.119.025.237.05.353a4.003 4.003 0 0 0-3.564-.711Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.333 14a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Zm0-5.5a.5.5 0 0 1 .5.5v1.167H5a.5.5 0 1 1 0 1H3.833v1.166a.5.5 0 1 1-1 0v-1.166H1.667a.5.5 0 0 1 0-1h1.166V9a.5.5 0 0 1 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 10c-.564 0-1.11.078-1.628.223A8.75 8.75 0 1 1 8.97 20.498c.41-.362.77-.779 1.069-1.24.59.156 1.21.238 1.848.238a7.226 7.226 0 0 0 5.07-2.066 5.522 5.522 0 0 0-1.299-1.098c-1.082-.666-2.39-1.003-3.77-1.003a7.82 7.82 0 0 0-.92.054 5.96 5.96 0 0 0-.586-2.038 2.74 2.74 0 0 0 1.54.483c.791 0 1.527-.354 2.078-.947a3.507 3.507 0 0 0 .914-2.135c.061-.86-.204-1.689-.78-2.309-.57-.612-1.364-.937-2.213-.937-.85 0-1.642.318-2.215.934-.576.618-.84 1.448-.778 2.311.02.3.08.593.172.874A5.98 5.98 0 0 0 5 10Zm5 6a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-4.25-2.5a.75.75 0 0 0-1.5 0v1.75H2.5a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75H7.5a.75.75 0 0 0 0-1.5H5.75V13.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonCircleAddFill };
var IconPersonCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.091 8.164a5.833 5.833 0 1 1 11.667 0 5.833 5.833 0 0 1-11.667 0Zm5.834 4.834a4.818 4.818 0 0 0 3.38-1.378 3.678 3.678 0 0 0-.866-.732c-.721-.444-1.594-.669-2.514-.669-.907 0-1.8.235-2.516.679a3.725 3.725 0 0 0-.859.726 4.817 4.817 0 0 0 3.375 1.373ZM7.948 5a1.99 1.99 0 0 0-1.478.623c-.383.412-.559.965-.518 1.54.037.533.251 1.04.61 1.425.367.394.858.63 1.386.63.527 0 1.018-.236 1.385-.63.358-.385.571-.891.61-1.424a2.022 2.022 0 0 0-.52-1.54A1.99 1.99 0 0 0 7.947 5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.137 12.246a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm8.75 7.25a7.226 7.226 0 0 0 5.07-2.066 5.52 5.52 0 0 0-1.299-1.098c-1.082-.666-2.39-1.003-3.77-1.003-1.36 0-2.7.353-3.775 1.018-.493.305-.925.67-1.288 1.09a7.226 7.226 0 0 0 5.062 2.06ZM11.921 7.5c-.85 0-1.642.318-2.215.934-.576.618-.84 1.448-.778 2.311.056.8.376 1.56.914 2.137.552.59 1.288.946 2.08.946.791 0 1.527-.354 2.078-.947a3.507 3.507 0 0 0 .914-2.135c.061-.86-.204-1.689-.78-2.309-.57-.612-1.364-.937-2.213-.937Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonCircleFill };
var IconPlayCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm4.442 2.288a.45.45 0 0 0 .442.014L10.5 8.398a.448.448 0 0 0 0-.796L6.884 5.699a.45.45 0 0 0-.66.398v3.806c0 .16.082.303.218.385Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9Zm6.663 3.433a.674.674 0 0 0 .663.02l5.423-2.855A.672.672 0 0 0 16.11 12a.671.671 0 0 0-.36-.597l-5.424-2.855a.674.674 0 0 0-.99.597v5.71a.67.67 0 0 0 .327.578Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPlayCircleFill };
var IconPersonFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 7.682c-.469 0-.922-.21-1.277-.59a2.28 2.28 0 0 1-.594-1.391c-.04-.562.132-1.078.483-1.455.35-.376.84-.58 1.388-.58.544 0 1.035.207 1.385.583.353.38.525.895.485 1.452a2.285 2.285 0 0 1-.593 1.391c-.354.38-.808.59-1.277.59Zm3.008 4.658H4.993a.632.632 0 0 1-.502-.243.69.69 0 0 1-.12-.588c.192-.772.668-1.411 1.376-1.85.629-.39 1.429-.604 2.253-.604.84 0 1.62.206 2.252.595.71.436 1.186 1.08 1.377 1.86a.69.69 0 0 1-.12.588.632.632 0 0 1-.501.242Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M9.099 8.237c-.06-.833.195-1.667.783-2.298.583-.626 1.383-.939 2.21-.939.831 0 1.63.32 2.208.942.588.63.845 1.463.785 2.296a3.382 3.382 0 0 1-.884 2.06c-.539.578-1.283.949-2.109.949-.826 0-1.57-.372-2.107-.948l-.001-.001a3.374 3.374 0 0 1-.885-2.06Zm-2.954 10.37L6.14 18.6a1.785 1.785 0 0 1-.31-1.52c.337-1.356 1.177-2.474 2.396-3.23C9.3 13.186 10.64 12.834 12 12.834c1.38 0 2.69.337 3.77 1.002 1.226.754 2.066 1.88 2.402 3.25a1.787 1.787 0 0 1-.314 1.518l-.005.006c-.16.204-.364.37-.597.482-.263.127-.528.16-.746.159H7.49a1.684 1.684 0 0 1-.748-.16 1.698 1.698 0 0 1-.598-.483Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonFill };
var IconPlayFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.984 4.576c0-.943 1.013-1.54 1.838-1.083l6.18 3.424a1.238 1.238 0 0 1 0 2.166l-6.18 3.424a1.238 1.238 0 0 1-1.838-1.083V4.576Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.976 6.864c0-1.415 1.52-2.31 2.757-1.624l9.27 5.136c1.276.707 1.276 2.541 0 3.248l-9.27 5.136c-1.237.686-2.757-.209-2.757-1.624V6.864Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPlayFill };
var IconProjectFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.002 4.5h3.316L4.146 2.01c-.47.02-.788.07-1.054.206a2 2 0 0 0-.874.874c-.167.328-.207.734-.216 1.41ZM2 4.767v.43l-.002 5.604c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.875c.427.218.988.218 2.108.218H10.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .875-.875c.218-.427.217-.988.217-2.108V6H2V4.767ZM13.996 4.5c-.01-.676-.048-1.082-.216-1.41a2 2 0 0 0-.874-.874c-.427-.218-.987-.218-2.107-.218h-.5L11.476 4.5h2.52ZM8.64 1.998H5.799L6.976 4.5h2.842L8.641 1.998Zm1.18 7.926a.5.5 0 0 0 0-.848L7.266 7.478a.5.5 0 0 0-.765.424v3.196a.5.5 0 0 0 .765.424l2.557-1.598Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.052 7.25 14.731 4h.465c1.68 0 2.52 0 3.161.327a3 3 0 0 1 1.311 1.31c.207.405.283.89.311 1.613h-2.927Zm-1.843 0L12.887 4H8.731l2.321 3.25h4.157Zm-6 0L6.912 4.035c-.541.038-.934.12-1.272.292a3 3 0 0 0-1.311 1.31c-.207.405-.283.89-.311 1.613h5.19ZM4 8.799V8.75h15.995v.049l.001 6.4c0 1.68.001 2.52-.326 3.162a3 3 0 0 1-1.311 1.312c-.642.327-1.482.327-3.163.327H8.8c-1.68 0-2.521 0-3.163-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.483-.326-3.163v-6.4Zm10.016 4.094a1 1 0 0 1 0 1.714l-2.599 1.564a1 1 0 0 1-1.516-.857v-3.128a1 1 0 0 1 1.516-.857l2.6 1.564Z',
      fill: 'currentColor'
    }));
  }
});
export { IconProjectFill };
var IconRectangleAngledFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.116 5.514a1.633 1.633 0 0 1 1.154-2l5.216-1.398a1.633 1.633 0 0 1 2 1.154l.107.397H6.3A2.633 2.633 0 0 0 3.667 6.3v4.83a1.583 1.583 0 0 1-.14-.35L2.116 5.514ZM6.3 4.667h5.4c.902 0 1.633.73 1.633 1.633v5.4c0 .902-.73 1.633-1.633 1.633H6.3A1.634 1.634 0 0 1 4.667 11.7V6.3A1.63 1.63 0 0 1 6.3 4.667Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.173 8.27a2.45 2.45 0 0 1 1.733-3l7.824-2.097a2.45 2.45 0 0 1 3 1.733l.16.594H9.45A3.95 3.95 0 0 0 5.5 9.45v7.245a2.377 2.377 0 0 1-.21-.524l-2.117-7.9ZM9.45 7h8.1A2.45 2.45 0 0 1 20 9.45v8.1A2.45 2.45 0 0 1 17.55 20h-8.1A2.45 2.45 0 0 1 7 17.55v-8.1A2.448 2.448 0 0 1 9.45 7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconRectangleAngledFill };
var IconRewindFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.644 5.022a.778.778 0 0 0-1.28-.594l-2.942 2.48V5.022a.778.778 0 0 0-1.28-.594L3.61 7.405a.778.778 0 0 0 0 1.19l3.533 2.977a.778.778 0 0 0 1.279-.595V9.092l2.943 2.48a.778.778 0 0 0 1.279-.595V5.022Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.966 7.534c0-.993-1.16-1.531-1.919-.892l-4.415 3.72V7.535c0-.993-1.16-1.531-1.918-.892l-5.3 4.465a1.167 1.167 0 0 0 0 1.785l5.3 4.466c.758.64 1.918.1 1.918-.892v-2.829l4.415 3.721c.759.64 1.919.1 1.919-.892V7.534Z',
      fill: 'currentColor'
    }));
  }
});
export { IconRewindFill };
var IconSentFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.41 6.359a.374.374 0 0 0-.032.696l3.47 1.533a.374.374 0 0 0 .37-.039l3.06-2.205c.033-.024.054-.024.066-.023a.11.11 0 0 1 .062.034.11.11 0 0 1 .033.061c.002.012.002.034-.023.067l-2.205 3.06a.374.374 0 0 0-.039.37l1.533 3.47a.374.374 0 0 0 .696-.033l3.26-9.777a.374.374 0 0 0-.473-.473L2.41 6.359Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.616 9.538a.56.56 0 0 0-.05 1.045l5.206 2.3a.56.56 0 0 0 .554-.059l4.59-3.308c.05-.036.082-.036.1-.034a.165.165 0 0 1 .093.05.166.166 0 0 1 .05.093c.002.018.002.05-.035.1l-3.308 4.59a.56.56 0 0 0-.058.553l2.3 5.206a.56.56 0 0 0 1.044-.049l4.889-14.666a.56.56 0 0 0-.71-.71L3.617 9.54Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSentFill };
var IconShieldExclamationmarkFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.334 1.934a.5.5 0 0 0-.668 0l-.003.002-.015.013-.064.054a8.813 8.813 0 0 1-1.245.837c-.838.464-1.967.91-3.2.91a.5.5 0 0 0-.5.5v3.405c0 .938.199 2.179.957 3.42.761 1.245 2.063 2.454 4.21 3.358a.5.5 0 0 0 .388 0c2.147-.904 3.449-2.114 4.21-3.358a6.532 6.532 0 0 0 .957-3.42V4.25a.5.5 0 0 0-.5-.5c-1.232 0-2.362-.446-3.2-.91a8.813 8.813 0 0 1-1.245-.837 3.928 3.928 0 0 1-.064-.054l-.015-.013-.003-.002ZM8 6.638a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332Zm.5 1a.5.5 0 0 0-1 0v3.056a.5.5 0 0 0 1 0V7.64Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.501 2.9a.751.751 0 0 0-1.002 0l-.004.004-.022.02-.098.081c-.088.073-.22.179-.393.307-.346.258-.85.603-1.474.949-1.256.695-2.95 1.364-4.8 1.364a.75.75 0 0 0-.75.75v5.108c0 1.407.299 3.268 1.436 5.129 1.142 1.867 3.095 3.681 6.315 5.038a.75.75 0 0 0 .582 0c3.22-1.357 5.174-3.17 6.315-5.038a9.799 9.799 0 0 0 1.436-5.13V6.376a.75.75 0 0 0-.75-.75c-1.85 0-3.544-.67-4.8-1.364a13.211 13.211 0 0 1-1.474-.949 9.965 9.965 0 0 1-.49-.389l-.023-.02-.004-.002ZM12 9.958a1 1 0 1 0 0-1.998 1 1 0 0 0 0 1.998Zm.75 1.5a.75.75 0 1 0-1.5 0v4.584a.75.75 0 0 0 1.5 0v-4.583Z',
      fill: 'currentColor'
    }));
  }
});
export { IconShieldExclamationmarkFill };
var IconSplitviewFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 5.167a.5.5 0 1 0-1 0v5.666a.5.5 0 0 0 1 0V5.167ZM2 6.333a1 1 0 0 1 1-1h2.333a1 1 0 0 1 1 1v3.334a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6.333Zm7.667 0a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1v3.334a1 1 0 0 1-1 1h-2.333a1 1 0 0 1-1-1V6.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 7.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5ZM3 9.5A1.5 1.5 0 0 1 4.5 8H8a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 8 16H4.5A1.5 1.5 0 0 1 3 14.5v-5Zm11.5 0A1.5 1.5 0 0 1 16 8h3.5A1.5 1.5 0 0 1 21 9.5v5a1.5 1.5 0 0 1-1.5 1.5H16a1.5 1.5 0 0 1-1.5-1.5v-5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSplitviewFill };
var IconSsoSettingsFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.334 1.934a.5.5 0 0 0-.668 0l-.003.002-.015.013-.064.054a8.813 8.813 0 0 1-1.245.837c-.838.464-1.967.91-3.2.91a.5.5 0 0 0-.5.5v3.405c0 .938.199 2.179.957 3.42.761 1.245 2.063 2.454 4.21 3.358a.5.5 0 0 0 .388 0c2.147-.904 3.449-2.114 4.21-3.358a6.532 6.532 0 0 0 .957-3.42V4.25a.5.5 0 0 0-.5-.5c-1.232 0-2.362-.446-3.2-.91a8.813 8.813 0 0 1-1.245-.837 3.928 3.928 0 0 1-.064-.054l-.015-.013-.003-.002Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.501 2.9a.75.75 0 0 0-1.002 0l-.004.004-.022.02a10.041 10.041 0 0 1-.49.39c-.347.256-.851.601-1.475.947-1.256.695-2.95 1.364-4.8 1.364a.75.75 0 0 0-.75.75v5.108c0 1.407.299 3.268 1.436 5.129 1.142 1.867 3.095 3.681 6.315 5.038a.75.75 0 0 0 .582 0c3.22-1.357 5.174-3.17 6.315-5.038a9.799 9.799 0 0 0 1.436-5.13V6.376a.75.75 0 0 0-.75-.75c-1.85 0-3.544-.67-4.8-1.364a13.224 13.224 0 0 1-1.474-.949 10.119 10.119 0 0 1-.49-.389l-.023-.02-.004-.002Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSsoSettingsFill };
var IconStarFantasyFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.649 3.304c.096-.359.606-.359.702 0l.473 1.755a3 3 0 0 0 2.117 2.117l1.755.473c.359.096.359.606 0 .702l-1.755.473a3 3 0 0 0-2.117 2.117l-.473 1.755c-.096.359-.606.359-.702 0l-.473-1.755A3 3 0 0 0 5.06 8.824L3.304 8.35c-.359-.096-.359-.606 0-.702l1.755-.473A3 3 0 0 0 7.176 5.06l.473-1.755Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.473 4.956c.145-.538.909-.538 1.054 0l.783 2.911a4 4 0 0 0 2.823 2.823l2.91.783c.539.145.539.909 0 1.054l-2.91.783a4 4 0 0 0-2.823 2.823l-.783 2.91c-.145.539-.909.539-1.054 0l-.783-2.91a4 4 0 0 0-2.823-2.823l-2.91-.783c-.539-.145-.539-.909 0-1.054l2.91-.783a4 4 0 0 0 2.823-2.823l.783-2.91Z',
      fill: 'currentColor'
    }));
  }
});
export { IconStarFantasyFill };
var IconStarFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.373 2.953a.417.417 0 0 0-.746 0L6.196 5.815l-3.398.523a.417.417 0 0 0-.231.707l2.35 2.35-.523 3.403a.417.417 0 0 0 .604.432L8 11.664l3.002 1.566a.416.416 0 0 0 .604-.432l-.523-3.403 2.35-2.35a.416.416 0 0 0-.23-.707l-3.399-.523-1.431-2.862Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.559 4.429a.625.625 0 0 0-1.118 0L9.294 8.723l-5.097.784a.625.625 0 0 0-.347 1.06l3.526 3.526-.785 5.104a.625.625 0 0 0 .906.649L12 17.496l4.503 2.35a.625.625 0 0 0 .906-.65l-.785-5.103 3.526-3.526a.625.625 0 0 0-.347-1.06l-5.097-.784L12.56 4.43Z',
      fill: 'currentColor'
    }));
  }
});
export { IconStarFill };
var IconStopCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm3.924 1.35c0 .413.337.75.75.75h2.7a.75.75 0 0 0 .75-.75v-2.7a.75.75 0 0 0-.75-.75h-2.7a.75.75 0 0 0-.75.75v2.7Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9Zm5.886 2.025c0 .62.505 1.125 1.125 1.125h4.05c.621 0 1.125-.505 1.125-1.125v-4.05c0-.62-.504-1.125-1.125-1.125h-4.05c-.62 0-1.125.505-1.125 1.125v4.05Z',
      fill: 'currentColor'
    }));
  }
});
export { IconStopCircleFill };
var IconSwitchFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('g', {
      clipPath: 'url(#a)'
    }, /*#__PURE__*/React.createElement('path', {
      d: 'M10.742 4.788H5.258C3.46 4.788 2 6.228 2 8c0 1.771 1.461 3.212 3.258 3.212h5.484C12.54 11.212 14 9.772 14 8c0-1.771-1.461-3.212-3.258-3.212Zm0 5.621C9.395 10.41 8.3 9.33 8.3 8c0-1.328 1.096-2.41 2.443-2.41S13.186 6.673 13.186 8s-1.097 2.41-2.444 2.41Z',
      fill: 'currentColor'
    })), /*#__PURE__*/React.createElement('defs', {}, /*#__PURE__*/React.createElement('clipPath', {
      id: 'a'
    }, /*#__PURE__*/React.createElement('path', {
      fill: 'currentColor',
      transform: 'translate(2 2)',
      d: 'M0 0h12v12H0z'
    }))));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M16.114 7.182H7.886C5.192 7.182 3 9.343 3 12c0 2.657 2.192 4.818 4.886 4.818h8.228C18.808 16.818 21 14.657 21 12c0-2.657-2.192-4.818-4.886-4.818Zm0 8.432c-2.02 0-3.665-1.622-3.665-3.614 0-1.992 1.644-3.614 3.665-3.614 2.02 0 3.664 1.622 3.664 3.614 0 1.992-1.644 3.614-3.664 3.614Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSwitchFill };
var IconTextAlignCenterFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.167 2H3.833C2.823 2 2 2.823 2 3.833v8.334C2 13.177 2.823 14 3.833 14h8.334c1.01 0 1.833-.823 1.833-1.833V3.833C14 2.823 13.177 2 12.167 2ZM5.833 5.333h4.334a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1 0-1Zm4.334 5.334H5.833a.5.5 0 0 1 0-1h4.334a.5.5 0 0 1 0 1Zm1-2.167H4.833a.5.5 0 0 1 0-1h6.334a.5.5 0 0 1 0 1Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M18.25 3H5.75A2.754 2.754 0 0 0 3 5.75v12.5A2.754 2.754 0 0 0 5.75 21h12.5A2.754 2.754 0 0 0 21 18.25V5.75A2.754 2.754 0 0 0 18.25 3Zm-9.5 5h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5Zm6.5 8h-6.5a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5Zm1.5-3.25h-9.5a.75.75 0 0 1 0-1.5h9.5a.75.75 0 0 1 0 1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTextAlignCenterFill };
var IconTextAlignLeftFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.167 2H3.833C2.823 2 2 2.823 2 3.833v8.334C2 13.177 2.823 14 3.833 14h8.334c1.01 0 1.833-.823 1.833-1.833V3.833C14 2.823 13.177 2 12.167 2Zm-3 8.833H4.833a.5.5 0 0 1 0-1h4.334a.5.5 0 0 1 0 1Zm2-2.333H4.833a.5.5 0 0 1 0-1h6.334a.5.5 0 0 1 0 1ZM4.333 5.667a.5.5 0 0 1 .5-.5h4.334a.5.5 0 0 1 0 1H4.833a.5.5 0 0 1-.5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M18.25 3H5.75A2.754 2.754 0 0 0 3 5.75v12.5A2.754 2.754 0 0 0 5.75 21h12.5A2.754 2.754 0 0 0 21 18.25V5.75A2.754 2.754 0 0 0 18.25 3Zm-4.5 13.25h-6.5a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5Zm3-3.5h-9.5a.75.75 0 0 1 0-1.5h9.5a.75.75 0 0 1 0 1.5ZM6.5 8.5a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTextAlignLeftFill };
var IconTextAlignRightFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3.833 2h8.334C13.177 2 14 2.823 14 3.833v8.334c0 1.01-.823 1.833-1.833 1.833H3.833A1.836 1.836 0 0 1 2 12.167V3.833C2 2.823 2.823 2 3.833 2Zm3 8.833h4.334a.5.5 0 0 0 0-1H6.833a.5.5 0 0 0 0 1Zm-2-2.333h6.334a.5.5 0 0 0 0-1H4.833a.5.5 0 0 0 0 1Zm6.834-2.833a.5.5 0 0 0-.5-.5H6.833a.5.5 0 0 0 0 1h4.334a.5.5 0 0 0 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M5.75 3h12.5A2.754 2.754 0 0 1 21 5.75v12.5A2.754 2.754 0 0 1 18.25 21H5.75A2.754 2.754 0 0 1 3 18.25V5.75A2.754 2.754 0 0 1 5.75 3Zm4.5 13.25h6.5a.75.75 0 0 0 0-1.5h-6.5a.75.75 0 0 0 0 1.5Zm-3-3.5h9.5a.75.75 0 0 0 0-1.5h-9.5a.75.75 0 0 0 0 1.5ZM17.5 8.5a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 .75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTextAlignRightFill };
var IconThemeDarkFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8.232 12.667A4.672 4.672 0 0 1 3.565 8a4.672 4.672 0 0 1 4.667-4.667c.091 0 .18.006.27.013l.046.003a.35.35 0 0 1 .294.496 4.072 4.072 0 0 0 3.27 5.765.35.35 0 0 1 .276.506 4.648 4.648 0 0 1-4.156 2.55Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.348 19c-3.86 0-7-3.14-7-7s3.14-7 7-7c.137 0 .27.01.404.019l.07.004a.525.525 0 0 1 .441.744 6.077 6.077 0 0 0-.565 2.558 6.108 6.108 0 0 0 5.471 6.089.526.526 0 0 1 .413.76A6.972 6.972 0 0 1 12.348 19Z',
      fill: 'currentColor'
    }));
  }
});
export { IconThemeDarkFill };
var IconThemeLightFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M7.993 2a.45.45 0 0 0-.442.456v.899a.45.45 0 1 0 .899 0v-.9A.45.45 0 0 0 7.993 2ZM4.075 3.626a.45.45 0 0 0-.313.772l.635.636a.45.45 0 1 0 .637-.637l-.636-.635a.45.45 0 0 0-.323-.136Zm7.836 0a.45.45 0 0 0-.309.136l-.636.635a.45.45 0 1 0 .637.637l.635-.636a.45.45 0 0 0-.327-.772ZM8 4.703a3.296 3.296 0 1 0 0 6.593 3.296 3.296 0 0 0 0-6.593ZM2.456 7.55a.45.45 0 1 0 0 .9h.899a.45.45 0 1 0 0-.9h-.899Zm10.19 0a.45.45 0 1 0 0 .9h.898a.45.45 0 1 0 0-.9h-.899Zm-7.94 3.28a.45.45 0 0 0-.309.136l-.635.636a.449.449 0 0 0 .49.734.451.451 0 0 0 .146-.098l.636-.635a.45.45 0 0 0-.328-.772Zm6.574 0a.45.45 0 0 0-.314.773l.636.635a.45.45 0 0 0 .636-.636l-.635-.636a.45.45 0 0 0-.323-.135Zm-3.287 1.36a.45.45 0 0 0-.442.456v.899a.45.45 0 1 0 .899 0v-.899a.45.45 0 0 0-.457-.456Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M11.99 3a.674.674 0 0 0-.664.684v1.348a.676.676 0 0 0 1.154.483.675.675 0 0 0 .194-.483V3.684A.674.674 0 0 0 11.99 3ZM6.111 5.439a.674.674 0 0 0-.47 1.158l.954.953a.675.675 0 1 0 .954-.954l-.953-.953a.674.674 0 0 0-.485-.204Zm11.755 0a.675.675 0 0 0-.464.204l-.953.953a.675.675 0 1 0 .954.954l.953-.953a.675.675 0 0 0-.49-1.158ZM12 7.055a4.945 4.945 0 1 0 0 9.89 4.945 4.945 0 0 0 0-9.89Zm-8.316 4.27A.676.676 0 0 0 3.2 12.48a.675.675 0 0 0 .483.194h1.348a.676.676 0 0 0 .483-1.154.675.675 0 0 0-.483-.194H3.684Zm15.284 0a.676.676 0 0 0-.483 1.155.674.674 0 0 0 .483.194h1.348a.676.676 0 0 0 .483-1.154.674.674 0 0 0-.483-.194h-1.348ZM7.06 16.246a.674.674 0 0 0-.464.204l-.953.954a.676.676 0 0 0 .954.954l.953-.953a.674.674 0 0 0-.49-1.158Zm9.86 0a.674.674 0 0 0-.47 1.159l.953.953a.678.678 0 0 0 .954 0 .678.678 0 0 0 0-.954l-.953-.953a.676.676 0 0 0-.485-.204Zm-4.93 2.039a.674.674 0 0 0-.664.684v1.348a.676.676 0 0 0 1.154.483.674.674 0 0 0 .194-.483v-1.348a.674.674 0 0 0-.684-.684Z',
      fill: 'currentColor'
    }));
  }
});
export { IconThemeLightFill };
var IconTrashFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.972 3.556a2.028 2.028 0 1 1 4.056 0v.11h2.805a.5.5 0 1 1 0 1h-.456l-.727 7.211v.001a1.61 1.61 0 0 1-1.603 1.455H5.953a1.61 1.61 0 0 1-1.603-1.455l-.727-7.211h-.456a.5.5 0 1 1 0-1h2.805v-.111Zm3.056 0v.11H6.972v-.11a1.028 1.028 0 1 1 2.056 0Zm-2 2.61a.5.5 0 0 1 .5.5v4.167a.5.5 0 1 1-1 0V6.667a.5.5 0 0 1 .5-.5Zm1.944 0a.5.5 0 0 1 .5.5v4.167a.5.5 0 1 1-1 0V6.667a.5.5 0 0 1 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.958 5.333a3.041 3.041 0 1 1 6.084 0V5.5h4.208a.75.75 0 0 1 0 1.5h-.684l-1.09 10.816v.001A2.416 2.416 0 0 1 15.07 20H8.93a2.417 2.417 0 0 1-2.406-2.183v-.001L5.434 7H4.75a.75.75 0 0 1 0-1.5h4.208v-.167Zm4.584 0V5.5h-3.084v-.167a1.541 1.541 0 1 1 3.084 0Zm-3 3.917a.75.75 0 0 1 .75.75v6.25a.75.75 0 0 1-1.5 0V10a.75.75 0 0 1 .75-.75Zm2.916 0a.75.75 0 0 1 .75.75v6.25a.75.75 0 1 1-1.5 0V10a.75.75 0 0 1 .75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTrashFill };
var IconTvFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.428 11.333H3.572c-.866 0-1.571-.68-1.571-1.517V4.851c0-.837.705-1.518 1.571-1.518h8.857c.867 0 1.572.68 1.572 1.518v4.965c0 .837-.705 1.517-1.572 1.517Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M5.639 12.833h4.722',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.357 17h13.286c1.3 0 2.357-1.02 2.357-2.276V7.276C21 6.02 19.943 5 18.643 5H5.357C4.057 5 3 6.02 3 7.276v7.448C3 15.98 4.057 17 5.357 17Zm3.101 1.5a.75.75 0 0 0 0 1.5h7.084a.75.75 0 0 0 0-1.5H8.458Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTvFill };
var IconUnlockFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.694 4.667a1.306 1.306 0 1 1 2.612 0 .5.5 0 0 0 1 0 2.306 2.306 0 1 0-4.612 0V6h-.388c-.737 0-1.334.597-1.334 1.333V12c0 .736.597 1.333 1.334 1.333h5.388c.737 0 1.334-.597 1.334-1.333V7.333c0-.736-.597-1.333-1.334-1.333h-4V4.667Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.042 7a1.958 1.958 0 1 1 3.916 0 .75.75 0 0 0 1.5 0 3.458 3.458 0 1 0-6.916 0v2h-.584a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8.084a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-6V7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconUnlockFill };
var IconVolumeHighFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.336 3.919 6.697 5.28a3.833 3.833 0 0 1-2.45.886h-.914A.333.333 0 0 0 3 6.5v3c0 .184.15.333.333.333h.914c.895 0 1.762.313 2.45.886l1.64 1.362V3.92Zm-.29-1.059a.778.778 0 0 1 1.29.585v9.11a.778.778 0 0 1-1.29.585l-1.988-1.652a2.833 2.833 0 0 0-1.811-.655h-.914A1.333 1.333 0 0 1 2 9.5v-3c0-.736.597-1.333 1.333-1.333h.914a2.83 2.83 0 0 0 1.81-.655L8.046 2.86Zm4.278 1.691a.5.5 0 0 1 .692.145C13.636 5.646 14 6.78 14 8c0 1.22-.364 2.354-.984 3.304a.5.5 0 0 1-.837-.547A5.024 5.024 0 0 0 13 8a5.024 5.024 0 0 0-.821-2.757.5.5 0 0 1 .145-.692Zm-.793 1.555a.5.5 0 1 0-.89.454 3.298 3.298 0 0 1 0 3.004.5.5 0 1 0 .89.453 4.298 4.298 0 0 0 0-3.91Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm12.504 5.878-2.458 2.044A5.75 5.75 0 0 1 6.37 9.25H5a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 .5.5h1.37a5.75 5.75 0 0 1 3.676 1.328l2.458 2.044V5.878Zm-.436-1.587c.75-.66 1.936-.13 1.936.877v13.665c0 1.006-1.186 1.537-1.936.876l-2.981-2.477a4.25 4.25 0 0 0-2.717-.982H5a2 2 0 0 1-2-2v-4.5a2 2 0 0 1 2-2h1.37a4.25 4.25 0 0 0 2.717-.982l2.981-2.477Zm6.418 2.536a.75.75 0 0 1 1.038.218A9.035 9.035 0 0 1 21 12c0 1.83-.546 3.531-1.476 4.956a.75.75 0 0 1-1.256-.82A7.535 7.535 0 0 0 19.5 12a7.535 7.535 0 0 0-1.232-4.135.75.75 0 0 1 .218-1.038ZM17.297 9.16a.75.75 0 0 0-1.337.68 4.948 4.948 0 0 1 0 4.506.75.75 0 0 0 1.337.68 6.448 6.448 0 0 0 0-5.866Z',
      fill: 'currentColor'
    }));
  }
});
export { IconVolumeHighFill };
var IconVolumeMidFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm6.697 5.281 1.64-1.362v8.162l-1.64-1.362a3.833 3.833 0 0 0-2.45-.886h-.914A.333.333 0 0 1 3 9.5v-3c0-.184.15-.333.333-.333h.914c.895 0 1.762-.314 2.45-.886Zm2.64-1.836a.778.778 0 0 0-1.292-.585L6.058 4.512a2.833 2.833 0 0 1-1.811.655h-.914C2.597 5.167 2 5.764 2 6.5v3c0 .736.597 1.333 1.333 1.333h.914a2.83 2.83 0 0 1 1.81.655l1.988 1.652a.778.778 0 0 0 1.291-.585v-9.11Zm2.194 2.661a.5.5 0 1 0-.89.454 3.298 3.298 0 0 1 0 3.004.5.5 0 1 0 .89.453 4.298 4.298 0 0 0 0-3.91Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm10.046 7.922 2.458-2.044v12.244l-2.458-2.044A5.75 5.75 0 0 0 6.37 14.75H5a.5.5 0 0 1-.5-.5v-4.5a.5.5 0 0 1 .5-.5h1.37a5.75 5.75 0 0 0 3.676-1.328Zm3.958-2.754c0-1.007-1.186-1.538-1.936-.877L9.087 6.768a4.25 4.25 0 0 1-2.717.982H5a2 2 0 0 0-2 2v4.5a2 2 0 0 0 2 2h1.37a4.25 4.25 0 0 1 2.717.982l2.981 2.477c.75.66 1.936.13 1.936-.877V5.168Zm3.293 3.992a.75.75 0 0 0-1.337.68 4.948 4.948 0 0 1 0 4.506.75.75 0 0 0 1.337.68 6.448 6.448 0 0 0 0-5.866Z',
      fill: 'currentColor'
    }));
  }
});
export { IconVolumeMidFill };
var IconWarningFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.83 3.329c.51-.92 1.83-.92 2.34 0l4.3 7.768a1.338 1.338 0 0 1-1.17 1.986H3.7a1.338 1.338 0 0 1-1.17-1.986l4.3-7.768ZM8 5.694a.5.5 0 0 1 .5.5v2.778a.5.5 0 1 1-1 0V6.194a.5.5 0 0 1 .5-.5Zm.667 4.973a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.245 4.993c.764-1.38 2.746-1.38 3.51 0l6.45 11.652c.74 1.337-.225 2.98-1.754 2.98H5.55c-1.53 0-2.495-1.643-1.755-2.98l6.45-11.652ZM12 8.542a.75.75 0 0 1 .75.75v4.166a.75.75 0 0 1-1.5 0V9.292a.75.75 0 0 1 .75-.75ZM13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWarningFill };
var IconVolumeMuteFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.336 3.919 6.697 5.28c-.11.092-.226.178-.346.256l-.727-.727a2.88 2.88 0 0 0 .434-.298L8.045 2.86a.778.778 0 0 1 1.291.585v5.077l-1-1V3.92ZM3.163 5.177l.99.99h-.82A.333.333 0 0 0 3 6.5v3c0 .184.15.333.333.333h.914c.895 0 1.762.313 2.45.886l1.64 1.362v-1.73l.941.942c.02.019.038.037.058.053v1.209a.778.778 0 0 1-1.29.585l-1.988-1.652a2.833 2.833 0 0 0-1.811-.655h-.914A1.333 1.333 0 0 1 2 9.5v-3c0-.679.507-1.239 1.163-1.323Zm.564-1.53a.5.5 0 1 0-.707.707l6.945 6.945a.5.5 0 1 0 .707-.707L3.727 3.646Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm12.504 5.878-2.458 2.044c-.167.138-.34.266-.52.384l-1.09-1.091a4.25 4.25 0 0 0 .65-.447l2.982-2.477c.75-.66 1.936-.13 1.936.877v7.615l-1.5-1.5V5.878Zm-7.76 1.888L6.228 9.25H5a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 .5.5h1.37a5.75 5.75 0 0 1 3.676 1.328l2.458 2.044v-2.596l1.414 1.413c.028.028.057.055.086.08v1.814c0 1.006-1.186 1.537-1.936.876l-2.981-2.477a4.25 4.25 0 0 0-2.717-.982H5a2 2 0 0 1-2-2v-4.5a2 2 0 0 1 1.744-1.984Zm.847-2.296a.75.75 0 0 0-1.06 1.06l10.417 10.418a.75.75 0 0 0 1.06-1.06L5.592 5.47Z',
      fill: 'currentColor'
    }));
  }
});
export { IconVolumeMuteFill };
var IconWorkspaceFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M6.472 7.306H4.25a.833.833 0 0 1-.833-.834V4.25c0-.46.373-.833.833-.833h2.222c.46 0 .834.373.834.833v2.222c0 .46-.373.834-.834.834Zm5.278 0H9.528a.833.833 0 0 1-.834-.834V4.25c0-.46.374-.833.834-.833h2.222c.46 0 .833.373.833.833v2.222c0 .46-.373.834-.833.834Zm-5.278 5.277H4.25a.833.833 0 0 1-.833-.833V9.528c0-.46.373-.834.833-.834h2.222c.46 0 .834.373.834.834v2.222c0 .46-.373.833-.834.833Zm5.278 0H9.528a.833.833 0 0 1-.834-.833V9.528c0-.46.374-.834.834-.834h2.222c.46 0 .833.373.833.834v2.222c0 .46-.373.833-.833.833Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M9.708 10.958H6.375c-.69 0-1.25-.56-1.25-1.25V6.375c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25Zm7.917 0h-3.333c-.69 0-1.25-.56-1.25-1.25V6.375c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25Zm-7.917 7.917H6.375c-.69 0-1.25-.56-1.25-1.25v-3.333c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25Zm7.917 0h-3.333c-.69 0-1.25-.56-1.25-1.25v-3.333c0-.69.56-1.25 1.25-1.25h3.333c.69 0 1.25.56 1.25 1.25v3.333c0 .69-.56 1.25-1.25 1.25Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconWorkspaceFill };
var IconXCircleFill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 2.444a5.555 5.555 0 1 0 0 11.111 5.555 5.555 0 0 0 0-11.11Zm2.1 7.067a.416.416 0 1 1-.59.59L8 8.588 6.49 10.1a.414.414 0 0 1-.59 0 .416.416 0 0 1 0-.589L7.41 8 5.9 6.49a.416.416 0 1 1 .59-.59L8 7.41 9.51 5.9a.416.416 0 1 1 .59.59L8.59 8l1.51 1.51Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12 3.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 1 0 0-16.666Zm3.15 10.6a.625.625 0 1 1-.884.883L12 12.884 9.734 15.15a.622.622 0 0 1-.884 0 .625.625 0 0 1 0-.883L11.116 12 8.85 9.734a.625.625 0 1 1 .884-.884L12 11.116l2.266-2.266a.625.625 0 1 1 .884.884L12.884 12l2.266 2.266Z',
      fill: 'currentColor'
    }));
  }
});
export { IconXCircleFill };
var IconAddCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 12.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm0-8.917a.75.75 0 0 1 .75.75V7.25h1.417a.75.75 0 0 1 0 1.5H8.75v1.417a.75.75 0 0 1-1.5 0V8.75H5.833a.75.75 0 0 1 0-1.5H7.25V5.833a.75.75 0 0 1 .75-.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 19.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0 1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 12 8Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAddCircle };
var IconAirplay = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 4.976c0-.907.736-1.643 1.643-1.643h8.714c.908 0 1.643.736 1.643 1.643v4.715c0 .907-.736 1.642-1.643 1.642h-1.585l-.867-1h2.452A.643.643 0 0 0 13 9.691V4.976a.643.643 0 0 0-.643-.643H3.643A.643.643 0 0 0 3 4.976v4.715c0 .355.288.642.643.642h2.119l-.867 1H3.643A1.643 1.643 0 0 1 2 9.691V4.976Zm6.582 5.357.866 1 1.797 2.073a.361.361 0 0 1-.274.6H4.696a.362.362 0 0 1-.274-.6l1.796-2.073.788-.909.08-.09.474-.548a.374.374 0 0 1 .547 0l.475.547Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 7.464A2.464 2.464 0 0 1 5.464 5h13.072A2.464 2.464 0 0 1 21 7.464v7.072A2.464 2.464 0 0 1 18.536 17h-2.379l-1.3-1.5h3.679a.964.964 0 0 0 .964-.964V7.464a.964.964 0 0 0-.964-.964H5.464a.964.964 0 0 0-.964.964v7.072c0 .532.432.964.964.964h3.179l-1.3 1.5H5.464A2.464 2.464 0 0 1 3 14.536V7.464Zm9.873 8.036 1.3 1.5 2.694 3.11a.542.542 0 0 1-.41.898H7.043a.543.543 0 0 1-.41-.898L9.328 17l1.181-1.364.119-.136.711-.821a.56.56 0 0 1 .822 0l.712.821Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAirplay };
var IconAnimal = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M6.278 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm3.555 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M4.25 6.472c-1.111-.278-.556-3.889-.556-3.889s3.334.735 3.334 1.667m4.722 2.222c1.111-.278.694-3.889.694-3.889s-3.333.735-3.333 1.667m3.472 5.528-.164-.99a5.277 5.277 0 0 0-2.405-3.605l-.259-.162a3.422 3.422 0 0 0-3.598-.02l-.015.01a5.278 5.278 0 0 0-2.39 3.317l-.335 1.45 1.698.618a1.802 1.802 0 0 1 1.173 1.476 1.724 1.724 0 0 0 3.424 0 1.802 1.802 0 0 1 1.173-1.476l1.698-.618Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M9.417 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm5.333 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M6.625 9.958c-1.667-.416-.833-5.833-.833-5.833s5 1.103 5 2.5m6.583 3.333c1.667-.416 1.042-5.833 1.042-5.833s-5 1.103-5 2.5m5.458 8.042-.247-1.484a7.916 7.916 0 0 0-3.608-5.408l-.387-.243a5.133 5.133 0 0 0-5.398-.03l-.022.014a7.916 7.916 0 0 0-3.586 4.975l-.502 2.176 2.548.926a2.703 2.703 0 0 1 1.76 2.215 2.586 2.586 0 0 0 5.135 0 2.703 2.703 0 0 1 1.76-2.215l2.547-.926Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconAnimal };
var IconAnnotations = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3.278 6.389a.556.556 0 0 0 .555-.556v-.88l3.192 3.19c.033 1.334.453 2.695 1.226 3.72.587.777 1.706 1.718 1.754 1.757a.553.553 0 0 0 .782-.069.555.555 0 0 0-.07-.782c-.01-.01-1.069-.9-1.58-1.576-.428-.567-.723-1.275-.878-2.016a3.495 3.495 0 0 0 1.672.426c.462 0 .931-.091 1.38-.277 1.299-.538 2.106-1.716 2.106-3.076a2.78 2.78 0 0 0-2.778-2.777c-1.348 0-2.436.694-3.064 1.956-.195.39-.334.82-.426 1.268l-2.53-2.53H5.5a.556.556 0 0 0 0-1.111H3.278a.556.556 0 0 0-.556.555v2.222c0 .307.25.556.556.556Zm5.292-.465c.304-.612.91-1.34 2.069-1.34.92 0 1.667.747 1.667 1.666 0 1.078-.734 1.765-1.42 2.05-.73.302-1.804.33-2.632-.498l-.114-.114c.032-.635.171-1.245.43-1.764Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.917 9.583c.46 0 .833-.373.833-.833V7.428l4.787 4.787c.05 2 .68 4.042 1.84 5.579.88 1.166 2.558 2.577 2.63 2.636a.831.831 0 0 0 1.173-.103.833.833 0 0 0-.103-1.174c-.016-.013-1.605-1.35-2.37-2.363-.643-.851-1.085-1.912-1.319-3.025a5.24 5.24 0 0 0 2.508.639 5.41 5.41 0 0 0 2.071-.415c1.948-.807 3.158-2.575 3.158-4.614a4.171 4.171 0 0 0-4.167-4.166c-2.02 0-3.653 1.042-4.595 2.934a7.764 7.764 0 0 0-.64 1.902L6.928 6.25H8.25a.834.834 0 0 0 0-1.667H4.917a.834.834 0 0 0-.834.834V8.75c0 .46.374.833.834.833Zm7.938-.697c.456-.918 1.366-2.011 3.103-2.011 1.38 0 2.5 1.121 2.5 2.5 0 1.616-1.1 2.648-2.129 3.074-1.095.454-2.706.495-3.948-.746l-.17-.17c.047-.954.256-1.87.644-2.647Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAnnotations };
var IconAppLogs = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7Zm-.32 1.116A.499.499 0 0 0 4 4.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5H7.833a.5.5 0 1 0-1 0H6.5a.5.5 0 0 0-1 0h-.333a.5.5 0 1 0-.987.116Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 3.25h8V5.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V3.25ZM5.167 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM6 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM7.833 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      stroke: 'currentColor',
      strokeLinecap: 'round',
      d: 'M5.5 6.5h4m-4 2h1.667m-1.667 2h5'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 6.25A2.25 2.25 0 0 1 6.25 4h11.5A2.25 2.25 0 0 1 20 6.25v11.5A2.25 2.25 0 0 1 17.75 20H6.25A2.25 2.25 0 0 1 4 17.75V6.25Zm2.25 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM5.5 10v7.75c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.75-.75H6.25a.75.75 0 0 0-.75.75V10Zm2.75-3.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm2 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM7.75 9.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM7 13.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAppLogs };
var IconAppWindow = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.167 2.667a1.5 1.5 0 0 0-1.5 1.5v7.666a1.5 1.5 0 0 0 1.5 1.5h7.666a1.5 1.5 0 0 0 1.5-1.5V4.167a1.5 1.5 0 0 0-1.5-1.5H4.167Zm.496 1a.5.5 0 1 0 .007 0h-.007Zm1.334 0a.5.5 0 1 0 .006 0h-.006Zm1.333 0a.5.5 0 1 0 .006 0H7.33Zm-3.663 2.16v6.006a.5.5 0 0 0 .5.5h7.666a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5H4.167a.5.5 0 0 0-.5.494Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.25 4A2.25 2.25 0 0 0 4 6.25v11.5A2.25 2.25 0 0 0 6.25 20h11.5A2.25 2.25 0 0 0 20 17.75V6.25A2.25 2.25 0 0 0 17.75 4H6.25ZM7 5.5A.75.75 0 1 0 7 7a.75.75 0 0 0 0-1.5ZM5.5 17.75v-9A.75.75 0 0 1 6.25 8h11.5a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H6.25a.75.75 0 0 1-.75-.75ZM9 5.5A.75.75 0 1 0 9 7a.75.75 0 0 0 0-1.5Zm2 0A.75.75 0 1 0 11 7a.75.75 0 0 0 0-1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAppWindow };
var IconApps = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.333 2.667a1.5 1.5 0 0 0-1.5 1.5v7.666a1.5 1.5 0 0 0 1.5 1.5h3.334a1.5 1.5 0 0 0 1.5-1.5V4.167a1.5 1.5 0 0 0-1.5-1.5H6.333Zm-.5 1.5a.5.5 0 0 1 .5-.5h.473a.5.5 0 0 0 .5.5h1.388a.5.5 0 0 0 .5-.5h.473a.5.5 0 0 1 .5.5v7.666a.5.5 0 0 1-.5.5H6.333a.5.5 0 0 1-.5-.5V4.167Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.5 4a2.25 2.25 0 0 0-2.25 2.25v11.5A2.25 2.25 0 0 0 9.5 20h5a2.25 2.25 0 0 0 2.25-2.25V6.25A2.25 2.25 0 0 0 14.5 4h-5Zm-.75 2.25a.75.75 0 0 1 .75-.75h.708c0 .414.336.75.75.75h2.084a.75.75 0 0 0 .75-.75h.708a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75V6.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconApps };
var IconArchive = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.667 3.667v1.341h8.666V3.667H3.667Zm-1-.223c0-.454.38-.777.793-.777h9.08c.413 0 .793.323.793.777v1.787a.78.78 0 0 1-.666.767v5.446c0 1.061-.888 1.89-1.943 1.89H5.276c-1.055 0-1.943-.829-1.943-1.89V5.998a.781.781 0 0 1-.666-.767V3.444Zm1.666 2.564h7.334v5.436c0 .473-.405.89-.943.89H5.276c-.539 0-.943-.416-.943-.89V6.008ZM6.75 7.361a.5.5 0 0 0 0 1h2.5a.5.5 0 1 0 0-1h-2.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 5.5v2.013h13V5.5h-13ZM4 5.167C4 4.485 4.57 4 5.19 4h13.62c.62 0 1.19.485 1.19 1.167v2.679c0 .611-.459 1.064-1 1.152v8.169C19 18.757 17.668 20 16.086 20H7.914C6.332 20 5 18.758 5 17.167v-8.17c-.541-.087-1-.54-1-1.151v-2.68Zm2.5 3.846h11v8.154c0 .71-.606 1.333-1.414 1.333H7.914c-.808 0-1.414-.624-1.414-1.333V9.013Zm3.625 2.029a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5h-3.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArchive };
var IconArrowClockwise = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.475 2.636a.75.75 0 0 0-1.06 1.061l.886.886H8a4.75 4.75 0 1 0 4.75 4.75.75.75 0 0 0-1.5 0A3.25 3.25 0 1 1 8 6.083h.412l-.998.998a.75.75 0 0 0 1.061 1.06l2.222-2.222a.75.75 0 0 0 0-1.06L8.475 2.636Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.447 4.22a.75.75 0 1 0-1.06 1.06l1.97 1.97H12A6.75 6.75 0 1 0 18.75 14a.75.75 0 0 0-1.5 0A5.25 5.25 0 1 1 12 8.75h1.523l-2.136 2.136a.75.75 0 0 0 1.06 1.061l3.334-3.333a.75.75 0 0 0 0-1.061L12.447 4.22Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowClockwise };
var IconArrowCounterclockwise = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.525 2.636a.75.75 0 0 1 1.06 1.061l-.886.886H8a4.75 4.75 0 1 1-4.75 4.75.75.75 0 0 1 1.5 0A3.25 3.25 0 1 0 8 6.083h-.412l.998.998a.75.75 0 0 1-1.061 1.06L5.303 5.92a.75.75 0 0 1 0-1.06l2.222-2.223Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.553 4.22a.75.75 0 1 1 1.06 1.06l-1.97 1.97H12A6.75 6.75 0 1 1 5.25 14a.75.75 0 0 1 1.5 0A5.25 5.25 0 1 0 12 8.75h-1.523l2.136 2.136a.75.75 0 0 1-1.06 1.061L8.219 8.614a.75.75 0 0 1 0-1.061l3.334-3.333Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCounterclockwise };
var IconArrowCurvedDownLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.917 6.445c0 .69-.56 1.25-1.25 1.25H6.144l.942-.942a.75.75 0 1 0-1.06-1.06l-2.224 2.22a.75.75 0 0 0 0 1.061l2.222 2.222a.75.75 0 0 0 1.06-1.06l-.941-.942h3.523a2.75 2.75 0 0 0 2.75-2.75V5.333a.75.75 0 0 0-1.5 0v1.112Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm8.31 13.416 2.054 2.054a.75.75 0 1 1-1.06 1.06L5.97 13.197a.75.75 0 0 1 0-1.06l3.333-3.334a.75.75 0 1 1 1.06 1.06l-2.052 2.053H14.5a2.25 2.25 0 0 0 2.25-2.25V8a.75.75 0 0 1 1.5 0v1.666a3.75 3.75 0 0 1-3.75 3.75H8.31Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCurvedDownLeft };
var IconArrowCurvedDownRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.083 6.445c0 .69.56 1.25 1.25 1.25h3.523l-.942-.942a.75.75 0 1 1 1.06-1.06l2.223 2.221a.75.75 0 0 1 0 1.061l-2.222 2.222a.75.75 0 0 1-1.06-1.06l.941-.942H6.333a2.75 2.75 0 0 1-2.75-2.75V5.333a.75.75 0 1 1 1.5 0v1.112Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm15.69 13.417-2.054 2.053a.75.75 0 1 0 1.061 1.06l3.333-3.333a.75.75 0 0 0 0-1.06l-3.333-3.334a.75.75 0 0 0-1.06 1.06l2.052 2.054H9.5a2.25 2.25 0 0 1-2.25-2.25V8a.75.75 0 0 0-1.5 0v1.667a3.75 3.75 0 0 0 3.75 3.75h6.19Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCurvedDownRight };
var IconArrowCurvedUpLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.025 4.803a.75.75 0 1 1 1.06 1.06l-.941.943h3.523a2.75 2.75 0 0 1 2.75 2.75v1.11a.75.75 0 0 1-1.5 0v-1.11c0-.69-.56-1.25-1.25-1.25H6.144l.942.942a.75.75 0 0 1-1.06 1.06L3.802 8.086a.75.75 0 0 1 0-1.06l2.222-2.223Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.303 7.47a.75.75 0 1 1 1.06 1.06l-2.052 2.053H14.5a3.75 3.75 0 0 1 3.75 3.75V16a.75.75 0 0 1-1.5 0v-1.667a2.25 2.25 0 0 0-2.25-2.25H8.31l2.054 2.053a.75.75 0 0 1-1.061 1.061L5.97 11.864a.75.75 0 0 1 0-1.061L9.303 7.47Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCurvedUpLeft };
var IconArrowCurvedUpRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.975 4.803a.75.75 0 1 0-1.06 1.06l.941.943H6.333a2.75 2.75 0 0 0-2.75 2.75v1.11a.75.75 0 0 0 1.5 0v-1.11c0-.69.56-1.25 1.25-1.25h3.523l-.942.942a.75.75 0 0 0 1.06 1.06l2.223-2.222a.75.75 0 0 0 0-1.06L9.975 4.802Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.697 7.47a.75.75 0 1 0-1.06 1.06l2.052 2.053H9.5a3.75 3.75 0 0 0-3.75 3.75V16a.75.75 0 0 0 1.5 0v-1.667a2.25 2.25 0 0 1 2.25-2.25h6.19l-2.054 2.053a.75.75 0 0 0 1.061 1.061l3.333-3.333a.75.75 0 0 0 0-1.061L14.697 7.47Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowCurvedUpRight };
var IconArrowDownCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.417a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.917 8a6.083 6.083 0 1 1 12.166 0A6.083 6.083 0 0 1 1.917 8Zm5.333.273-.386-.387a.75.75 0 1 0-1.061 1.061l1.667 1.667a.75.75 0 0 0 1.06 0l1.667-1.667a.75.75 0 1 0-1.06-1.06l-.387.386V5.917a.75.75 0 0 0-1.5 0v2.356Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm8 1.314-1.22-1.22a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 0 0-1.06-1.06l-1.22 1.22v-4.44a.75.75 0 0 0-1.5 0v4.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownCircle };
var IconArrowDownLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.629 10.765h2.903a.75.75 0 0 1 0 1.5H4.818a.75.75 0 0 1-.75-.75V6.801a.75.75 0 1 1 1.5 0v2.904l5.084-5.084a.75.75 0 0 1 1.06 1.06L6.63 10.766Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.038 16.523h5.26a.75.75 0 0 1 0 1.5H7.227a.75.75 0 0 1-.75-.75v-7.071a.75.75 0 1 1 1.5 0v5.26l8.266-8.265a.75.75 0 0 1 1.06 1.06l-8.265 8.266Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownLeft };
var IconArrowDownLeftUpRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.197 3.864a.75.75 0 1 0-1.06-1.061l-2.65 2.649V3.374a.75.75 0 1 0-1.5 0v3.889c0 .414.336.75.75.75h3.89a.75.75 0 0 0 0-1.5h-2.079l2.649-2.65ZM5.452 9.487H3.374a.75.75 0 1 1 0-1.5h3.889a.75.75 0 0 1 .75.75v3.89a.75.75 0 0 1-1.5 0v-2.08l-2.65 2.65a.75.75 0 1 1-1.06-1.06l2.649-2.65Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.53 5.53a.75.75 0 1 0-1.06-1.06l-4.518 4.517-.096.096V5.061a.75.75 0 0 0-1.5 0v5.833c0 .414.336.75.75.75h5.833a.75.75 0 0 0 0-1.5h-4.022l.096-.096L19.53 5.53ZM9.083 13.856H5.061a.75.75 0 0 1 0-1.5h5.833a.75.75 0 0 1 .75.75v5.833a.75.75 0 0 1-1.5 0v-4.023L5.53 19.53a.75.75 0 0 1-1.06-1.06l4.613-4.614Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownLeftUpRight };
var IconArrowDownRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.432 9.705V6.8a.75.75 0 0 1 1.5 0v4.714a.75.75 0 0 1-.75.75H6.468a.75.75 0 0 1 0-1.5H9.37L4.288 5.682a.75.75 0 0 1 1.06-1.061l5.084 5.084Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.023 15.462v-5.26a.75.75 0 0 1 1.5 0v7.071a.75.75 0 0 1-.75.75H9.702a.75.75 0 0 1 0-1.5h5.26L6.697 8.257a.75.75 0 0 1 1.06-1.06l8.266 8.265Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDownRight };
var IconArrowDown = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm8.75 11.023 2.053-2.053a.75.75 0 1 1 1.06 1.06L8.53 13.364a.75.75 0 0 1-1.06 0L4.136 10.03a.75.75 0 1 1 1.061-1.06l2.053 2.053v-7.19a.75.75 0 0 1 1.5 0v7.19Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm12.75 17.44 3.72-3.72a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 1 1 1.06-1.06l3.72 3.72V5.75a.75.75 0 0 1 1.5 0v11.69Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowDown };
var IconArrowLeftCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.417a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.917 8a6.083 6.083 0 1 1 12.166 0A6.083 6.083 0 0 1 1.917 8Zm5.81-.75.387-.386a.75.75 0 0 0-1.061-1.061L5.386 7.47a.75.75 0 0 0 0 1.06l1.667 1.667a.75.75 0 1 0 1.06-1.06l-.386-.387h2.356a.75.75 0 0 0 0-1.5H7.727Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm7.436-.75 1.22-1.22a.75.75 0 1 0-1.061-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h4.44a.75.75 0 0 0 0-1.5h-4.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeftCircle };
var IconArrowLeftRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.09 7.47a.75.75 0 0 1 0 1.06l-2.75 2.75a.75.75 0 0 1-1.061-1.06l1.47-1.47H4.25l1.47 1.47a.75.75 0 0 1-1.06 1.06L1.91 8.53a.75.75 0 0 1 0-1.06l2.75-2.75a.75.75 0 0 1 1.06 1.06L4.25 7.25h7.498l-1.47-1.47a.75.75 0 0 1 1.06-1.06l2.75 2.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20.87 11.47a.75.75 0 0 1 0 1.06l-4.126 4.125a.75.75 0 0 1-1.06-1.06l2.844-2.845H5.472l2.844 2.844a.75.75 0 0 1-1.06 1.061L3.13 12.53a.75.75 0 0 1 0-1.06l4.125-4.125a.75.75 0 1 1 1.06 1.06L5.472 11.25h13.056l-2.844-2.844a.75.75 0 1 1 1.06-1.061l4.125 4.125Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeftRight };
var IconArrowLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.97 7.803a.75.75 0 0 0 0 1.06l3.333 3.334a.75.75 0 1 0 1.06-1.06L5.312 9.082H12.5a.75.75 0 0 0 0-1.5H5.31L7.365 5.53a.75.75 0 0 0-1.061-1.06L2.97 7.803Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.72 11.97a.75.75 0 0 0 0 1.06l5 5a.75.75 0 0 0 1.06-1.06l-3.72-3.72h11.69a.75.75 0 0 0 0-1.5H7.06l3.72-3.72a.75.75 0 1 0-1.06-1.06l-5 5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowLeft };
var IconArrowRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm9.697 12.197 3.333-3.333a.75.75 0 0 0 0-1.061L9.697 4.47a.75.75 0 0 0-1.06 1.06l2.052 2.053H3.5a.75.75 0 0 0 0 1.5h7.19l-2.053 2.053a.75.75 0 0 0 1.06 1.061Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm14.28 18.03 5-5a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 1.06l3.72 3.72H5.25a.75.75 0 0 0 0 1.5h11.69l-3.72 3.72a.75.75 0 0 0 1.06 1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowRight };
var IconArrowTopCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.417a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.917 8a6.083 6.083 0 1 1 12.166 0A6.083 6.083 0 0 1 1.917 8Zm6.833-.273.386.387a.75.75 0 0 0 1.061-1.061L8.53 5.386a.75.75 0 0 0-1.06 0L5.803 7.053a.75.75 0 0 0 1.06 1.06l.387-.386v2.356a.75.75 0 0 0 1.5 0V7.727Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm9.5-1.314 1.22 1.22a.75.75 0 1 0 1.06-1.061l-2.5-2.5a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.22-1.22v4.44a.75.75 0 0 0 1.5 0v-4.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowTopCircle };
var IconArrowRightCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.417a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.917 8a6.083 6.083 0 1 1 12.166 0A6.083 6.083 0 0 1 1.917 8Zm6.356.75-.387.386a.75.75 0 0 0 1.061 1.061l1.667-1.667a.75.75 0 0 0 0-1.06L8.947 5.803a.75.75 0 1 0-1.06 1.06l.386.387H5.917a.75.75 0 1 0 0 1.5h2.356Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm10.064.75-1.22 1.22a.75.75 0 1 0 1.061 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06l1.22 1.22h-4.44a.75.75 0 0 0 0 1.5h4.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowRightCircle };
var IconArrowUpDownLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.167 3.083a.75.75 0 0 1 .75.75v3.89a.75.75 0 0 1-1.5 0v-2.08l-5.773 5.773h2.078a.75.75 0 0 1 0 1.5H3.833a.75.75 0 0 1-.75-.75v-3.89a.75.75 0 1 1 1.5 0v2.079l5.773-5.773H8.278a.75.75 0 1 1 0-1.5h3.889Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.25 5a.75.75 0 0 1 .75.75v5.833a.75.75 0 0 1-1.5 0V7.561L7.56 17.5h4.023a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75v-5.833a.75.75 0 0 1 1.5 0v4.022L16.44 6.5h-4.023a.75.75 0 0 1 0-1.5h5.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownLeft };
var IconArrowUpDownRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.917 12.167a.75.75 0 0 1-.75.75h-3.89a.75.75 0 1 1 0-1.5h2.079L4.583 5.644v2.078a.75.75 0 1 1-1.5 0V3.833a.75.75 0 0 1 .75-.75h3.89a.75.75 0 0 1 0 1.5h-2.08l5.773 5.773V8.278a.75.75 0 0 1 1.5 0v3.889Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19 18.25a.75.75 0 0 1-.75.75h-5.833a.75.75 0 0 1 0-1.5h4.022L6.5 7.56v4.023a.75.75 0 0 1-1.5 0V5.75A.75.75 0 0 1 5.75 5h5.833a.75.75 0 0 1 0 1.5H7.561l9.939 9.94v-4.023a.75.75 0 0 1 1.5 0v5.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDownRight };
var IconArrowUpDown = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.53 13.423a.75.75 0 0 1-1.06 0l-2.75-2.75a.75.75 0 1 1 1.06-1.06l1.47 1.469V4.918l-1.47 1.47a.75.75 0 1 1-1.06-1.061l2.75-2.75a.75.75 0 0 1 1.06 0l2.75 2.75a.75.75 0 0 1-1.06 1.06L8.75 4.919v6.164l1.47-1.47a.75.75 0 1 1 1.06 1.061l-2.75 2.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.53 19.87a.75.75 0 0 1-1.06 0l-4.125-4.126a.75.75 0 0 1 1.06-1.06l2.845 2.844V6.472L8.406 9.316a.75.75 0 0 1-1.061-1.06L11.47 4.13a.75.75 0 0 1 1.06 0l4.125 4.125a.75.75 0 0 1-1.06 1.06L12.75 6.472v11.056l2.845-2.844a.75.75 0 1 1 1.06 1.06L12.53 19.87Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpDown };
var IconArrowUpLeftCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.417a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.917 8a6.083 6.083 0 1 1 12.166 0A6.083 6.083 0 0 1 1.917 8Zm6.42-.723h.547a.75.75 0 0 0 0-1.5H6.527a.75.75 0 0 0-.75.75v2.357a.75.75 0 1 0 1.5 0v-.546l1.666 1.666a.75.75 0 1 0 1.06-1.061L8.338 7.277Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm8.35-1.46h1.726a.75.75 0 0 0 0-1.5H9.79a.75.75 0 0 0-.75.75v3.536a.75.75 0 0 0 1.5 0V11.6l3.14 3.14a.75.75 0 0 0 1.06-1.062L11.6 10.54Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpLeftCircle };
var IconArrowUpLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.568 6.962v2.903a.75.75 0 1 1-1.5 0V5.151a.75.75 0 0 1 .75-.75h4.714a.75.75 0 0 1 0 1.5H6.629l5.083 5.084a.75.75 0 1 1-1.06 1.06L5.568 6.963Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.977 9.538v5.26a.75.75 0 0 1-1.5 0V7.727a.75.75 0 0 1 .75-.75h7.071a.75.75 0 1 1 0 1.5h-5.26l8.265 8.266a.75.75 0 0 1-1.06 1.06L7.977 9.538Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpLeft };
var IconArrowUpRightCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.417a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.917 8a6.083 6.083 0 1 1 12.166 0A6.083 6.083 0 0 1 1.917 8Zm6.806.338v.546a.75.75 0 0 0 1.5 0V6.527a.75.75 0 0 0-.75-.75H7.116a.75.75 0 1 0 0 1.5h.546L5.997 8.943a.75.75 0 0 0 1.06 1.06l1.666-1.665Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm10.21-.399v1.725a.75.75 0 0 0 1.5 0V9.79a.75.75 0 0 0-.75-.75h-3.536a.75.75 0 0 0 0 1.5H12.4l-3.14 3.14a.75.75 0 0 0 1.06 1.06l3.14-3.139Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpRightCircle };
var IconArrowUpRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.371 5.901H6.468a.75.75 0 1 1 0-1.5h4.714a.75.75 0 0 1 .75.75v4.714a.75.75 0 0 1-1.5 0V6.962l-5.084 5.084a.75.75 0 0 1-1.06-1.061L9.37 5.901Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.962 8.477h-5.26a.75.75 0 1 1 0-1.5h7.07a.75.75 0 0 1 .75.75v7.071a.75.75 0 0 1-1.5 0v-5.26l-8.265 8.265a.75.75 0 1 1-1.06-1.06l8.265-8.266Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUpRight };
var IconArrowUp = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.53 3.303a.75.75 0 0 0-1.06 0L4.136 6.636a.75.75 0 0 0 1.061 1.061L7.25 5.644v7.19a.75.75 0 0 0 1.5 0v-7.19l2.053 2.053a.75.75 0 1 0 1.06-1.06L8.53 3.302Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.53 5.22a.75.75 0 0 0-1.06 0l-5 5a.75.75 0 1 0 1.06 1.06l3.72-3.72v11.69a.75.75 0 0 0 1.5 0V7.56l3.72 3.72a.75.75 0 1 0 1.06-1.06l-5-5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconArrowUp };
var IconAspectRatio = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.611 4.333A.611.611 0 0 0 3 4.944v6.112c0 .337.274.61.611.61h8.778a.611.611 0 0 0 .611-.61V4.944a.611.611 0 0 0-.611-.61H3.61ZM2 4.944c0-.89.721-1.61 1.611-1.61h8.778c.89 0 1.611.72 1.611 1.61v6.112c0 .89-.721 1.61-1.611 1.61H3.61a1.61 1.61 0 0 1-1.611-1.61V4.944Zm2 .89a.5.5 0 0 1 .5-.5h2.222a.5.5 0 0 1 0 1H5v1.722a.5.5 0 1 1-1 0V5.833Zm8 2.113a.5.5 0 0 0-1 0v1.72H9.278a.5.5 0 1 0 0 1H11.5a.5.5 0 0 0 .5-.5v-2.22Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.417 6.5a.917.917 0 0 0-.917.917v9.166c0 .507.41.917.917.917h13.166c.507 0 .917-.41.917-.917V7.417a.917.917 0 0 0-.917-.917H5.417ZM3 7.417A2.417 2.417 0 0 1 5.417 5h13.166A2.417 2.417 0 0 1 21 7.417v9.166A2.417 2.417 0 0 1 18.583 19H5.417A2.417 2.417 0 0 1 3 16.583V7.417ZM6 8.75A.75.75 0 0 1 6.75 8h3.333a.75.75 0 0 1 0 1.5H7.5v2.583a.75.75 0 0 1-1.5 0V8.75Zm12 3.17a.75.75 0 0 0-1.5 0v2.58h-2.583a.75.75 0 1 0 0 1.5h3.333a.75.75 0 0 0 .75-.75v-3.33Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAspectRatio };
var IconAssetCarousel = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.917 3.667A.333.333 0 0 0 5.583 4v8c0 .184.15.333.334.333h4.166a.334.334 0 0 0 .334-.333V4a.333.333 0 0 0-.334-.333H5.917ZM4.583 4c0-.736.597-1.333 1.334-1.333h4.166c.737 0 1.334.597 1.334 1.333h1.25C13.403 4 14 4.597 14 5.333v5.334c0 .736-.597 1.333-1.333 1.333h-1.25c0 .736-.597 1.333-1.334 1.333H5.917A1.333 1.333 0 0 1 4.583 12h-1.25A1.333 1.333 0 0 1 2 10.667V5.333C2 4.597 2.597 4 3.333 4h1.25Zm6.834 7h1.25c.184 0 .333-.15.333-.333V5.333A.333.333 0 0 0 12.667 5h-1.25v6ZM4.583 5v6h-1.25A.333.333 0 0 1 3 10.667V5.333C3 5.15 3.15 5 3.333 5h1.25Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.875 5.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h6.25a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-6.25Zm-2 .5a2 2 0 0 1 2-2h6.25a2 2 0 0 1 2 2H19a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-1.875a2 2 0 0 1-2 2h-6.25a2 2 0 0 1-2-2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.875Zm10.25 10.5H19a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5h-1.875v9Zm-10.25-9v9H5a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h1.875Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAssetCarousel };
var IconAssetGrid = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.667 5.167a2.5 2.5 0 0 1 2.5-2.5h5.666a2.5 2.5 0 0 1 2.5 2.5v5.666a2.5 2.5 0 0 1-2.5 2.5H5.167a2.5 2.5 0 0 1-2.5-2.5V5.167Zm7.5 7.166h.666a1.5 1.5 0 0 0 1.5-1.5v-.666h-2.166v2.166Zm-1-2.166v2.166H6.833v-2.166h2.334Zm1-1h2.166V6.833h-2.166v2.334Zm-1-2.334v2.334H6.833V6.833h2.334Zm1-1h2.166v-.666a1.5 1.5 0 0 0-1.5-1.5h-.666v2.166Zm-1-2.166v2.166H6.833V3.667h2.334Zm-4 0h.666v2.166H3.667v-.666a1.5 1.5 0 0 1 1.5-1.5Zm-1.5 3.166h2.166v2.334H3.667V6.833Zm0 3.334h2.166v2.166h-.666a1.5 1.5 0 0 1-1.5-1.5v-.666Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 7.75A3.75 3.75 0 0 1 7.75 4h8.5A3.75 3.75 0 0 1 20 7.75v8.5A3.75 3.75 0 0 1 16.25 20h-8.5A3.75 3.75 0 0 1 4 16.25v-8.5ZM15.5 18.5h.75a2.25 2.25 0 0 0 2.25-2.25V15h-3v3.5ZM14 15v3.5h-4V15h4Zm1.5-1.5h3V10h-3v3.5ZM14 10v3.5h-4V10h4Zm1.5-1.5h3v-.75a2.25 2.25 0 0 0-2.25-2.25h-.75v3Zm-1.5-3v3h-4v-3h4Zm-6.25 0h.75v3h-3v-.75A2.25 2.25 0 0 1 7.75 5.5ZM5.5 10h3v3.5h-3V10Zm0 5h3v3.5h-.75a2.25 2.25 0 0 1-2.25-2.25V15Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAssetGrid };
var IconAttachment = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.475 3.714a3.218 3.218 0 0 1 4.547 4.556l-4.504 4.504A2.138 2.138 0 0 1 4.494 9.75L7.98 6.266a.567.567 0 1 1 .801.801l-3.484 3.485a1.005 1.005 0 0 0 1.42 1.42l4.505-4.504a2.085 2.085 0 0 0-2.95-2.948l-.008.008-4.026 3.86a.567.567 0 0 1-.784-.819l4.021-3.855Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.213 5.57a4.827 4.827 0 0 1 6.82 6.834l-6.756 6.757a3.207 3.207 0 0 1-4.536-4.535l5.227-5.227A.85.85 0 0 1 13.17 10.6l-5.226 5.227a1.507 1.507 0 0 0 2.13 2.13l6.757-6.756A3.127 3.127 0 1 0 12.41 6.78l-.013.013-6.04 5.789a.85.85 0 0 1-1.175-1.227l6.032-5.783Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAttachment };
var IconBagCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167Zm0 3.666a.917.917 0 0 0-.913.834h1.826A.917.917 0 0 0 8 5.833Zm0-.5c-.754 0-1.371.59-1.414 1.334h-.21a.567.567 0 0 0-.565.543l-.12 2.866a.567.567 0 0 0 .566.59h3.486c.322 0 .58-.268.566-.59l-.12-2.866a.567.567 0 0 0-.566-.543h-.209A1.417 1.417 0 0 0 8 5.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm0 5.5c-.717 0-1.306.55-1.37 1.25h2.74A1.375 1.375 0 0 0 12 8.75ZM12 8a2.125 2.125 0 0 0-2.121 2h-.314a.85.85 0 0 0-.849.815l-.18 4.3a.85.85 0 0 0 .85.885h5.228a.85.85 0 0 0 .85-.885l-.18-4.3a.85.85 0 0 0-.85-.815h-.313c-.064-1.115-.99-2-2.121-2Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBagCircle };
var IconAt = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.5a5.5 5.5 0 1 0 1.932 10.65.5.5 0 0 0-.351-.935A4.5 4.5 0 1 1 12.5 8v.556a1.167 1.167 0 1 1-2.333 0V5.778a.5.5 0 1 0-1 0v.024a2.255 2.255 0 0 0-1.445-.524C6.313 5.278 5.278 6.563 5.278 8s1.035 2.722 2.444 2.722c.752 0 1.397-.365 1.835-.925A2.166 2.166 0 0 0 13.5 8.555V8A5.5 5.5 0 0 0 8 2.5Zm1.167 5.485v.03c-.007 1.006-.713 1.707-1.445 1.707-.735 0-1.444-.708-1.444-1.722s.709-1.722 1.444-1.722c.732 0 1.438.701 1.445 1.707Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.75a8.25 8.25 0 1 0 2.899 15.976.75.75 0 0 0-.527-1.404A6.75 6.75 0 1 1 18.75 12v.833a1.75 1.75 0 1 1-3.501 0V8.667a.75.75 0 0 0-1.5 0v.036a3.382 3.382 0 0 0-2.167-.786C9.47 7.917 7.917 9.845 7.917 12c0 2.155 1.553 4.083 3.666 4.083 1.128 0 2.095-.548 2.753-1.387a3.25 3.25 0 0 0 5.914-1.863V12A8.25 8.25 0 0 0 12 3.75Zm1.75 8.227v.046c-.01 1.509-1.069 2.56-2.167 2.56-1.103 0-2.166-1.062-2.166-2.583 0-1.52 1.063-2.583 2.166-2.583 1.098 0 2.156 1.051 2.167 2.56Z',
      fill: 'currentColor'
    }));
  }
});
export { IconAt };
var IconBlank = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 4.25a.75.75 0 0 1 .75-.75h3v1a2.25 2.25 0 0 0 2.25 2.25h1v5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-7.5ZM5.25 2A2.25 2.25 0 0 0 3 4.25v7.5A2.25 2.25 0 0 0 5.25 14h5.5A2.25 2.25 0 0 0 13 11.75V6a.75.75 0 0 0-.22-.53L9.53 2.22A.75.75 0 0 0 9 2H5.25Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 5.5A1.5 1.5 0 0 0 6.5 7v10A1.5 1.5 0 0 0 8 18.5h8a1.5 1.5 0 0 0 1.5-1.5v-6.25h-2.25a3 3 0 0 1-3-3V5.5H8Zm5.75 1.06 2.69 2.69h-1.19a1.5 1.5 0 0 1-1.5-1.5V6.56ZM5 7a3 3 0 0 1 3-3h5a.75.75 0 0 1 .53.22l5.25 5.25c.141.14.22.331.22.53v7a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBlank };
var IconBook = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm8.007 13.333-.276.417a.5.5 0 0 0 .552 0l-.276-.417Zm-.425-.28-.276.416.276-.417ZM2 4.272v8.445h1V4.273H2Zm5.306 9.196.425.281.552-.834-.425-.28-.552.833Zm.995-9.716-.094-.068-.587.81.093.067.588-.809Zm0 .809.093-.068-.589-.808-.093.067.59.809ZM13 4.272v8.447h1V4.272h-1Zm-4.846 8.364-.424.28.553.834.424-.281-.553-.833Zm-.647-8.478v9.175h1V4.158h-1Zm5.908 8.323a4.98 4.98 0 0 0-5.261.155l.553.833a3.98 3.98 0 0 1 4.205-.124l.503-.864Zm-.415.238c0-.213.23-.345.415-.238l-.503.864A.724.724 0 0 0 14 12.719h-1Zm.113-8.225A.275.275 0 0 1 13 4.272h1c0-.232-.11-.45-.298-.586l-.59.808Zm-10.024 8.85a3.998 3.998 0 0 1 4.217.125l.552-.834a4.998 4.998 0 0 0-5.271-.155l.502.865Zm5.305-8.85a4.008 4.008 0 0 1 4.719 0l.589-.808a5.008 5.008 0 0 0-5.897 0l.589.808ZM2 12.718c0 .56.606.908 1.09.627l-.503-.865a.275.275 0 0 1 .413.238H2Zm6.207-9.033a5.026 5.026 0 0 0-5.908 0l.588.81a4.026 4.026 0 0 1 4.733 0l.587-.81ZM3 4.273c0 .088-.042.17-.113.221L2.3 3.685a.726.726 0 0 0-.3.588h1Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm12.01 19-.428.616a.75.75 0 0 0 .856 0L12.01 19Zm1.068-.744.429.616-.429-.616Zm-.524-11.623.454.597-.454-.597ZM4 7.16v11.003h1.5V7.16H4Zm6.512 11.713 1.07.743.856-1.232-1.071-.743-.855 1.232ZM12.464 6.45l-.545-.415-.909 1.194.546.415.908-1.194Zm0 1.193.544-.414-.91-1.193-.543.415.91 1.192ZM18.5 7.16v11.006H20V7.159h-1.5Zm-5.85 10.48-1.069.743.857 1.232 1.069-.744-.857-1.231ZM11.26 7.048V19h1.5V7.048h-1.5Zm8.046 10.714a5.68 5.68 0 0 0-6.656-.121l.857 1.231a4.18 4.18 0 0 1 4.898.09l.901-1.2Zm-.806.402c0-.415.474-.651.806-.402l-.901 1.2A.997.997 0 0 0 20 18.164h-1.5Zm.156-10.645a.494.494 0 0 1-.156-.36H20c0-.278-.115-.543-.317-.733l-1.027 1.093ZM5.596 18.962a4.202 4.202 0 0 1 4.916-.09l.855-1.231a5.702 5.702 0 0 0-6.67.12l.899 1.2ZM13.008 7.23a4.374 4.374 0 0 1 5.648.289l1.027-1.093a5.874 5.874 0 0 0-7.584-.389l.91 1.193ZM4 18.163a.998.998 0 0 0 1.596.799l-.9-1.2a.502.502 0 0 1 .804.401H4Zm7.919-12.127a5.895 5.895 0 0 0-7.6.388L5.344 7.52a4.395 4.395 0 0 1 5.667-.29l.908-1.193ZM5.5 7.16a.493.493 0 0 1-.156.36L4.32 6.423c-.204.19-.319.457-.319.736h1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBook };
var IconBranding = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm4 11.5-.593-.145a1.39 1.39 0 0 1-1.005-1.688l1.573-6.192A1.39 1.39 0 0 1 5.663 2.47l6.196 1.58m-.364 8.782H5.338A1.337 1.337 0 0 1 4 11.495V5.338C4 4.6 4.6 4 5.338 4h6.157c.739 0 1.338.6 1.338 1.338v6.157c0 .739-.599 1.338-1.338 1.338Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M11.333 7a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm6.69 5.397-.056.22a2.745 2.745 0 0 1 1.374-.367h3.52L8.31 4.433a1.332 1.332 0 0 0-1.62.964Zm-2.36 9.288.92-3.62v5.229a1.334 1.334 0 0 1-.92-1.609Zm.595 3.075.394.1A2.759 2.759 0 0 0 8.008 20h9.234A2.758 2.758 0 0 0 20 17.242V8.008a2.76 2.76 0 0 0-1.891-2.62.755.755 0 0 0-.141-.05l-9.289-2.36a2.834 2.834 0 0 0-3.443 2.05l-2.36 9.288a2.834 2.834 0 0 0 2.05 3.444ZM8.008 6.75c-.695 0-1.258.563-1.258 1.258v9.234c0 .695.563 1.258 1.258 1.258h9.234c.695 0 1.258-.563 1.258-1.258V8.008c0-.695-.563-1.258-1.258-1.258H8.008ZM18 9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconBranding };
var IconCardLandscape = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.167 5.833C2.167 4.821 2.987 4 4 4h8c1.012 0 1.833.82 1.833 1.833v4.334c0 1.012-.82 1.833-1.833 1.833H4a1.833 1.833 0 0 1-1.833-1.833V5.833ZM4 5a.833.833 0 0 0-.833.833v4.334c0 .46.373.833.833.833h8c.46 0 .833-.373.833-.833V5.833A.833.833 0 0 0 12 5H4Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.25 8.75A2.75 2.75 0 0 1 6 6h12a2.75 2.75 0 0 1 2.75 2.75v6.5A2.75 2.75 0 0 1 18 18H6a2.75 2.75 0 0 1-2.75-2.75v-6.5ZM6 7.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H6Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardLandscape };
var IconCardPortrait = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.167 3.833C4.167 2.821 4.987 2 6 2h4c1.012 0 1.833.82 1.833 1.833v8.334c0 1.012-.82 1.833-1.833 1.833H6a1.833 1.833 0 0 1-1.833-1.833V3.833ZM6 3a.833.833 0 0 0-.833.833v8.334c0 .46.373.833.833.833h4c.46 0 .833-.373.833-.833V3.833A.833.833 0 0 0 10 3H6Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.25 5.75A2.75 2.75 0 0 1 9 3h6a2.75 2.75 0 0 1 2.75 2.75v12.5A2.75 2.75 0 0 1 15 21H9a2.75 2.75 0 0 1-2.75-2.75V5.75ZM9 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h6c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25H9Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardPortrait };
var IconCardSize = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.917 9.417v-5.5h6.833v5.5H5.917Zm-.212-7c-.57 0-1.288.406-1.288 1.194v3.806H3.039c-.57 0-1.289.406-1.289 1.194v3.778c0 .788.718 1.194 1.289 1.194h4.589c.57 0 1.289-.406 1.289-1.194v-1.472h4.044c.57 0 1.289-.407 1.289-1.195v-6.11c0-.79-.718-1.195-1.289-1.195H5.705Zm1.712 8.5H5.705c-.57 0-1.288-.407-1.288-1.195v-.805H3.25v3.166h4.167v-1.166Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 14.492V5.508a.212.212 0 0 1 .058-.008h10.884c.024 0 .043.003.058.008v8.984a.208.208 0 0 1-.058.008H8.558a.208.208 0 0 1-.058-.008ZM8.558 4C7.84 4 7 4.506 7 5.417V11.5H4.558C3.84 11.5 3 12.006 3 12.917v5.666C3 19.494 3.839 20 4.558 20h6.884C12.16 20 13 19.494 13 18.583V16h6.442C20.16 16 21 15.494 21 14.583V5.417C21 4.506 20.16 4 19.442 4H8.558ZM11.5 16H8.558C7.84 16 7 15.494 7 14.583V13H4.558a.208.208 0 0 0-.058.008v5.484a.208.208 0 0 0 .058.008h6.884a.208.208 0 0 0 .058-.008V16Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardSize };
var IconCardSquare = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 3.875C2 2.839 2.84 2 3.875 2h8.25C13.161 2 14 2.84 14 3.875v8.25C14 13.161 13.16 14 12.125 14h-8.25A1.875 1.875 0 0 1 2 12.125v-8.25ZM3.875 3A.875.875 0 0 0 3 3.875v8.25c0 .483.392.875.875.875h8.25a.875.875 0 0 0 .875-.875v-8.25A.875.875 0 0 0 12.125 3h-8.25Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 5.813A2.813 2.813 0 0 1 5.813 3h12.375A2.813 2.813 0 0 1 21 5.813v12.375A2.813 2.813 0 0 1 18.187 21H5.813A2.813 2.813 0 0 1 3 18.187V5.813ZM5.813 4.5c-.725 0-1.313.588-1.313 1.313v12.375c0 .724.588 1.312 1.313 1.312h12.375c.724 0 1.312-.588 1.312-1.313V5.813c0-.724-.588-1.312-1.313-1.312H5.813Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCardSquare };
var IconCard = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.861 4.75a.889.889 0 0 0-.889.889v.417H13v-.417a.889.889 0 0 0-.889-.889h-8.25Zm-.889 5.611V6.89H13v3.472a.89.89 0 0 1-.889.889h-8.25a.89.89 0 0 1-.889-.889Zm-1-4.722a1.89 1.89 0 0 1 1.89-1.889h8.25A1.89 1.89 0 0 1 14 5.639v4.722a1.889 1.889 0 0 1-1.889 1.889h-8.25a1.889 1.889 0 0 1-1.889-1.889V5.64Zm8.111 3.75a.417.417 0 1 0 0 .833h1.667a.417.417 0 1 0 0-.833h-1.667Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.292 7a1.33 1.33 0 0 0-1.334 1.33V9.5H19V8.33A1.33 1.33 0 0 0 17.667 7H6.292Zm-1.334 8.66V11H19v4.66c0 .74-.6 1.34-1.333 1.34H6.292a1.34 1.34 0 0 1-1.334-1.34Zm-1.5-7.33A2.83 2.83 0 0 1 6.292 5.5h11.375A2.83 2.83 0 0 1 20.5 8.33v7.33a2.84 2.84 0 0 1-2.833 2.84H6.292a2.84 2.84 0 0 1-2.834-2.84V8.33ZM14.5 13.5a.75.75 0 0 0 0 1.5h2.25a.75.75 0 0 0 0-1.5H14.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCard };
var IconCardThumbnail = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 4.944a.61.61 0 0 1 .611-.61h8.778a.61.61 0 0 1 .611.61v6.112a.611.611 0 0 1-.611.61H3.61a.611.611 0 0 1-.611-.61V4.944Zm.611-1.61c-.89 0-1.611.72-1.611 1.61v6.112c0 .89.721 1.61 1.611 1.61h8.778c.89 0 1.611-.72 1.611-1.61V4.944c0-.89-.721-1.61-1.611-1.61H3.61Zm1.056 2a.333.333 0 0 0-.334.333v2.666c0 .184.15.334.334.334h6.666c.184 0 .334-.15.334-.334V5.667a.333.333 0 0 0-.334-.334H4.667Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M4.833 10.167h2.334',
      stroke: 'currentColor',
      strokeLinecap: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 7.417c0-.507.41-.917.917-.917h13.166c.507 0 .917.41.917.917v9.166c0 .507-.41.917-.917.917H5.417a.917.917 0 0 1-.917-.917V7.417ZM5.417 5A2.417 2.417 0 0 0 3 7.417v9.166A2.417 2.417 0 0 0 5.417 19h13.166A2.417 2.417 0 0 0 21 16.583V7.417A2.417 2.417 0 0 0 18.583 5H5.417ZM7 8a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-4A.5.5 0 0 0 17 8H7Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M7.25 15.25h3.5',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round'
    }));
  }
});
export { IconCardThumbnail };
var IconChatBubble = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 2.667a5.333 5.333 0 0 0-4.659 7.925l-.663 2.375a.288.288 0 0 0 .355.355l2.376-.663A5.333 5.333 0 1 0 8 2.666Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '5.833',
      cy: '8',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '8',
      cy: '8',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '10.167',
      cy: '8',
      r: '.667',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.25a8.75 8.75 0 0 0-7.791 12.727l-.914 3.272a1.182 1.182 0 0 0 1.456 1.457l3.275-.914A8.75 8.75 0 1 0 12 3.25ZM4.75 12A7.25 7.25 0 1 1 12 19.25a7.211 7.211 0 0 1-3.521-.916.75.75 0 0 0-.567-.067l-3.021.843.843-3.02a.75.75 0 0 0-.067-.567A7.207 7.207 0 0 1 4.75 12Zm4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.25 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChatBubble };
var IconCheckCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167Zm2.437 4.937a.5.5 0 0 0-.707-.708L7.306 8.821 6.27 7.785a.5.5 0 1 0-.707.707l1.389 1.39a.5.5 0 0 0 .707 0l2.778-2.778Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm3.655 7.405a.75.75 0 1 0-1.06-1.06l-3.637 3.636-1.553-1.553a.75.75 0 1 0-1.06 1.06l2.083 2.084a.75.75 0 0 0 1.06 0l4.167-4.167Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCheckCircle };
var IconCheckmark = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm3.583 8.417 3.334 3.333 5.5-7.5',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm5.375 12.625 5 5 8.25-11.25',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconCheckmark };
var IconCheckbox = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.333 4.382c0-.947-.768-1.715-1.715-1.715H4.382c-.947 0-1.715.768-1.715 1.715v7.236c0 .947.768 1.715 1.715 1.715h7.236c.947 0 1.715-.768 1.715-1.715V4.382Zm-1.715-.715c.395 0 .715.32.715.715v7.236c0 .395-.32.715-.715.715H4.382a.715.715 0 0 1-.715-.715V4.382c0-.395.32-.715.715-.715h7.236Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm5.792 8.208 1.666 1.667 2.75-3.75',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20 6.573A2.573 2.573 0 0 0 17.427 4H6.573A2.573 2.573 0 0 0 4 6.573v10.854A2.573 2.573 0 0 0 6.573 20h10.854A2.573 2.573 0 0 0 20 17.427V6.573ZM17.427 5.5c.593 0 1.073.48 1.073 1.073v10.854c0 .593-.48 1.073-1.073 1.073H6.573c-.593 0-1.073-.48-1.073-1.073V6.573c0-.593.48-1.073 1.073-1.073h10.854Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('g', {
      clipPath: 'url(#a)'
    }, /*#__PURE__*/React.createElement('path', {
      d: 'm8.688 12.313 2.5 2.5 4.124-5.626',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })), /*#__PURE__*/React.createElement('defs', {}, /*#__PURE__*/React.createElement('clipPath', {
      id: 'a'
    }, /*#__PURE__*/React.createElement('path', {
      fill: 'currentColor',
      transform: 'translate(7 7)',
      d: 'M0 0h10v10H0z'
    }))));
  }
});
export { IconCheckbox };
var IconChevronDown = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.47 10.28a.75.75 0 0 0 1.06 0l3.502-3.502a.75.75 0 1 0-1.06-1.06L8 8.689 5.028 5.718a.75.75 0 0 0-1.06 1.06L7.47 10.28Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.75 15.5a.75.75 0 0 1-.53-.22l-5.5-5.5a.75.75 0 0 1 1.06-1.06l4.97 4.97 4.97-4.97a.75.75 0 1 1 1.06 1.06l-5.5 5.5a.75.75 0 0 1-.53.22Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronDown };
var IconChevronRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.5 8a.75.75 0 0 0-.22-.53l-3.5-3.5a.75.75 0 0 0-1.06 1.06L8.69 8l-2.97 2.97a.75.75 0 1 0 1.06 1.06l3.5-3.5A.75.75 0 0 0 10.5 8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.28 11.47a.75.75 0 0 1 0 1.06l-5.5 5.5a.75.75 0 0 1-1.06-1.06L13.69 12 8.72 7.03a.75.75 0 0 1 1.06-1.06l5.5 5.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronRight };
var IconChevronLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 8a.75.75 0 0 1 .22-.53l3.5-3.5a.75.75 0 1 1 1.06 1.06L7.31 8l2.97 2.97a.75.75 0 1 1-1.06 1.06l-3.5-3.5A.75.75 0 0 1 5.5 8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 12a.75.75 0 0 1 .22-.53l5.5-5.5a.75.75 0 1 1 1.06 1.06L10.31 12l4.97 4.97a.75.75 0 1 1-1.06 1.06l-5.5-5.5A.75.75 0 0 1 8.5 12Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronLeft };
var IconChevronUp = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.47 5.718a.75.75 0 0 1 1.06 0l3.502 3.502a.75.75 0 1 1-1.06 1.06L8 7.31l-2.972 2.97a.75.75 0 0 1-1.06-1.06L7.47 5.718Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.72 8.72a.75.75 0 0 1 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06l-4.97-4.97-4.97 4.97a.75.75 0 0 1-1.06-1.06l5.5-5.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronUp };
var IconChevronUpDown = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.5 6.5 8 3.81l3.5 2.69m0 3L8 12.19 4.5 9.5',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.793 10.345a.75.75 0 1 0 .914-1.19l-5.25-4.035a.75.75 0 0 0-.914 0l-5.25 4.035a.75.75 0 1 0 .914 1.19L12 6.66l4.793 3.685Zm-9.586 3.31a.75.75 0 0 0-.914 1.19l5.25 4.036a.75.75 0 0 0 .914 0l5.25-4.036a.75.75 0 1 0-.914-1.19L12 17.34l-4.793-3.685Z',
      fill: 'currentColor'
    }));
  }
});
export { IconChevronUpDown };
var IconCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 13.333A5.333 5.333 0 1 0 8 2.667a5.333 5.333 0 0 0 0 10.666Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconCircle };
var IconClock = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.417 8a4.583 4.583 0 1 1 9.166 0 4.583 4.583 0 0 1-9.166 0ZM8 1.917a6.083 6.083 0 1 0 0 12.166A6.083 6.083 0 0 0 8 1.917Zm.75 3.25a.75.75 0 1 0-1.5 0V8.5c0 .414.336.75.75.75h2.167a.75.75 0 0 0 0-1.5H8.75V5.167Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm.75 4.5a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h3.25a.75.75 0 0 0 0-1.5h-2.5V7.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconClock };
var IconCloud = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.383 5.588C4.933 4.371 6.176 3.25 8 3.25c2.011 0 3.663 1.452 4.111 3.572a4.006 4.006 0 0 1 1.446.653c.643.469 1.193 1.212 1.193 2.22 0 1.982-1.816 3.055-3.39 3.055H5.12c-.995 0-1.95-.41-2.656-1.045-.706-.636-1.214-1.545-1.214-2.576 0-1.925 1.582-3.198 3.133-3.541ZM8 4.75c-1.265 0-2.084.857-2.356 1.731a.75.75 0 0 1-.643.524C3.804 7.123 2.75 8.032 2.75 9.13c0 .523.26 1.05.718 1.46.458.412 1.063.661 1.652.661h6.24c1.066 0 1.89-.69 1.89-1.556 0-.4-.206-.737-.577-1.008a2.48 2.48 0 0 0-1.255-.455.75.75 0 0 1-.708-.673C10.53 5.778 9.313 4.75 8 4.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.735 9.181C8.36 7.708 9.822 6.32 12 6.32c2.39 0 4.345 1.782 4.837 4.376a4.654 4.654 0 0 1 1.792.801c.749.559 1.37 1.427 1.37 2.591 0 2.302-2.075 3.592-3.94 3.592H8.52c-1.164 0-2.283-.49-3.11-1.249C4.583 15.672 4 14.597 4 13.392c0-2.288 1.88-3.825 3.735-4.21ZM12 7.82c-1.6 0-2.646 1.11-2.995 2.252a.75.75 0 0 1-.642.528c-1.484.15-2.863 1.31-2.863 2.792 0 .709.345 1.403.924 1.934.58.532 1.346.854 2.096.854h7.54c1.326 0 2.44-.882 2.44-2.092 0-.57-.291-1.033-.768-1.388a3.103 3.103 0 0 0-1.595-.589.75.75 0 0 1-.707-.675C15.203 9.154 13.665 7.82 12 7.82Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCloud };
var IconCollapse = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.167 6.667a.5.5 0 0 1-.354-.147L6.146 4.854a.5.5 0 1 1 .708-.708L8.167 5.46 9.48 4.146a.5.5 0 0 1 .707.708L8.52 6.52a.5.5 0 0 1-.353.147Zm0 2.666a.5.5 0 0 0-.354.147l-1.667 1.666a.5.5 0 1 0 .708.708l1.313-1.313 1.313 1.313a.5.5 0 0 0 .707-.707L8.52 9.48a.5.5 0 0 0-.353-.147Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.25 10a.75.75 0 0 1-.53-.22l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.97 1.97 1.97-1.97a.75.75 0 1 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-.53.22Zm0 4a.75.75 0 0 0-.53.22l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.97-1.97 1.97 1.97a.75.75 0 1 0 1.06-1.06l-2.5-2.5a.75.75 0 0 0-.53-.22Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCollapse };
var IconCollections = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.333 2.167c-1.196 0-2.166.97-2.166 2.166v7.334c0 1.196.97 2.166 2.166 2.166h7.334c1.196 0 2.166-.97 2.166-2.166V4.333c0-1.196-.97-2.166-2.166-2.166H4.333ZM3.167 4.333c0-.644.522-1.166 1.166-1.166H7.5v2.666H3.167v-1.5Zm0 2.5H7.5v6H4.333a1.167 1.167 0 0 1-1.166-1.166V6.833Zm5.333 6h3.167c.644 0 1.166-.522 1.166-1.166v-1.5H8.5v2.666Zm0-3.666v-6h3.167c.644 0 1.166.522 1.166 1.166v4.834H8.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 5.5H17A1.5 1.5 0 0 1 18.5 7v6.75h-5.75V5.5Zm0 9.75v3.25H17a1.5 1.5 0 0 0 1.5-1.5v-1.75h-5.75Zm7.25 0V17a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8.25ZM5.5 17v-6.75h5.75v8.25H7A1.5 1.5 0 0 1 5.5 17Zm5.75-11.5v3.25H5.5V7A1.5 1.5 0 0 1 7 5.5h4.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCollections };
var IconCommand = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.333 4.382c0-.947-.768-1.715-1.715-1.715H4.382c-.947 0-1.715.768-1.715 1.715v7.236c0 .947.768 1.715 1.715 1.715h7.236c.947 0 1.715-.768 1.715-1.715V4.382Zm-1.715-.715c.395 0 .715.32.715.715v7.236c0 .395-.32.715-.715.715H4.382a.715.715 0 0 1-.715-.715V4.382c0-.395.32-.715.715-.715h7.236Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.5 8a.5.5 0 0 1-.276.447l-4 2a.5.5 0 1 1-.448-.894L8.882 8 5.776 6.447a.5.5 0 0 1 .448-.894l4 2A.5.5 0 0 1 10.5 8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573Zm-3.165 6.098a.75.75 0 0 0 0-1.342l-6-3a.75.75 0 0 0-.67 1.342L13.323 12l-4.658 2.33a.75.75 0 1 0 .67 1.34l6-3Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCommand };
var IconCommentReplyRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 2.667a5.333 5.333 0 0 0-4.659 7.925l-.663 2.375a.288.288 0 0 0 .355.355l2.376-.663A5.333 5.333 0 1 0 8 2.666Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8.972 6.333 10.64 8 8.972 9.667',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M5.361 8H10.5',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8.042 12h7.708m-2.292-2.5 2.5 2.5-2.5 2.5M12 4a8 8 0 0 0-8 8c0 1.412.37 2.737 1.012 3.889l-.995 3.562a.432.432 0 0 0 .533.532l3.564-.994A8 8 0 1 0 12 4Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconCommentReplyRight };
var IconCommentReply = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 2.667a5.333 5.333 0 0 0-4.659 7.925l-.663 2.375a.288.288 0 0 0 .355.355l2.376-.663A5.333 5.333 0 1 0 8 2.666Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8.972 6.333 10.64 8 8.972 9.667',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M5.361 8H10.5',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8.042 12h7.708m-2.292-2.5 2.5 2.5-2.5 2.5M12 4a8 8 0 0 0-8 8c0 1.412.37 2.737 1.012 3.889l-.995 3.562a.432.432 0 0 0 .533.532l3.564-.994A8 8 0 1 0 12 4Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconCommentReply };
var IconCommentReplyUp = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 2.667a5.333 5.333 0 0 0-4.659 7.925l-.663 2.375a.288.288 0 0 0 .355.355l2.376-.663A5.333 5.333 0 1 0 8 2.666Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8 10.639V5.5M6.333 7.028 8 5.36l1.667 1.667',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12 4a8 8 0 0 0-8 8c0 1.412.37 2.737 1.012 3.889l-.995 3.562a.432.432 0 0 0 .533.532l3.564-.994A8 8 0 1 0 12 4Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M12 15.958V8.25m-2.5 2.292 2.5-2.5 2.5 2.5',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconCommentReplyUp };
var IconComposeArrow = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.975 5.651H6.468a.5.5 0 0 1 0-1h4.714a.5.5 0 0 1 .5.5v4.714a.5.5 0 0 1-1 0V6.358l-5.51 5.51a.5.5 0 0 1-.708-.706l5.51-5.51Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.962 8.477h-5.26a.75.75 0 0 1 0-1.5h7.07a.75.75 0 0 1 .75.75v7.071a.75.75 0 0 1-1.5 0v-5.26l-8.265 8.265a.75.75 0 1 1-1.06-1.06l8.265-8.266Z',
      fill: 'currentColor'
    }));
  }
});
export { IconComposeArrow };
var IconComposeDraw = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm6.532 6.667 1.05-3.13a.333.333 0 0 1 .632 0l1.05 3.13h.341a.5.5 0 0 1 .49.4l1.024 4.987a.5.5 0 1 1-.98.201l-.942-4.588H6.6l-.942 4.588a.5.5 0 1 1-.98-.201l1.024-4.988a.5.5 0 0 1 .49-.4h.341Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm9.799 10 1.574-4.694a.5.5 0 0 1 .948 0L13.895 10h.513a.75.75 0 0 1 .734.6l1.537 7.48a.75.75 0 1 1-1.47.303L13.796 11.5H9.898l-1.413 6.883a.75.75 0 1 1-1.47-.302l1.537-7.482A.75.75 0 0 1 9.286 10H9.8Z',
      fill: 'currentColor'
    }));
  }
});
export { IconComposeDraw };
var IconComposeEmoji = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 2a.25.25 0 0 1 .25.25v1.5h1.5a.25.25 0 0 1 0 .5h-1.5v1.5a.25.25 0 0 1-.5 0v-1.5h-1.5a.25.25 0 1 1 0-.5h1.5v-1.5A.25.25 0 0 1 12 2ZM8 3.167A4.833 4.833 0 1 0 12.833 8a.5.5 0 0 1 1 0A5.833 5.833 0 1 1 8 2.167a.5.5 0 1 1 0 1ZM5.453 9.2a.417.417 0 0 1 .586.07A2.489 2.489 0 0 0 8 10.222c.795 0 1.504-.37 1.961-.952a.417.417 0 0 1 .655.515A3.322 3.322 0 0 1 8 11.055a3.322 3.322 0 0 1-2.616-1.27.417.417 0 0 1 .07-.585Zm1.575-2.589a.694.694 0 1 1-1.39 0 .694.694 0 0 1 1.39 0Zm2.639.695a.695.695 0 1 0 0-1.39.695.695 0 0 0 0 1.39Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18 3c.207 0 .375.168.375.375v2.25h2.25a.375.375 0 0 1 0 .75h-2.25v2.25a.375.375 0 0 1-.75 0v-2.25h-2.25a.375.375 0 0 1 0-.75h2.25v-2.25c0-.207.168-.375.375-.375Zm-6 1.75A7.25 7.25 0 1 0 19.25 12a.75.75 0 0 1 1.5 0A8.75 8.75 0 1 1 12 3.25a.75.75 0 0 1 0 1.5ZM8.18 13.8a.625.625 0 0 1 .878.105A3.733 3.733 0 0 0 12 15.333a3.733 3.733 0 0 0 2.942-1.428.625.625 0 1 1 .982.773A4.983 4.983 0 0 1 12 16.583c-1.59 0-3.01-.743-3.925-1.905a.625.625 0 0 1 .105-.878Zm2.362-3.883a1.042 1.042 0 1 1-2.084 0 1.042 1.042 0 0 1 2.084 0Zm3.958 1.041a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083Z',
      fill: 'currentColor'
    }));
  }
});
export { IconComposeEmoji };
var IconComposeLine = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm3.833 12.167 8.334-8.334',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm5.75 18.25 12.5-12.5',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconComposeLine };
var IconComposeRectangle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3.833 11.125v-6.25c0-.575.363-1.042.81-1.042h6.714c.447 0 .81.467.81 1.042v6.25c0 .575-.363 1.042-.81 1.042H4.644c-.448 0-.81-.467-.81-1.042Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M5.75 16.688V7.313c0-.863.544-1.563 1.215-1.563h10.07c.67 0 1.215.7 1.215 1.563v9.375c0 .862-.544 1.562-1.215 1.562H6.965c-.67 0-1.215-.7-1.215-1.563Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconComposeRectangle };
var IconCompressed = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.167 4.167a2 2 0 0 1 2-2h7.666a2 2 0 0 1 2 2v7.666a2 2 0 0 1-2 2H4.167a2 2 0 0 1-2-2V4.167Zm2-1a1 1 0 0 0-1 1v7.666a1 1 0 0 0 1 1h7.666a1 1 0 0 0 1-1V4.167a1 1 0 0 0-1-1H8.5v.5H9a.5.5 0 0 1 0 1h-.5v.666H9a.5.5 0 0 1 0 1h-.5V7H9a.5.5 0 0 1 0 1h-.5v1h.186c.119 0 .222.082.249.197l.353 1.513a1.323 1.323 0 1 1-2.576 0l.353-1.513A.256.256 0 0 1 7.314 9H7.5V8H7a.5.5 0 0 1 0-1h.5v-.667H7a.5.5 0 1 1 0-1h.5v-.666H7a.5.5 0 0 1 0-1h.5v-.5H4.167ZM8.667 11a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17 5.5h-4.265v1.25h.75a.75.75 0 1 1 0 1.5h-.75v1h.75a.75.75 0 1 1 0 1.5h-.75v1.5h.279c.178 0 .333.123.373.296l.53 2.27a1.984 1.984 0 1 1-3.864 0l.53-2.27a.383.383 0 0 1 .373-.296h.279v-1.5h-.75a.75.75 0 0 1 0-1.5h.75v-1h-.75a.75.75 0 0 1 0-1.5h.75V5.5H7A1.5 1.5 0 0 0 5.5 7v10A1.5 1.5 0 0 0 7 18.5h10a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 17 5.5ZM7 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5.985 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCompressed };
var IconConnectedApps = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.75 3.528a.5.5 0 0 1 .5-.5h2.778a.5.5 0 0 1 .5.5V4.86h.944V3.528a.5.5 0 0 1 .5-.5h2.778a.5.5 0 0 1 .5.5v1.348a1.612 1.612 0 0 1 1.389 1.596v4.722c0 .89-.721 1.612-1.611 1.612H3.972a1.61 1.61 0 0 1-1.61-1.611V6.471c0-.814.603-1.487 1.388-1.596V3.528Zm7.5 1.333v-.833H9.472v.833h1.778Zm-4.722-.833v.833H4.75v-.833h1.778ZM3.972 5.86a.611.611 0 0 0-.61.611v4.722a.61.61 0 0 0 .61.612h8.056a.611.611 0 0 0 .61-.611V6.471a.611.611 0 0 0-.61-.61H3.972Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.625 5.292a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75v2h1.416v-2a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75v2.023a2.417 2.417 0 0 1 2.083 2.393v7.084a2.417 2.417 0 0 1-2.416 2.416H5.958a2.417 2.417 0 0 1-2.416-2.416V9.708c0-1.221.906-2.231 2.083-2.393V5.292Zm11.25 2v-1.25h-2.667v1.25h2.667Zm-7.083-1.25v1.25H7.125v-1.25h2.667Zm-3.834 2.75a.917.917 0 0 0-.916.916v7.084c0 .506.41.916.916.916h12.084c.506 0 .916-.41.916-.916V9.708a.917.917 0 0 0-.916-.916H5.958Z',
      fill: 'currentColor'
    }));
  }
});
export { IconConnectedApps };
var IconCopy = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.363 2.71c-1.04 0-1.883.843-1.883 1.883v4.234c0 1.04.843 1.883 1.883 1.883h.99v.7c0 1.04.843 1.883 1.883 1.883h6.4c1.04 0 1.883-.843 1.883-1.883V7.593c0-1.04-.843-1.883-1.883-1.883h-1.117V4.593c0-1.04-.843-1.883-1.883-1.883H3.363Zm6.656 3V4.593a.383.383 0 0 0-.383-.383H3.363a.383.383 0 0 0-.383.383v4.234c0 .211.172.383.383.383h.99V7.593c0-1.04.843-1.883 1.883-1.883h3.783ZM5.853 9.96v1.45c0 .212.171.383.383.383h6.4a.383.383 0 0 0 .383-.383V7.593a.383.383 0 0 0-.383-.383h-6.4a.383.383 0 0 0-.383.383V9.96Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.45 5.5A2.45 2.45 0 0 0 4 7.95v5.1a2.45 2.45 0 0 0 2.45 2.45H7v.55a2.45 2.45 0 0 0 2.45 2.45h8.1A2.45 2.45 0 0 0 20 16.05v-5.1a2.45 2.45 0 0 0-2.45-2.45H17v-.55a2.45 2.45 0 0 0-2.45-2.45h-8.1Zm9.05 3v-.55a.95.95 0 0 0-.95-.95h-8.1a.95.95 0 0 0-.95.95v5.1c0 .525.425.95.95.95H7v-3.05A2.45 2.45 0 0 1 9.45 8.5h6.05Zm-7 6.25v1.3c0 .525.425.95.95.95h8.1a.95.95 0 0 0 .95-.95v-5.1a.95.95 0 0 0-.95-.95h-8.1a.95.95 0 0 0-.95.95v3.8Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCopy };
var IconCustomFieldAssignee = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.833 1.083a3.75 3.75 0 0 0-3.75 3.75v6.334a3.75 3.75 0 0 0 3.75 3.75h6.334a3.75 3.75 0 0 0 3.75-3.75V4.833a3.75 3.75 0 0 0-3.75-3.75H4.833Zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h6.334a2.25 2.25 0 0 1 2.25 2.25v6.334a2.25 2.25 0 0 1-1.428 2.095c-.218-.848-.745-1.546-1.507-2.015-.683-.42-1.51-.633-2.382-.633-.858 0-1.705.222-2.383.643-.77.476-1.3 1.183-1.514 2.039a1.18 1.18 0 0 0-.007.03 2.25 2.25 0 0 1-1.613-2.16V4.834Zm4.18 1.427a1.912 1.912 0 0 0-.495 1.451c.034.482.227.945.559 1.302.34.364.81.599 1.332.599a1.82 1.82 0 0 0 1.331-.6c.332-.356.524-.82.559-1.3a1.91 1.91 0 0 0-.496-1.45 1.888 1.888 0 0 0-1.394-.595c-.523 0-1.028.197-1.397.593Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75Zm11.298 18.401A3.251 3.251 0 0 0 20.5 17.25V6.75a3.25 3.25 0 0 0-3.25-3.25H6.75A3.25 3.25 0 0 0 3.5 6.75v10.5a3.25 3.25 0 0 0 2.756 3.213 1.69 1.69 0 0 1 .048-.52c.32-1.283 1.116-2.343 2.27-3.058 1.019-.63 2.288-.964 3.576-.964 1.308 0 2.548.319 3.573.95 1.16.713 1.956 1.78 2.275 3.077.037.149.053.301.05.453ZM10.143 9.39c-.557.598-.797 1.388-.741 2.177.05.722.34 1.418.838 1.952h.001c.51.547 1.214.899 1.997.899.783 0 1.487-.352 1.997-.9a3.201 3.201 0 0 0 .838-1.95c.057-.79-.187-1.578-.743-2.175a2.833 2.833 0 0 0-2.092-.893 2.83 2.83 0 0 0-2.095.89Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldAssignee };
var IconCustomFieldCalendar = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 1.083A3.417 3.417 0 0 0 1.083 4.5v7A3.417 3.417 0 0 0 4.5 14.917h7a3.417 3.417 0 0 0 3.417-3.417v-7A3.417 3.417 0 0 0 11.5 1.083h-7ZM2.583 4.5c0-1.059.858-1.917 1.917-1.917h7c1.059 0 1.917.858 1.917 1.917v.833H2.583V4.5Zm0 2.333V11.5c0 1.059.858 1.917 1.917 1.917h7a1.917 1.917 0 0 0 1.917-1.917V6.833H2.583Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75ZM3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h10.5a3.25 3.25 0 0 1 3.25 3.25V8h-17V6.75Zm0 2.75v7.75a3.25 3.25 0 0 0 3.25 3.25h10.5a3.25 3.25 0 0 0 3.25-3.25V9.5h-17Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldCalendar };
var IconCustomFieldCheck = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 1.083A3.417 3.417 0 0 0 1.083 4.5v7A3.417 3.417 0 0 0 4.5 14.917h7a3.417 3.417 0 0 0 3.417-3.417v-7A3.417 3.417 0 0 0 11.5 1.083h-7ZM2.583 4.5c0-1.059.858-1.917 1.917-1.917h7c1.059 0 1.917.858 1.917 1.917v7a1.917 1.917 0 0 1-1.917 1.917h-7A1.917 1.917 0 0 1 2.583 11.5v-7Zm8.81 1.998a.75.75 0 1 0-1.12-.996l-2.995 3.37-1.217-1.37a.75.75 0 1 0-1.122.996l1.778 2a.75.75 0 0 0 1.121 0l3.556-4Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75ZM3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h10.5a3.25 3.25 0 0 1 3.25 3.25v10.5a3.25 3.25 0 0 1-3.25 3.25H6.75a3.25 3.25 0 0 1-3.25-3.25V6.75Zm13.31 2.748a.75.75 0 0 0-1.12-.996l-4.773 5.37-2.106-2.37a.75.75 0 0 0-1.122.996l2.667 3a.75.75 0 0 0 1.121 0l5.334-6Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldCheck };
var IconCustomFieldDescription = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.833 1.083a3.75 3.75 0 0 0-3.75 3.75v6.334a3.75 3.75 0 0 0 3.75 3.75h6.334a3.75 3.75 0 0 0 3.75-3.75V4.833a3.75 3.75 0 0 0-3.75-3.75H4.833Zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h6.334a2.25 2.25 0 0 1 2.25 2.25v6.334a2.25 2.25 0 0 1-2.25 2.25H4.833a2.25 2.25 0 0 1-2.25-2.25V4.833Zm2.834 0a.75.75 0 1 0 0 1.5h5.166a.75.75 0 0 0 0-1.5H5.417ZM4.667 8a.75.75 0 0 1 .75-.75h5.166a.75.75 0 0 1 0 1.5H5.417a.75.75 0 0 1-.75-.75Zm.75 1.667a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75ZM3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h10.5a3.25 3.25 0 0 1 3.25 3.25v10.5a3.25 3.25 0 0 1-3.25 3.25H6.75a3.25 3.25 0 0 1-3.25-3.25V6.75ZM7.75 8a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM7 12a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 7 12Zm.75 2.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldDescription };
var IconCustomFieldLink = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.583 4.833a2.25 2.25 0 0 1 2.25-2.25H6.75a.75.75 0 1 0 0-1.5H4.833a3.75 3.75 0 0 0-3.75 3.75v6.334a3.75 3.75 0 0 0 3.75 3.75h6.334a3.75 3.75 0 0 0 3.75-3.75V9.25a.75.75 0 0 0-1.5 0v1.917a2.25 2.25 0 0 1-2.25 2.25H4.833a2.25 2.25 0 0 1-2.25-2.25V4.833Zm6-2.833a.75.75 0 0 1 .75-.75H14a.748.748 0 0 1 .75.75v4.667a.75.75 0 0 1-1.5 0V3.81L8.53 8.53a.75.75 0 0 1-1.06-1.06l4.72-4.72H9.332a.75.75 0 0 1-.75-.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h3.75a.75.75 0 0 0 0-1.5H6.75A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V13.5a.75.75 0 0 0-1.5 0v3.75a3.25 3.25 0 0 1-3.25 3.25H6.75a3.25 3.25 0 0 1-3.25-3.25V6.75ZM14 2.25h7a.748.748 0 0 1 .525.215l.01.01c.133.135.215.32.215.525v7a.75.75 0 0 1-1.5 0V4.81l-7.72 7.72a.75.75 0 1 1-1.06-1.06l7.72-7.72H14a.75.75 0 0 1 0-1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldLink };
var IconCustomFieldNumber = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.833 1.083a3.75 3.75 0 0 0-3.75 3.75v6.334a3.75 3.75 0 0 0 3.75 3.75h6.334a3.75 3.75 0 0 0 3.75-3.75V4.833a3.75 3.75 0 0 0-3.75-3.75H4.833Zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h6.334a2.25 2.25 0 0 1 2.25 2.25v6.334a2.25 2.25 0 0 1-2.25 2.25H4.833a2.25 2.25 0 0 1-2.25-2.25V4.833Zm6.834.236c0-.817-.988-1.226-1.565-.648L6.136 6.136a.75.75 0 1 0 1.061 1.061l.72-.72v4.856a.75.75 0 0 0 1.5 0V5.07Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75ZM3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h10.5a3.25 3.25 0 0 1 3.25 3.25v10.5a3.25 3.25 0 0 1-3.25 3.25H6.75a3.25 3.25 0 0 1-3.25-3.25V6.75Zm10.25.854c0-.891-1.077-1.338-1.707-.708L9.47 9.47a.75.75 0 1 0 1.06 1.06l1.72-1.72V17a.75.75 0 0 0 1.5 0V7.604Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldNumber };
var IconCustomFieldRating = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 1.083A3.417 3.417 0 0 0 1.083 4.5v7A3.417 3.417 0 0 0 4.5 14.917h7a3.417 3.417 0 0 0 3.417-3.417v-7A3.417 3.417 0 0 0 11.5 1.083h-7ZM2.583 4.5c0-1.059.858-1.917 1.917-1.917h7c1.059 0 1.917.858 1.917 1.917v7a1.917 1.917 0 0 1-1.917 1.917h-7A1.917 1.917 0 0 1 2.583 11.5v-7Zm5.399.667c.085 0 .164.048.202.125l.777 1.554 1.845.284a.226.226 0 0 1 .126.384L9.656 8.79l.284 1.848a.226.226 0 0 1-.328.235l-1.63-.85-1.63.85a.226.226 0 0 1-.329-.235l.285-1.848L5.03 7.514a.226.226 0 0 1 .126-.384l1.845-.284.777-1.554a.226.226 0 0 1 .203-.125Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75ZM3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h10.5a3.25 3.25 0 0 1 3.25 3.25v10.5a3.25 3.25 0 0 1-3.25 3.25H6.75a3.25 3.25 0 0 1-3.25-3.25V6.75Zm8.473 1a.34.34 0 0 1 .303.188l1.166 2.332 2.768.425a.34.34 0 0 1 .188.576l-1.915 1.914.427 2.772a.339.339 0 0 1-.493.352l-2.444-1.276-2.445 1.276a.34.34 0 0 1-.493-.352l.427-2.772-1.915-1.914a.34.34 0 0 1 .188-.576l2.768-.425 1.166-2.332a.34.34 0 0 1 .303-.188Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldRating };
var IconCustomFieldSelect = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.833 1.083a3.75 3.75 0 0 0-3.75 3.75v6.334a3.75 3.75 0 0 0 3.75 3.75h6.334a3.75 3.75 0 0 0 3.75-3.75V4.833a3.75 3.75 0 0 0-3.75-3.75H4.833Zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h6.334a2.25 2.25 0 0 1 2.25 2.25v6.334a2.25 2.25 0 0 1-2.25 2.25H4.833a2.25 2.25 0 0 1-2.25-2.25V4.833Zm3.018 1h4.798c.537 0 .854.602.55 1.045l-2.4 3.49a.667.667 0 0 1-1.098 0l-2.4-3.49a.667.667 0 0 1 .55-1.045Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.75 2A4.75 4.75 0 0 0 2 6.75v10.5A4.75 4.75 0 0 0 6.75 22h10.5A4.75 4.75 0 0 0 22 17.25V6.75A4.75 4.75 0 0 0 17.25 2H6.75ZM3.5 6.75A3.25 3.25 0 0 1 6.75 3.5h10.5a3.25 3.25 0 0 1 3.25 3.25v10.5a3.25 3.25 0 0 1-3.25 3.25H6.75a3.25 3.25 0 0 1-3.25-3.25V6.75Zm4.901 2h7.198a1 1 0 0 1 .824 1.566l-3.599 5.235a1 1 0 0 1-1.648 0l-3.599-5.235a1 1 0 0 1 .824-1.566Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldSelect };
var IconCustomFieldText = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.083 4.833a3.75 3.75 0 0 1 3.75-3.75h6.334a3.75 3.75 0 0 1 3.75 3.75v6.334a3.75 3.75 0 0 1-3.75 3.75H4.833a3.75 3.75 0 0 1-3.75-3.75V4.833Zm3.75-2.25a2.25 2.25 0 0 0-2.25 2.25v6.334a2.25 2.25 0 0 0 2.25 2.25h6.334a2.25 2.25 0 0 0 2.25-2.25V4.833a2.25 2.25 0 0 0-2.25-2.25H4.833ZM4.667 6.75a.75.75 0 0 1 .75-.75h5.166a.75.75 0 0 1 0 1.5H5.417a.75.75 0 0 1-.75-.75Zm.75 1.75a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 6.75A4.75 4.75 0 0 1 6.75 2h10.5A4.75 4.75 0 0 1 22 6.75v10.5A4.75 4.75 0 0 1 17.25 22H6.75A4.75 4.75 0 0 1 2 17.25V6.75ZM6.75 3.5A3.25 3.25 0 0 0 3.5 6.75v10.5a3.25 3.25 0 0 0 3.25 3.25h10.5a3.25 3.25 0 0 0 3.25-3.25V6.75a3.25 3.25 0 0 0-3.25-3.25H6.75ZM7 10a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 7 10Zm.75 3.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconCustomFieldText };
var IconDeactivated = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167ZM5.977 9.316a.5.5 0 1 0 .707.707l3.34-3.339a.5.5 0 1 0-.708-.707l-3.34 3.339Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM8.965 13.974a.75.75 0 0 0 1.061 1.06l5.009-5.008a.75.75 0 1 0-1.061-1.06l-5.009 5.008Z',
      fill: 'currentColor'
    }));
  }
});
export { IconDeactivated };
var IconDial = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 12a3.333 3.333 0 1 0 0-6.667A3.333 3.333 0 0 0 8 12Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '8',
      cy: '3.333',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '4.667',
      cy: '4.667',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '2.667',
      cy: '8',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '4',
      cy: '12',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '11.333',
      cy: '4.667',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '13.333',
      cy: '8',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '12',
      cy: '12',
      r: '.667',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8 8.667C7.234 9.426 5.667 11 5.667 11',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 3.75a4.25 4.25 0 0 0-3.49 6.677l.779-.78c.73-.733 1.607-1.609 2.183-2.18a.75.75 0 0 1 1.056 1.066 675.208 675.208 0 0 0-2.957 2.955A4.25 4.25 0 1 0 12 8.75ZM6.25 13a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0ZM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-2 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM18 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconDial };
var IconDownload = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2a.5.5 0 0 1 .5.5v6.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 9.293V2.5A.5.5 0 0 1 8 2Zm-4.833 8a.5.5 0 0 1 .5.5v1c0 .46.373.833.833.833h7c.46 0 .833-.373.833-.833v-1a.5.5 0 1 1 1 0v1c0 1.012-.82 1.833-1.833 1.833h-7A1.833 1.833 0 0 1 2.667 11.5v-1a.5.5 0 0 1 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3a.75.75 0 0 1 .75.75v10.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V3.75A.75.75 0 0 1 12 3ZM4.75 15a.75.75 0 0 1 .75.75v1.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 0 1 1.5 0v1.5A2.75 2.75 0 0 1 17.25 20H6.75A2.75 2.75 0 0 1 4 17.25v-1.5a.75.75 0 0 1 .75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconDownload };
var IconDrag = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.667 6a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM6.333 6a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm0 2.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Zm.667 2a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM10.333 8A.667.667 0 1 1 9 8a.667.667 0 0 1 1.333 0Zm-.666 3.333a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      fill: 'currentColor'
    }));
  }
});
export { IconDrag };
var IconDrink = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.887 2.335a.417.417 0 0 1 .335-.168h1.528a.417.417 0 0 1 0 .833h-1.318l-.27.364c1.115.66 1.866 1.82 1.866 3.164 0 .23-.187.416-.417.416h-.058l-.283 1.858-.26 1.72-.245 1.605c-.112.728-.79 1.207-1.515 1.207h-2.5c-.726 0-1.403-.479-1.515-1.207l-.244-1.605-.261-1.72-.283-1.858H4.39a.417.417 0 0 1-.417-.416c0-2.102 1.835-3.75 4.028-3.75.486 0 .955.08 1.39.23l.497-.673ZM4.838 6.111h6.324c-.22-1.391-1.526-2.5-3.162-2.5s-2.942 1.109-3.162 2.5Zm.452.833.264 1.733.26 1.72L6.06 12c.039.25.3.5.691.5h2.5c.39 0 .653-.25.69-.5l.245-1.604.261-1.72.264-1.733H5.29Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.831 3.503a.625.625 0 0 1 .502-.253h2.292a.625.625 0 1 1 0 1.25h-1.977l-.405.546c1.673.991 2.799 2.73 2.799 4.746 0 .345-.28.625-.625.625h-.088l-.424 2.786-.391 2.58-.367 2.407v.001c-.167 1.092-1.183 1.81-2.272 1.81h-3.75c-1.089 0-2.104-.718-2.272-1.81l-.367-2.408-.391-2.58-.424-2.786h-.088a.625.625 0 0 1-.625-.625c0-3.153 2.753-5.625 6.042-5.625.73 0 1.432.121 2.084.345l.747-1.009ZM7.257 9.167h9.486c-.33-2.087-2.29-3.75-4.743-3.75-2.454 0-4.412 1.663-4.743 3.75Zm.679 1.25.394 2.598.392 2.58.367 2.406c.057.376.45.75 1.036.75h3.75c.586 0 .979-.374 1.036-.75l.367-2.406.392-2.58.394-2.598H7.936Z',
      fill: 'currentColor'
    }));
  }
});
export { IconDrink };
var IconEditCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.167a4.833 4.833 0 1 0 0 9.666 4.833 4.833 0 0 0 0-9.666ZM2.167 8a5.833 5.833 0 1 1 11.666 0A5.833 5.833 0 0 1 2.167 8Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm10.386 6.973-.36.36-1.36-1.358.361-.36a.954.954 0 0 1 .68-.282.962.962 0 0 1 .68 1.64ZM5.92 8.816l2.482-2.483 1.264 1.263-2.483 2.483a.48.48 0 0 1-.19.117l-1.39.46a.207.207 0 0 1-.21-.05.206.206 0 0 1-.05-.21l.46-1.39a.482.482 0 0 1 .117-.19Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM15.038 11l.54-.54a1.443 1.443 0 0 0 0-2.039A1.431 1.431 0 0 0 14.56 8c-.386 0-.748.15-1.02.421l-.54.541L15.038 11Zm-2.433-1.5-3.724 3.724a.723.723 0 0 0-.175.284l-.69 2.086a.309.309 0 0 0 .39.39l2.086-.69a.721.721 0 0 0 .284-.175l3.724-3.724L12.605 9.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEditCircle };
var IconEdit = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.445 4.555a.757.757 0 0 0-1.07 0l-.5.499 1.071 1.07.499-.498a.757.757 0 0 0 0-1.071Zm-1.206 2.277L9.169 5.76 4.988 9.94l-.428 1.499 1.5-.428 4.178-4.18Zm1.913-2.984a1.757 1.757 0 0 0-2.485 0L4.274 9.24a.956.956 0 0 0-.243.414l-.679 2.376a.5.5 0 0 0 .618.618l2.375-.679h.001a.96.96 0 0 0 .413-.243l5.393-5.393a1.757 1.757 0 0 0 0-2.485Zm-7.64 5.944Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.167 6.832a1.136 1.136 0 0 0-1.606 0l-.748.749 1.606 1.606.748-.748a1.136 1.136 0 0 0 0-1.607Zm-1.809 3.416L13.752 8.64l-6.268 6.27-.642 2.25 2.248-.643 6.268-6.268Zm2.87-4.476a2.636 2.636 0 0 0-3.727 0L6.41 13.86a1.434 1.434 0 0 0-.365.62v.001l-1.018 3.562a.75.75 0 0 0 .928.927l3.562-1.017h.001c.234-.067.447-.193.62-.366l8.09-8.087a2.636 2.636 0 0 0 0-3.727Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEdit };
var IconEmoji = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167ZM6.104 9.219a.5.5 0 1 0-.786.618A3.405 3.405 0 0 0 8 11.139a3.405 3.405 0 0 0 2.682-1.302.5.5 0 1 0-.786-.618 2.405 2.405 0 0 1-1.896.92 2.405 2.405 0 0 1-1.896-.92Zm.23-1.913a.694.694 0 1 0 0-1.39.694.694 0 0 0 0 1.39Zm4.027-.695a.694.694 0 1 1-1.389 0 .694.694 0 0 1 1.39 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM9.156 13.828a.75.75 0 1 0-1.179.927A5.108 5.108 0 0 0 12 16.708c1.63 0 3.086-.762 4.023-1.953a.75.75 0 1 0-1.18-.927A3.608 3.608 0 0 1 12 15.208a3.608 3.608 0 0 1-2.844-1.38Zm.344-2.87a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083Zm6.042-1.041a1.042 1.042 0 1 1-2.084 0 1.042 1.042 0 0 1 2.084 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEmoji };
var IconError = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.333 2.167a.5.5 0 0 0-.353.146L2.313 4.98a.5.5 0 0 0-.146.353v5.334a.5.5 0 0 0 .146.353l2.667 2.667a.5.5 0 0 0 .353.146h5.334a.5.5 0 0 0 .353-.146l2.667-2.667a.5.5 0 0 0 .146-.353V5.333a.5.5 0 0 0-.146-.353L11.02 2.313a.5.5 0 0 0-.353-.146H5.333ZM3.167 5.54 5.54 3.167h4.92l2.373 2.373v4.92l-2.373 2.373H5.54L3.167 10.46V5.54Zm2.901.528a.375.375 0 0 1 .53 0L8 7.47l1.402-1.402a.375.375 0 1 1 .53.53L8.53 8l1.402 1.401a.375.375 0 1 1-.53.53L8 8.532l-1.402 1.4a.375.375 0 1 1-.53-.53L7.47 8 6.068 6.598a.375.375 0 0 1 0-.53Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.25a.75.75 0 0 0-.53.22l-4 4a.75.75 0 0 0-.22.53v8c0 .199.079.39.22.53l4 4c.14.141.331.22.53.22h8a.75.75 0 0 0 .53-.22l4-4a.75.75 0 0 0 .22-.53V8a.75.75 0 0 0-.22-.53l-4-4a.75.75 0 0 0-.53-.22H8ZM4.75 8.31l3.56-3.56h7.38l3.56 3.56v7.38l-3.56 3.56H8.31l-3.56-3.56V8.31Zm4.352.792c.22-.22.576-.22.796 0L12 11.204l2.102-2.102a.563.563 0 0 1 .796.796L12.796 12l2.102 2.102a.563.563 0 0 1-.796.796L12 12.796l-2.102 2.102a.563.563 0 0 1-.796-.796L11.204 12 9.102 9.898a.563.563 0 0 1 0-.796Z',
      fill: 'currentColor'
    }));
  }
});
export { IconError };
var IconExpand = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.167 12a.5.5 0 0 0 .353-.146l1.667-1.667a.5.5 0 1 0-.707-.707l-1.313 1.313L6.854 9.48a.5.5 0 1 0-.708.707l1.667 1.667a.5.5 0 0 0 .354.146Zm0-8a.5.5 0 0 1 .353.146l1.667 1.667a.5.5 0 1 1-.707.707L8.167 5.207 6.854 6.52a.5.5 0 1 1-.708-.707l1.667-1.667A.5.5 0 0 1 8.167 4Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.25 18a.75.75 0 0 0 .53-.22l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.97 1.97-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.14.141.331.22.53.22Zm0-12a.75.75 0 0 1 .53.22l2.5 2.5a.75.75 0 0 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 .53-.22Z',
      fill: 'currentColor'
    }));
  }
});
export { IconExpand };
var IconExport = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.682 6.025 8.02 8.687a.5.5 0 0 1-.707-.707l2.662-2.662H6.468a.5.5 0 1 1 0-1h4.714a.5.5 0 0 1 .5.5v4.714a.5.5 0 0 1-1 0V6.025Zm-5.849 5.641a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.9-1.9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.962 7.977h-5.26a.75.75 0 1 1 0-1.5h7.071a.75.75 0 0 1 .75.75v7.071a.75.75 0 0 1-1.5 0v-5.26L12.03 13.03a.75.75 0 1 1-1.06-1.06l3.992-3.993ZM7.25 17.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2.85-2.85a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconExport };
var IconEyeSlash = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.48 4.187a.5.5 0 0 1 .707-.707l8.333 8.333a.5.5 0 1 1-.707.707L3.48 4.187Zm-1.193 3.53a8.962 8.962 0 0 1 1.94-2.075l.715.714A7.652 7.652 0 0 0 3.313 8c1.36 1.832 3.05 2.696 4.687 2.696.38 0 .761-.046 1.141-.14l.803.802A5.811 5.811 0 0 1 8 11.696c-2.118 0-4.178-1.178-5.713-3.413a.5.5 0 0 1 0-.566Zm3.769-3.075.803.802c.38-.094.762-.14 1.141-.14 1.637 0 3.327.864 4.687 2.696a7.65 7.65 0 0 1-1.63 1.644l.715.714c.705-.536 1.36-1.23 1.941-2.075a.5.5 0 0 0 0-.566C12.178 5.482 10.118 4.304 8 4.304a5.81 5.81 0 0 0-1.944.338ZM6 8c0-.18.024-.353.068-.518l2.45 2.45A2.003 2.003 0 0 1 6 8Zm1.482-1.932 2.45 2.45a2.003 2.003 0 0 0-2.45-2.45Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.22 6.28a.75.75 0 0 1 1.06-1.06l12.5 12.5a.75.75 0 1 1-1.06 1.06L5.22 6.28Zm-1.79 5.295c.87-1.267 1.854-2.308 2.912-3.112l1.071 1.071C6.55 10.162 5.726 10.981 4.97 12c2.04 2.748 4.576 4.044 7.031 4.044.569 0 1.142-.07 1.712-.21l1.204 1.203a8.716 8.716 0 0 1-2.916.507c-3.178 0-6.267-1.767-8.57-5.12a.75.75 0 0 1 0-.849Zm5.654-4.612 1.204 1.204A7.122 7.122 0 0 1 12 7.957c2.455 0 4.99 1.295 7.03 4.043-.756 1.019-1.58 1.838-2.443 2.466l1.072 1.071c1.057-.804 2.04-1.845 2.911-3.112a.75.75 0 0 0 0-.85C18.267 8.223 15.178 6.456 12 6.456c-.988 0-1.966.17-2.916.507ZM9 12c0-.269.035-.53.102-.777l3.675 3.675A3.004 3.004 0 0 1 9 12Zm2.223-2.898 3.675 3.675a3.004 3.004 0 0 0-3.675-3.675Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEyeSlash };
var IconEye = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 10.696c-1.637 0-3.327-.864-4.687-2.696C4.673 6.168 6.363 5.304 8 5.304c1.637 0 3.327.864 4.687 2.696-1.36 1.832-3.05 2.696-4.687 2.696Zm5.713-2.98C12.178 5.483 10.118 4.305 8 4.305S3.822 5.482 2.287 7.717a.5.5 0 0 0 0 .566C3.822 10.518 5.882 11.696 8 11.696s4.178-1.178 5.713-3.413a.5.5 0 0 0 0-.566ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 16.044c-2.455 0-4.99-1.296-7.03-4.044C7.01 9.252 9.544 7.956 12 7.956S16.99 9.252 19.03 12c-2.04 2.748-4.575 4.044-7.03 4.044Zm8.57-4.469C18.267 8.223 15.178 6.456 12 6.456s-6.267 1.767-8.57 5.12a.75.75 0 0 0 0 .849c2.303 3.352 5.392 5.119 8.57 5.119s6.267-1.767 8.57-5.12a.75.75 0 0 0 0-.849ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
      fill: 'currentColor'
    }));
  }
});
export { IconEye };
var IconFiletypeAudio = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M9.833 12V4m-5.5 5.667V6.333m3.667 4V5.667M6.167 8.933V7.067m5.5 2.333V6.6',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M14.75 18V6M6.5 14.5v-5m5.5 6v-7m-2.75 4.9v-2.8m8.25 3.5V9.9',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconFiletypeAudio };
var IconFiletypeBlank = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm6.829 8.469-2.015-.574a.816.816 0 1 1 .529-1.542l1.99.803-.13-2.294A.816.816 0 0 1 8.016 4h.039c.468 0 .84.394.814.862L8.738 7.22l1.914-.78c.44-.18.94.054 1.085.506l.003.01a.816.816 0 0 1-.557 1.035l-2.066.577 1.364 1.737a.816.816 0 0 1-.167 1.168l-.029.02a.816.816 0 0 1-1.168-.233l-1.18-1.904-1.17 1.841a.816.816 0 0 1-1.148.237l-.014-.01a.816.816 0 0 1-.18-1.18L6.83 8.47Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm10.243 12.703-3.022-.86a1.224 1.224 0 1 1 .793-2.313L11 10.735l-.197-3.442A1.224 1.224 0 0 1 12.025 6h.058c.703 0 1.262.59 1.222 1.293l-.198 3.537 2.872-1.17c.66-.269 1.409.08 1.627.76l.005.013a1.224 1.224 0 0 1-.836 1.554l-3.1.865 2.047 2.605a1.224 1.224 0 0 1-.25 1.752l-.044.031c-.575.411-1.38.25-1.752-.35l-1.77-2.856-1.755 2.762a1.224 1.224 0 0 1-1.723.355l-.02-.014a1.224 1.224 0 0 1-.27-1.77l2.105-2.664Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeBlank };
var IconFiletypeCompressed = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('rect', {
      x: '3.5',
      y: '9',
      width: '9',
      height: '2',
      rx: '.833',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('rect', {
      x: '3.5',
      y: '5',
      width: '9',
      height: '2',
      rx: '.833',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('rect', {
      x: '5.25',
      y: '13.25',
      width: '13.5',
      height: '3.5',
      rx: '1.25',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('rect', {
      x: '5.25',
      y: '7.25',
      width: '13.5',
      height: '3.5',
      rx: '1.25',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconFiletypeCompressed };
var IconFiletypeDrawing = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm9.86 4.196 1.944 1.945a.292.292 0 0 1 0 .412l-.767.766-2.356-2.356.766-.767a.292.292 0 0 1 .412 0Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm8.007 5.635.674-.672 2.356 2.356-.673.673-.414 1.539a1.651 1.651 0 0 1-1.21 1.177l-3.15.756a.86.86 0 0 1-.58-.063l2.631-2.63.01.001a.343.343 0 0 0 .057.006.486.486 0 1 0-.486-.486c0 .02.003.038.006.058l.001.009-2.631 2.63a.868.868 0 0 1-.062-.58l.755-3.15A1.653 1.653 0 0 1 6.47 6.05l1.538-.414Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm14.789 6.295 2.916 2.916a.438.438 0 0 1 0 .62l-1.149 1.148-3.535-3.535 1.149-1.15a.44.44 0 0 1 .619 0Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm12.011 8.453 1.01-1.01 3.535 3.536-1.01 1.01-.62 2.307a2.478 2.478 0 0 1-1.816 1.767l-4.724 1.133a1.292 1.292 0 0 1-.869-.095l3.945-3.945.013.002c.029.004.058.009.088.009a.73.73 0 1 0-.73-.73c0 .03.005.059.009.087 0 .005 0 .01.002.014l-3.947 3.947a1.302 1.302 0 0 1-.093-.871l1.133-4.724c.213-.884.89-1.58 1.767-1.815l2.307-.622Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeDrawing };
var IconFiletypeFile = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 4.25a.75.75 0 0 1 .75-.75h3v1a2.25 2.25 0 0 0 2.25 2.25h1v5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-7.5ZM5.25 2A2.25 2.25 0 0 0 3 4.25v7.5A2.25 2.25 0 0 0 5.25 14h5.5A2.25 2.25 0 0 0 13 11.75V6a.75.75 0 0 0-.22-.53L9.53 2.22A.75.75 0 0 0 9 2H5.25Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 5.5A1.5 1.5 0 0 0 6.5 7v10A1.5 1.5 0 0 0 8 18.5h8a1.5 1.5 0 0 0 1.5-1.5v-6.25h-2.25a3 3 0 0 1-3-3V5.5H8Zm5.75 1.06 2.69 2.69h-1.19a1.5 1.5 0 0 1-1.5-1.5V6.56ZM5 7a3 3 0 0 1 3-3h5a.75.75 0 0 1 .53.22l5.25 5.25c.141.14.22.331.22.53v7a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeFile };
var IconFiletypeImage = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm2.936 10.84 3.438-6.303a.333.333 0 0 1 .585 0l2.178 3.991.916-1.425a.333.333 0 0 1 .56 0l2.39 3.717a.333.333 0 0 1-.28.513H3.228a.333.333 0 0 1-.292-.493Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '11',
      cy: '4.333',
      r: '1',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm4.403 16.26 5.158-9.455a.5.5 0 0 1 .878 0l3.266 5.987 1.374-2.138a.5.5 0 0 1 .842 0l3.584 5.576a.5.5 0 0 1-.42.77H4.841a.5.5 0 0 1-.439-.74Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('circle', {
      cx: '16.5',
      cy: '6.5',
      r: '1.5',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeImage };
var IconFiletypeMotion = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.833 6.037c0-.297.24-.537.537-.537a4.833 4.833 0 0 1 4.404 2.841 3.401 3.401 0 0 1 2.757-1.409.537.537 0 1 1 0 1.074 2.327 2.327 0 0 0-2.327 2.321v.006H7.13v-.006a3.76 3.76 0 0 0-3.76-3.753.537.537 0 0 1-.537-.537Zm9.821 2.445a1.012 1.012 0 1 0 0-2.025 1.012 1.012 0 0 0 0 2.025Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.25 9.056c0-.445.36-.806.806-.806a7.25 7.25 0 0 1 6.605 4.262 5.104 5.104 0 0 1 4.135-2.114.806.806 0 0 1 0 1.611 3.491 3.491 0 0 0-3.49 3.491h-1.612a5.638 5.638 0 0 0-5.638-5.639.806.806 0 0 1-.806-.805Zm14.732 3.666a1.518 1.518 0 1 0 0-3.037 1.518 1.518 0 0 0 0 3.037Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeMotion };
var IconFiletypePdf = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M10.5 3.833h-5a.832.832 0 0 0-.83.834l-.003 7.5L8 10.333l3.333 1.834v-7.5a.836.836 0 0 0-.833-.834Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M15.75 5.75h-7.5c-.688 0-1.244.563-1.244 1.25L7 18.25l5-2.75 5 2.75V7c0-.688-.563-1.25-1.25-1.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypePdf };
var IconFiletypeSpreadsheet = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M5 4.667h3V8H4V5.667a1 1 0 0 1 1-1ZM4 8h4v3.333H5a1 1 0 0 1-1-1V8Zm4-3.333h3a1 1 0 0 1 1 1V8H8V4.667ZM8 8h4v2.333a1 1 0 0 1-1 1H8V8Z',
      stroke: 'currentColor',
      strokeWidth: '.667'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M7.5 7H12v5H6V8.5A1.5 1.5 0 0 1 7.5 7ZM6 12h6v5H7.5A1.5 1.5 0 0 1 6 15.5V12Zm6-5h4.5A1.5 1.5 0 0 1 18 8.5V12h-6V7Zm0 5h6v3.5a1.5 1.5 0 0 1-1.5 1.5H12v-5Z',
      stroke: 'currentColor'
    }));
  }
});
export { IconFiletypeSpreadsheet };
var IconFiletypeVector = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.389 6.372a.972.972 0 0 1-1.806.5h-1.467a5.074 5.074 0 0 1 1.967 4.017.5.5 0 1 1-1 0A4.085 4.085 0 0 0 8.925 6.91a.501.501 0 0 1-.108-.039H7.164a.5.5 0 0 1-.12.046 4.085 4.085 0 0 0-3.127 3.971.5.5 0 0 1-1 0c0-1.634.77-3.087 1.967-4.017H3.417a.972.972 0 1 1 0-1h9.166a.972.972 0 0 1 1.806.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.126 10.308a1.458 1.458 0 1 1 0-1.5h13.748a1.457 1.457 0 1 1 0 1.5h-2.2a7.611 7.611 0 0 1 2.951 6.025.75.75 0 0 1-1.5 0 6.127 6.127 0 0 0-4.738-5.967.75.75 0 0 1-.162-.058h-2.48a.753.753 0 0 1-.18.07 6.128 6.128 0 0 0-4.69 5.955.75.75 0 0 1-1.5 0 7.61 7.61 0 0 1 2.951-6.025h-2.2Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeVector };
var IconFiletypeText = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.708 4.167a.5.5 0 0 1 .5.5v.416a.5.5 0 0 1-.906.292H8.5v5.458h.23a.5.5 0 0 1 0 1H7.27a.5.5 0 0 1 0-1h.23V5.375H5.698a.5.5 0 0 1-.906-.292v-.416a.5.5 0 0 1 .906-.292h4.604a.5.5 0 0 1 .406-.208Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.063 6.25a.75.75 0 0 1 .75.75v.625a.75.75 0 0 1-1.36.438H12.75v8.187h.344a.75.75 0 0 1 0 1.5h-2.188a.75.75 0 0 1 0-1.5h.344V8.062H8.547a.749.749 0 0 1-1.36-.437V7a.75.75 0 0 1 1.36-.438h6.906a.749.749 0 0 1 .61-.312Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeText };
var IconFiletypeVideo = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.653 5.147c0-.787.845-1.284 1.532-.903l5.15 2.853a1.032 1.032 0 0 1 0 1.805l-5.15 2.854a1.032 1.032 0 0 1-1.532-.903V5.147Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.98 7.72a1.548 1.548 0 0 1 2.298-1.354l7.725 4.28a1.548 1.548 0 0 1 0 2.708l-7.725 4.28A1.548 1.548 0 0 1 6.98 16.28V7.72Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFiletypeVideo };
var IconFilter = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167ZM5.361 5.694a.5.5 0 0 0 0 1h5.278a.5.5 0 0 0 0-1H5.36Zm.556 1.945a.5.5 0 0 0 0 1h4.166a.5.5 0 1 0 0-1H5.917Zm.055 2.444a.5.5 0 0 1 .5-.5h3.056a.5.5 0 1 1 0 1H6.472a.5.5 0 0 1-.5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM8.042 8.542a.75.75 0 1 0 0 1.5h7.916a.75.75 0 0 0 0-1.5H8.042Zm.833 2.916a.75.75 0 0 0 0 1.5h6.25a.75.75 0 1 0 0-1.5h-6.25Zm.083 3.667a.75.75 0 0 1 .75-.75h4.584a.75.75 0 0 1 0 1.5H9.708a.75.75 0 0 1-.75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFilter };
var IconFlag = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3.694 13.139V3.417h9.167l-2.5 3.333 2.5 3.333H3.833',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M5.542 19.708V5.125h13.75l-3.75 5 3.75 5H5.75',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconFlag };
var IconFolderClosed = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.694 3.333c-.736 0-1.332.597-1.333 1.332v.002l-.028 6.664v.002c0 .758.647 1.334 1.361 1.334h8.612c.715 0 1.36-.576 1.36-1.334V6c0-.757-.645-1.333-1.36-1.333H8.039l-1.218-.99c-.315-.262-.692-.344-1.029-.344H3.694Zm-.333 1.334c0-.185.15-.334.333-.334h2.098c.183 0 .308.044.392.114l.004.004 1.358 1.104.138.112h4.622c.205 0 .36.17.36.333v.667H3.354l.008-1.998v-.002Zm-.012 3-.016 3.666v.001c0 .163.156.333.361.333h8.612c.205 0 .36-.17.36-.334V7.667H3.35Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.542 5a2 2 0 0 0-2 1.998V7L3.5 16.997V17c0 1.136.97 2 2.042 2h12.916c1.073 0 2.042-.864 2.042-2V9c0-1.136-.97-2-2.042-2h-6.4l-1.826-1.485C9.759 5.123 9.193 5 8.688 5H5.542Zm-.5 2a.5.5 0 0 1 .5-.5h3.146c.274 0 .462.066.587.17l.007.007 2.037 1.655.206.168h6.933c.309 0 .542.255.542.5v1H5.03l.012-2.997V7Zm-.02 4.5L5 17v.001c0 .244.234.499.542.499h12.916c.309 0 .542-.255.542-.5v-5.5H5.023Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFolderClosed };
var IconFolderImage = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.361 4.665c0-.735.597-1.332 1.333-1.332h2.098c.337 0 .714.082 1.03.344l1.217.99h4.267c.715 0 1.36.576 1.36 1.333v5.333c0 .758-.646 1.334-1.36 1.334H3.694c-.218 0-.43-.054-.62-.15l-.04.038-.146-.153a1.369 1.369 0 0 1-.34-.353l-.206-.215.067-.064a1.29 1.29 0 0 1-.076-.437v-.002l.028-6.664v-.002Zm6.346 7.002H3.96l2.22-2.133a.222.222 0 0 1 .307 0l2.22 2.133Zm3.599 0H10.15L7.179 8.812a1.222 1.222 0 0 0-1.691 0L3.334 10.88l.026-6.211v-.002c0-.184.15-.334.333-.334h2.098c.183 0 .308.045.392.114l.004.004 1.358 1.104.138.112h4.622c.205 0 .36.17.36.333v5.333c0 .163-.155.334-.36.334ZM8.722 7.36a.694.694 0 1 0-1.388 0 .694.694 0 0 0 1.388 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.542 6.998a2 2 0 0 1 2-1.998h3.146c.505 0 1.07.123 1.544.515L12.058 7h6.4c1.073 0 2.042.864 2.042 2v8c0 1.136-.97 2-2.042 2H5.542c-.328 0-.646-.08-.93-.225l-.06.058-.22-.23a2.058 2.058 0 0 1-.509-.53l-.31-.322.1-.096A1.935 1.935 0 0 1 3.5 17v-.003L3.542 7v-.002ZM13.06 17.5H5.939l3.33-3.199a.334.334 0 0 1 .461 0l3.33 3.199Zm5.397 0h-3.232l-4.457-4.281-.001-.001a1.833 1.833 0 0 0-2.536 0H8.23L5.003 16.32l.039-9.317V7a.5.5 0 0 1 .5-.5h3.146c.274 0 .462.066.587.17l.007.007 2.037 1.655.206.168h6.933c.309 0 .542.255.542.5v8c0 .245-.233.5-.542.5Zm-5.375-6.458a1.041 1.041 0 1 0-2.083 0 1.041 1.041 0 0 0 2.083 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFolderImage };
var IconFolderLockedIcon = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.361 4.665c0-.735.597-1.332 1.333-1.332h2.098c.337 0 .714.082 1.03.344l1.217.99h4.267c.715 0 1.36.576 1.36 1.333v2.02a3.99 3.99 0 0 0-2.99-1.353h1.99V6c0-.163-.155-.333-.36-.333H7.684l-.138-.112L6.188 4.45l-.004-.004c-.084-.07-.21-.114-.392-.114H3.694a.333.333 0 0 0-.333.334v.002l-.008 1.998h7.305a3.985 3.985 0 0 0-2.637 1H3.349l-.016 3.666v.001c0 .163.156.333.361.333h3.099c.091.354.23.69.409 1H3.694c-.715 0-1.36-.576-1.36-1.334v-.002l.027-6.664v-.002Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.014 9a.653.653 0 1 1 1.305 0v.666h-1.305V9Zm-.5.667V9a1.153 1.153 0 1 1 2.305 0v.666h.195c.368 0 .667.3.667.667v2.334a.667.667 0 0 1-.667.666H9.319a.667.667 0 0 1-.666-.666v-2.334c0-.368.298-.666.666-.666h.195Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.542 6.998a2 2 0 0 1 2-1.998h3.146c.505 0 1.07.123 1.544.515L12.058 7h6.4c1.073 0 2.042.864 2.042 2v3.031A5.986 5.986 0 0 0 16.012 10H19V9c0-.245-.233-.5-.542-.5h-6.933l-.206-.168-2.037-1.655-.007-.006c-.125-.105-.313-.171-.587-.171H5.542a.5.5 0 0 0-.5.5v.003L5.029 10h10.959a5.977 5.977 0 0 0-3.957 1.5H5.023L5 17v.001c0 .244.234.499.542.499h4.647c.137.532.345 1.036.614 1.5H5.542C4.469 19 3.5 18.136 3.5 17v-.003L3.542 7v-.002Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.02 13.5a.98.98 0 0 1 1.96 0v1h-1.96v-1Zm-.75 1v-1a1.73 1.73 0 0 1 3.46 0v1h.29a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1h-4.04a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1h.29Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFolderLockedIcon };
var IconFullscreenExit = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '17',
      height: '16',
      viewBox: '0 0 17 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.667 7.333a.5.5 0 0 0 0-1h-2.5v-2.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .5.5h3ZM4.333 8.667a.5.5 0 0 0 0 1h2.5v2.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5h-3Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '25',
      height: '24',
      viewBox: '0 0 25 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.75 11a.75.75 0 0 0 0-1.5H15V5.75a.75.75 0 0 0-1.5 0v4.5c0 .414.336.75.75.75h4.5Zm-12.5 2a.75.75 0 0 0 0 1.5H10v3.75a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFullscreenExit };
var IconFullscreen = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.667 3.833a.5.5 0 0 0-.5-.5h-3.89a.5.5 0 0 0 0 1h3.39v3.39a.5.5 0 1 0 1 0v-3.89Zm-9.334 8.334a.5.5 0 0 0 .5.5h3.89a.5.5 0 0 0 0-1h-3.39v-3.39a.5.5 0 1 0-1 0v3.89Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19 5.75a.75.75 0 0 0-.75-.75h-5.833a.75.75 0 0 0 0 1.5H17.5v5.083a.75.75 0 0 0 1.5 0V5.75ZM5 18.25c0 .414.336.75.75.75h5.833a.75.75 0 0 0 0-1.5H6.5v-5.083a.75.75 0 0 0-1.5 0v5.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFullscreen };
var IconFolderOpen = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.333 4.667c0-.164.156-.334.361-.334H5.79c.006.002.04.01.108.055.074.048.143.106.23.18l.056.046c.01.008.02.017.032.024l1.33.937a.5.5 0 0 0 .287.092h3.917c.084 0 .134.03.169.07A.402.402 0 0 1 12 6v.528H4.737a1.333 1.333 0 0 0-1.26.899l-.144.49v-3.25Zm-1 6.766V4.667c0-.758.646-1.334 1.361-1.334h2.098c.273 0 .5.119.651.217.13.085.254.189.34.262l.026.02 1.183.835h3.758c.804 0 1.25.669 1.25 1.333v.545c.627.116 1.026.778.796 1.403l-1.223 3.696a1.77 1.77 0 0 1-.436.667c-.191.182-.472.356-.818.356H3.417c-.43 0-.74-.284-.9-.552a1.27 1.27 0 0 1-.184-.682Zm1.013-.015L4.43 7.73a.333.333 0 0 1 .307-.202h8.068c.04 0 .066.039.052.075a.552.552 0 0 0-.008.022l-1.222 3.695a.773.773 0 0 1-.178.266c-.082.077-.13.08-.13.08H3.43a.214.214 0 0 1-.057-.065.295.295 0 0 1-.039-.105c-.004-.028 0-.042 0-.043a.52.52 0 0 0 .011-.035Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 7c0-.245.233-.5.542-.5h3.143c.01.003.06.016.162.082.11.072.215.16.346.27l.082.069a.749.749 0 0 0 .048.037l1.995 1.405a.75.75 0 0 0 .432.137h5.875c.126 0 .2.044.253.106A.602.602 0 0 1 18 9v.792H7.105a2 2 0 0 0-1.89 1.349L5 11.875V7ZM3.5 17.15V7c0-1.136.97-2 2.042-2h3.146c.41 0 .75.177.977.325.195.127.38.284.51.393l.038.031L11.988 7h5.637C18.83 7 19.5 8.004 19.5 9v.818a1.584 1.584 0 0 1 1.193 2.104l-1.833 5.545a2.655 2.655 0 0 1-.655 1.001c-.286.271-.708.532-1.227.532H5.126c-.645 0-1.11-.425-1.351-.827A1.905 1.905 0 0 1 3.5 17.15Zm1.52-.023 1.625-5.531a.5.5 0 0 1 .46-.304h12.102c.06 0 .099.058.078.112a.636.636 0 0 0-.011.033L17.44 16.98a1.16 1.16 0 0 1-.267.399c-.123.116-.194.121-.196.121H5.148l-.002-.001a.32.32 0 0 1-.085-.098.443.443 0 0 1-.058-.157.154.154 0 0 1-.001-.065.74.74 0 0 0 .018-.052Z',
      fill: 'currentColor'
    }));
  }
});
export { IconFolderOpen };
var IconGlobe = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.241 3.497a4.85 4.85 0 0 0-2.49 2.197h1.626a7.554 7.554 0 0 1 .5-1.537c.105-.23.227-.454.364-.66ZM3.167 8c0-.452.062-.89.178-1.306h1.867a11.482 11.482 0 0 0 0 2.612H3.345A4.837 4.837 0 0 1 3.167 8Zm.584 2.306a4.85 4.85 0 0 0 2.49 2.197 4.877 4.877 0 0 1-.365-.66 7.555 7.555 0 0 1-.5-1.537H3.752Zm2.652 0c.103.417.233.794.382 1.119.41.894.877 1.214 1.215 1.214.338 0 .804-.32 1.215-1.214.15-.325.279-.702.382-1.12H6.403Zm4.22 0a7.556 7.556 0 0 1-.5 1.537 4.875 4.875 0 0 1-.364.66 4.85 4.85 0 0 0 2.49-2.197h-1.626Zm2.032-1h-1.867a11.478 11.478 0 0 0 0-2.612h1.867a4.839 4.839 0 0 1 0 2.612Zm-2.875 0H6.22a10.482 10.482 0 0 1-.001-2.612H9.78a10.482 10.482 0 0 1 .001 2.612Zm.843-3.612h1.626a4.85 4.85 0 0 0-2.49-2.197c.137.206.259.43.365.66.207.45.375.97.5 1.537Zm-4.22 0h3.194a6.318 6.318 0 0 0-.382-1.119C8.805 3.681 8.338 3.361 8 3.361c-.338 0-.804.32-1.215 1.214-.15.325-.279.702-.382 1.12ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.361 5.245a7.276 7.276 0 0 0-3.735 3.297h2.44c.185-.852.438-1.631.748-2.306.16-.347.342-.682.547-.99ZM4.75 12c0-.679.093-1.335.268-1.958h2.8c-.072.63-.11 1.286-.11 1.958 0 .672.038 1.328.11 1.958h-2.8A7.256 7.256 0 0 1 4.75 12Zm.876 3.458a7.276 7.276 0 0 0 3.736 3.297 7.311 7.311 0 0 1-.548-.991 11.33 11.33 0 0 1-.749-2.306H5.626Zm3.979 0c.154.627.348 1.193.572 1.68.616 1.34 1.316 1.82 1.823 1.82.507 0 1.207-.48 1.823-1.82a9.475 9.475 0 0 0 .572-1.68h-4.79Zm6.33 0c-.186.852-.44 1.631-.75 2.306a7.246 7.246 0 0 1-.547.991 7.276 7.276 0 0 0 3.736-3.297h-2.44Zm3.047-1.5h-2.8c.072-.63.11-1.286.11-1.958 0-.672-.038-1.328-.11-1.958h2.8c.175.623.268 1.28.268 1.958 0 .679-.093 1.335-.268 1.958Zm-4.311 0H9.329A15.625 15.625 0 0 1 9.21 12c0-.682.042-1.339.12-1.958h5.342c.078.62.12 1.276.12 1.958 0 .682-.042 1.339-.12 1.958Zm1.264-5.416h2.439a7.276 7.276 0 0 0-3.736-3.297c.206.31.389.644.548.991.31.675.563 1.454.749 2.306Zm-5.758-1.68a9.473 9.473 0 0 0-.572 1.68h4.79a9.474 9.474 0 0 0-.572-1.68c-.616-1.34-1.316-1.82-1.823-1.82-.507 0-1.207.48-1.823 1.82ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconGlobe };
var IconGuides = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8.083 3.333H4.298c-.625 0-1.131.507-1.131 1.132v3.618m4.916-4.75h3.619c.625 0 1.131.507 1.131 1.132v3.618m-4.75-4.75V5M3.167 8.083v3.619a1.13 1.13 0 0 0 1.131 1.131H8m-4.833-4.75h1.666M8 12.833h3.702a1.13 1.13 0 0 0 1.131-1.131V8.083M8 12.833v-1.666m4.833-3.084h-1.666',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.125 5H6.447C5.51 5 4.75 5.76 4.75 6.697v5.428M12.125 5h5.428c.937 0 1.697.76 1.697 1.697v5.428M12.125 5v3M4.75 12.125v5.428c0 .937.76 1.697 1.697 1.697H12m-7.25-7.125h3M12 19.25h5.553c.937 0 1.697-.76 1.697-1.697v-5.428M12 19.25v-3m7.25-4.125h-3',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconGuides };
var IconHashtag = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.307 3.342a.506.506 0 0 1 .403.591l-.397 2.1h2.119l.432-2.288a.506.506 0 1 1 .995.188l-.397 2.1h1.699a.506.506 0 1 1 0 1.011h-1.89l-.363 1.912h1.803a.506.506 0 1 1 0 1.012H9.717l-.433 2.287a.506.506 0 1 1-.994-.188l.397-2.1H6.568l-.432 2.288a.506.506 0 1 1-.995-.188l.397-2.1H3.84a.506.506 0 0 1 0-1.011h1.89l.363-1.912H4.289a.506.506 0 1 1 0-1.012h1.994l.433-2.287a.506.506 0 0 1 .59-.403Zm1.571 5.614.362-1.912H7.122L6.76 8.956h2.118Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.96 5.013a.76.76 0 0 1 .605.887l-.595 3.148h3.177l.65-3.43a.759.759 0 1 1 1.491.282l-.596 3.148h2.549a.759.759 0 0 1 0 1.518h-2.836l-.542 2.868h2.703a.759.759 0 1 1 0 1.518h-2.99l-.65 3.43a.76.76 0 0 1-1.491-.282l.595-3.148H9.854l-.65 3.43a.76.76 0 0 1-1.491-.282l.596-3.148h-2.55a.759.759 0 1 1 0-1.518h2.836l.542-2.868H6.434a.76.76 0 0 1 0-1.518h2.99l.65-3.43a.759.759 0 0 1 .886-.605Zm2.358 8.42.542-2.867h-3.178l-.542 2.868h3.178Z',
      fill: 'currentColor'
    }));
  }
});
export { IconHashtag };
var IconHome = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.111 12.167h2.445a.278.278 0 0 0 .277-.278V9.11c0-.307.249-.555.556-.555h1.389c.307 0 .555.248.555.555v2.778c0 .153.125.278.278.278h2.278a.278.278 0 0 0 .278-.278V7.586c0-.51-.235-.993-.636-1.309l-3.448-3.11-3.614 3.11a1.667 1.667 0 0 0-.636 1.31v4.302c0 .153.125.278.278.278Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.636 4.182a.75.75 0 0 1 .991.011l5.155 4.65A3.25 3.25 0 0 1 19 11.38v6.453c0 .645-.523 1.167-1.167 1.167h-3.416a1.167 1.167 0 0 1-1.167-1.167v-4.166a.083.083 0 0 0-.083-.084h-2.084a.083.083 0 0 0-.083.084v4.166C11 18.478 10.477 19 9.833 19H6.167A1.167 1.167 0 0 1 5 17.833V11.38c0-.99.451-1.926 1.225-2.543l5.41-4.655Zm.477 1.568-4.92 4.234A1.75 1.75 0 0 0 6.5 11.38v6.12h2.999v-3.833c0-.875.709-1.584 1.583-1.584h2.084c.874 0 1.583.709 1.583 1.584V17.5h2.75v-6.12a1.75 1.75 0 0 0-.705-1.407L12.113 5.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconHome };
var IconHeart = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 3.194a3.139 3.139 0 0 0-3.139 3.14c0 1.83.84 3.337 1.929 4.462 1.084 1.12 2.44 1.89 3.552 2.262a.5.5 0 0 0 .316 0c1.113-.371 2.468-1.142 3.552-2.262 1.088-1.125 1.929-2.633 1.929-4.463A3.139 3.139 0 0 0 10.5 3.194c-.99 0-1.817.476-2.5 1.31-.683-.834-1.51-1.31-2.5-1.31Zm-2.139 3.14A2.14 2.14 0 0 1 5.5 4.194c.74 0 1.43.409 2.077 1.434a.5.5 0 0 0 .846 0C9.07 4.603 9.759 4.194 10.5 4.194a2.14 2.14 0 0 1 2.139 2.14c0 1.503-.687 2.773-1.648 3.766A8.264 8.264 0 0 1 8 12.054 8.263 8.263 0 0 1 5.009 10.1c-.96-.993-1.648-2.263-1.648-3.767Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.25 4.792A4.708 4.708 0 0 0 3.542 9.5c0 2.745 1.26 5.006 2.893 6.693 1.626 1.682 3.66 2.837 5.328 3.393a.75.75 0 0 0 .474 0c1.669-.556 3.702-1.711 5.328-3.393 1.632-1.687 2.893-3.948 2.893-6.693 0-2.6-2.107-4.708-4.708-4.708-1.485 0-2.725.713-3.75 1.965-1.025-1.252-2.265-1.965-3.75-1.965ZM5.042 9.5A3.208 3.208 0 0 1 8.25 6.292c1.111 0 2.144.612 3.116 2.15a.75.75 0 0 0 1.268 0c.973-1.538 2.005-2.15 3.116-2.15A3.208 3.208 0 0 1 18.958 9.5c0 2.255-1.03 4.16-2.471 5.65-1.37 1.416-3.074 2.416-4.487 2.93-1.413-.514-3.118-1.514-4.487-2.93-1.44-1.49-2.471-3.395-2.471-5.65Z',
      fill: 'currentColor'
    }));
  }
});
export { IconHeart };
var IconImageMap = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382Zm-5.666.285A.667.667 0 0 0 6 5.333v4c0 .369.298.667.667.667h4a.667.667 0 0 0 .666-.667v-4a.667.667 0 0 0-.666-.666h-4ZM7 9V5.667h3.333V9H7Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM10 7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-6Zm.5 6.5v-5h5v5h-5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconImageMap };
var IconImage = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.667 2.167a2.5 2.5 0 0 0-2.5 2.5v5.46l-.01.01.01.01v1.186a2.5 2.5 0 0 0 2.5 2.5h.158l.024.025.025-.025h6.46a2.5 2.5 0 0 0 2.5-2.5V4.667a2.5 2.5 0 0 0-2.5-2.5H4.666Zm-1.5 8.39v.776a1.5 1.5 0 0 0 1.312 1.489L7.65 9.729 6.01 8.143a.206.206 0 0 0-.288 0l-.004.004-2.551 2.41Zm5.2-1.526.507-.496.002-.001a1.205 1.205 0 0 1 1.678 0h.001l2.278 2.214V4.667a1.5 1.5 0 0 0-1.5-1.5H4.667a1.5 1.5 0 0 0-1.5 1.5v4.515l1.862-1.76a1.207 1.207 0 0 1 1.677.002l1.66 1.607Zm2.966 3.802H5.9l3.671-3.58a.206.206 0 0 1 .288 0l2.713 2.635.227-.232a1.5 1.5 0 0 1-1.466 1.177Zm-.694-6.639a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7 5.5h10A1.5 1.5 0 0 1 18.5 7v8.393l-2.667-2.591-.002-.002a1.809 1.809 0 0 0-2.518.001l-.766.742-2.488-2.406a1.808 1.808 0 0 0-2.519-.002v.002L5.5 13.115V7A1.5 1.5 0 0 1 7 5.5Zm-1.5 9.704V17A1.5 1.5 0 0 0 7 18.5h.43l4.04-3.912-2.454-2.374h-.001a.308.308 0 0 0-.432 0L5.5 15.204Zm9.29-1.325 3.649 3.546A1.5 1.5 0 0 1 17 18.5H9.586l4.77-4.621a.309.309 0 0 1 .432 0h.002ZM4 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7Zm11.958 2.292a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconImage };
var IconInbox = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.667 4.631c0-.532.432-.964.964-.964h6.738c.532 0 .964.432.964.964v4.036H9.644a.5.5 0 0 0-.5.5c0 .778-.59 1.166-1.144 1.166-.555 0-1.144-.388-1.144-1.166a.5.5 0 0 0-.5-.5h-2.69V4.63Zm0 5.036v1.702c0 .532.432.964.964.964h6.738a.965.965 0 0 0 .964-.964V9.667h-2.239c-.232 1.11-1.23 1.666-2.094 1.666-.865 0-1.862-.555-2.094-1.666h-2.24Zm.964-7c-1.085 0-1.964.88-1.964 1.964v6.738c0 1.085.88 1.964 1.964 1.964h6.738c1.085 0 1.964-.88 1.964-1.964V4.63c0-1.085-.88-1.964-1.964-1.964H4.63Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 6.947c0-.799.648-1.447 1.447-1.447h10.106c.799 0 1.447.648 1.447 1.447V13h-4.034a.75.75 0 0 0-.75.75c0 1.167-.884 1.75-1.716 1.75s-1.716-.583-1.716-1.75a.75.75 0 0 0-.75-.75H5.5V6.947Zm0 7.553v2.553c0 .799.648 1.447 1.447 1.447h10.106c.799 0 1.447-.648 1.447-1.447V14.5h-3.359C14.793 16.166 13.297 17 12 17s-2.793-.834-3.141-2.5H5.5ZM6.947 4A2.947 2.947 0 0 0 4 6.947v10.106A2.947 2.947 0 0 0 6.947 20h10.106A2.947 2.947 0 0 0 20 17.053V6.947A2.947 2.947 0 0 0 17.053 4H6.947Z',
      fill: 'currentColor'
    }));
  }
});
export { IconInbox };
var IconInfo = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.167a4.833 4.833 0 1 0 0 9.666 4.833 4.833 0 0 0 0-9.666ZM2.167 8a5.833 5.833 0 1 1 11.666 0A5.833 5.833 0 0 1 2.167 8ZM8 6.638a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332Zm.5 1a.5.5 0 0 0-1 0v3.056a.5.5 0 0 0 1 0V7.64Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0ZM12 9.957a1 1 0 1 0 0-1.998 1 1 0 0 0 0 1.998Zm.75 1.501a.75.75 0 1 0-1.5 0v4.583a.75.75 0 1 0 1.5 0v-4.583Z',
      fill: 'currentColor'
    }));
  }
});
export { IconInfo };
var IconKey = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.694 2.613a3.695 3.695 0 0 0-3.626 4.39L2.813 10.26a.5.5 0 0 0-.146.354v2.222a.5.5 0 0 0 .5.5h2.222a.5.5 0 0 0 .5-.5v-.611h.889a.5.5 0 0 0 .5-.5v-.89h.889a.5.5 0 0 0 .5-.5v-.478a3.695 3.695 0 1 0 1.028-7.244ZM7 6.307a2.695 2.695 0 1 1 1.406 2.367.5.5 0 0 0-.74.439v.722h-.888a.5.5 0 0 0-.5.5v.889h-.89a.5.5 0 0 0-.5.5v.61h-1.22V10.82l3.305-3.306a.5.5 0 0 0 .129-.487A2.68 2.68 0 0 1 7 6.307Zm4.056-.53a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.542 3.919A5.542 5.542 0 0 0 9 9.46c0 .36.037.708.103 1.045L4.22 15.389a.75.75 0 0 0-.22.53v3.333c0 .414.336.75.75.75h3.333a.75.75 0 0 0 .75-.75v-.916h1.334a.75.75 0 0 0 .75-.75v-1.334h1.333a.75.75 0 0 0 .75-.75v-.717a5.542 5.542 0 1 0 1.542-10.866ZM10.5 9.46a4.042 4.042 0 1 1 2.11 3.55.75.75 0 0 0-1.11.658v1.083h-1.333a.75.75 0 0 0-.75.75v1.334H8.083a.75.75 0 0 0-.75.75v.916H5.5V16.23l4.959-4.96a.75.75 0 0 0 .192-.73 4.017 4.017 0 0 1-.151-1.08Zm6.083-.794a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconKey };
var IconLayout = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.444 4c0-.184.15-.333.334-.333H12c.184 0 .333.149.333.333v2.222a.334.334 0 0 1-.333.334H9.778a.333.333 0 0 1-.334-.334V4Zm.334-1.333c-.737 0-1.334.597-1.334 1.333v2.222c0 .737.597 1.334 1.334 1.334H12c.736 0 1.333-.597 1.333-1.334V4c0-.736-.597-1.333-1.333-1.333H9.778ZM3.667 4c0-.184.149-.333.333-.333h2.222c.184 0 .334.149.334.333v2.222c0 .184-.15.334-.334.334H4a.333.333 0 0 1-.333-.334V4ZM4 2.667c-.736 0-1.333.597-1.333 1.333v2.222c0 .737.597 1.334 1.333 1.334h2.222c.737 0 1.334-.597 1.334-1.334V4c0-.736-.597-1.333-1.334-1.333H4Zm0 6.777a.333.333 0 0 0-.333.334V12c0 .184.149.333.333.333h2.222A.334.334 0 0 0 6.556 12V9.778a.333.333 0 0 0-.334-.334H4Zm-1.333.334c0-.737.597-1.334 1.333-1.334h2.222c.737 0 1.334.597 1.334 1.334V12c0 .736-.597 1.333-1.334 1.333H4A1.333 1.333 0 0 1 2.667 12V9.778Zm6.777 0c0-.184.15-.334.334-.334H12c.184 0 .333.15.333.334V12a.333.333 0 0 1-.333.333H9.778A.333.333 0 0 1 9.444 12V9.778Zm.334-1.334c-.737 0-1.334.597-1.334 1.334V12c0 .736.597 1.333 1.334 1.333H12c.736 0 1.333-.597 1.333-1.333V9.778c0-.737-.597-1.334-1.333-1.334H9.778Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.167 6a.5.5 0 0 1 .5-.5H18a.5.5 0 0 1 .5.5v3.333a.5.5 0 0 1-.5.5h-3.333a.5.5 0 0 1-.5-.5V6Zm.5-2a2 2 0 0 0-2 2v3.333a2 2 0 0 0 2 2H18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3.333ZM5.5 6a.5.5 0 0 1 .5-.5h3.333a.5.5 0 0 1 .5.5v3.333a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V6ZM6 4a2 2 0 0 0-2 2v3.333a2 2 0 0 0 2 2h3.333a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm0 10.167a.5.5 0 0 0-.5.5V18a.5.5 0 0 0 .5.5h3.333a.5.5 0 0 0 .5-.5v-3.333a.5.5 0 0 0-.5-.5H6Zm-2 .5a2 2 0 0 1 2-2h3.333a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3.333Zm10.167 0a.5.5 0 0 1 .5-.5H18a.5.5 0 0 1 .5.5V18a.5.5 0 0 1-.5.5h-3.333a.5.5 0 0 1-.5-.5v-3.333Zm.5-2a2 2 0 0 0-2 2V18a2 2 0 0 0 2 2H18a2 2 0 0 0 2-2v-3.333a2 2 0 0 0-2-2h-3.333Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLayout };
var IconLettter = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12.861 12.444h-.071a.694.694 0 0 1-.648-.444L9.031 3.933a.278.278 0 0 1 .259-.377c.196 0 .377-.187.377-.417a.416.416 0 0 0-.417-.417h-2.5a.416.416 0 0 0-.417.417.42.42 0 0 0 .377.417c.196 0 .33.195.26.377l-3.095 8.023-.017.044a.694.694 0 0 1-.648.444h-.071a.416.416 0 1 0 0 .834h1.643a.416.416 0 1 0 0-.834.136.136 0 0 1-.115-.06.135.135 0 0 1-.015-.128l.57-1.478h5l.57 1.478a.136.136 0 0 1-.015.128.136.136 0 0 1-.114.06.416.416 0 1 0 0 .834h2.198a.416.416 0 1 0 0-.834Zm-7.317-2.5 2.178-5.647 2.179 5.647H5.544Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M19.292 18.667h-.107c-.43 0-.817-.265-.972-.667L13.546 5.9a.416.416 0 0 1 .389-.567c.293 0 .565-.28.565-.625a.625.625 0 0 0-.625-.625h-3.75a.625.625 0 0 0-.625.625c0 .449.411.625.565.625.295 0 .494.294.389.567L5.812 17.933v.002L5.787 18a1.042 1.042 0 0 1-.972.667h-.107a.625.625 0 1 0 0 1.25h2.465a.625.625 0 1 0 0-1.25.205.205 0 0 1-.172-.09.204.204 0 0 1-.023-.192l.856-2.218h7.5l.854 2.216a.203.203 0 0 1-.022.193.204.204 0 0 1-.172.09.625.625 0 1 0 0 1.25h3.298a.625.625 0 1 0 0-1.25Zm-10.976-3.75 3.267-8.472 3.268 8.472H8.316Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLettter };
var IconLink = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8.29 9.086a1.87 1.87 0 0 0 .263-.232 2.01 2.01 0 0 0 0-2.726L6.606 4.065a1.748 1.748 0 0 0-2.573 0 2.01 2.01 0 0 0 0 2.726L5.494 8.34',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M7.646 6.914c-.07.055-.136.117-.2.184a2.04 2.04 0 0 0 0 2.751l1.948 2.081c.71.76 1.862.76 2.573 0 .71-.76.71-1.99 0-2.75l-1.452-1.552',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.3 5.145a3.566 3.566 0 0 0-5.237 0c-1.417 1.502-1.417 3.92 0 5.422l.957 1.013 1.397 1.481a.75.75 0 0 0 1.091-1.03l-1.397-1.48-.957-1.014c-.872-.924-.872-2.438 0-3.362.849-.9 2.206-.9 3.055 0l1.568 1.661 1.569 1.662c.872.924.872 2.44 0 3.363-.1.107-.208.2-.32.281a.75.75 0 0 0 .88 1.216c.187-.136.365-.292.53-.467 1.418-1.502 1.418-3.92 0-5.422l-1.568-1.662L10.3 5.145Zm1.598 5.691a.75.75 0 1 0-.937-1.172 3.71 3.71 0 0 0-.4.372c-1.415 1.512-1.414 3.943 0 5.455l1.569 1.677 1.568 1.677a3.55 3.55 0 0 0 5.241 0c1.415-1.513 1.415-3.944 0-5.457l-2.34-2.5a.75.75 0 1 0-1.095 1.025l2.34 2.5c.875.936.875 2.471 0 3.407-.849.907-2.202.907-3.05 0l-1.57-1.677-1.568-1.677c-.875-.935-.875-2.47 0-3.406l.002-.002a2.27 2.27 0 0 1 .24-.222Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLink };
var IconList = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.333 5.222a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Zm1.834-.5a.5.5 0 1 0 0 1h6.666a.5.5 0 1 0 0-1H6.167Zm0 2.778a.5.5 0 1 0 0 1h6.666a.5.5 0 1 0 0-1H6.167Zm-.5 3.278a.5.5 0 0 1 .5-.5h6.666a.5.5 0 1 1 0 1H6.167a.5.5 0 0 1-.5-.5ZM3.5 8.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Zm.833 1.945a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.5 7.833a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm2.75-.75a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-10Zm0 4.167a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-10Zm-.75 4.917a.75.75 0 0 1 .75-.75h10a.75.75 0 1 1 0 1.5h-10a.75.75 0 0 1-.75-.75ZM5.25 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm1.25 2.917a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconList };
var IconLock = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.694 4.667a1.306 1.306 0 1 1 2.612 0V6H6.694V4.667ZM5.694 6V4.667a2.306 2.306 0 1 1 4.612 0V6h.389c.736 0 1.333.597 1.333 1.333V12c0 .736-.597 1.333-1.334 1.333H5.306A1.333 1.333 0 0 1 3.972 12V7.333C3.972 6.597 4.57 6 5.306 6h.388Zm-.722 1.333c0-.184.15-.333.334-.333h5.388c.185 0 .334.15.334.333V12c0 .184-.15.333-.334.333H5.306A.333.333 0 0 1 4.972 12V7.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.042 7a1.958 1.958 0 1 1 3.916 0v2h-3.916V7Zm-1.5 2V7a3.458 3.458 0 1 1 6.916 0v2h.584a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7.958a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h.584Zm-1.084 2a.5.5 0 0 1 .5-.5h8.084a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H7.958a.5.5 0 0 1-.5-.5v-7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLock };
var IconLogout = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.013 2C4.696 2 2 4.67 2 7.972c0 3.302 2.696 5.972 6.013 5.972 1.91 0 3.61-.888 4.711-2.268a.5.5 0 1 0-.782-.623 5.012 5.012 0 0 1-3.93 1.891C5.242 12.944 3 10.714 3 7.972 3 5.23 5.24 3 8.013 3c1.594 0 3.01.74 3.93 1.892a.5.5 0 0 0 .781-.624A6.013 6.013 0 0 0 8.013 2Zm3.411 3.98a.5.5 0 0 1 .707 0l1.667 1.666a.5.5 0 0 1 0 .708l-1.667 1.666a.5.5 0 1 1-.707-.707l.809-.808L6.777 8.5a.5.5 0 0 1 .001-1l5.464.005-.818-.818a.5.5 0 0 1 0-.707Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.019 3C7.043 3 3 7.006 3 11.958c0 4.953 4.043 8.959 9.019 8.959a9.019 9.019 0 0 0 7.067-3.402.75.75 0 1 0-1.172-.936 7.52 7.52 0 0 1-5.895 2.838c-4.158 0-7.519-3.345-7.519-7.459C4.5 7.845 7.861 4.5 12.019 4.5a7.52 7.52 0 0 1 5.895 2.837.75.75 0 1 0 1.172-.935A9.019 9.019 0 0 0 12.02 3Zm5.117 5.97a.75.75 0 0 1 1.061 0l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.212-1.213-8.183-.007a.75.75 0 1 1 .001-1.5l8.196.007-1.227-1.227a.75.75 0 0 1 0-1.06Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLogout };
var IconMagnifyingglass = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.667 6.975a3.308 3.308 0 1 1 6.615 0 3.308 3.308 0 0 1-6.615 0Zm3.308-4.308a4.308 4.308 0 1 0 2.672 7.687l2.833 2.833a.5.5 0 0 0 .707-.707l-2.833-2.833a4.308 4.308 0 0 0-3.38-6.98Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 10.462a4.962 4.962 0 1 1 9.924 0 4.962 4.962 0 0 1-9.924 0ZM10.462 4a6.462 6.462 0 1 0 4.008 11.53l4.25 4.25a.75.75 0 0 0 1.06-1.06l-4.25-4.25A6.462 6.462 0 0 0 10.462 4Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMagnifyingglass };
var IconLoupeTool = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.167a4.833 4.833 0 1 0 0 9.666 4.833 4.833 0 0 0 0-9.666ZM2.167 8a5.833 5.833 0 1 1 11.666 0A5.833 5.833 0 0 1 2.167 8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconLoupeTool };
var IconMinusCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167ZM5.5 7.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm-3.5 8a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMinusCircle };
var IconMinus = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.75 8a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 3.75 8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 12a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 12Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMinus };
var IconMoreHorizontal = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM3 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-6 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMoreHorizontal };
var IconMoveTo = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 4.5c0-.46.373-.833.833-.833h2c.46 0 .834.373.834.833v2.167h1V4.5a1.833 1.833 0 0 0-1.834-1.833h-2C2.821 2.667 2 3.487 2 4.5v7c0 1.012.82 1.833 1.833 1.833h2c1.013 0 1.834-.82 1.834-1.833V9.333h-1V11.5c0 .46-.373.833-.834.833h-2A.833.833 0 0 1 3 11.5v-7Zm6.333 0c0-.46.373-.833.834-.833h2c.46 0 .833.373.833.833v7c0 .46-.373.833-.833.833h-2a.833.833 0 0 1-.834-.833V9.333h-1V11.5c0 1.012.821 1.833 1.834 1.833h2c1.012 0 1.833-.82 1.833-1.833v-7c0-1.013-.82-1.833-1.833-1.833h-2c-1.013 0-1.834.82-1.834 1.833v2.167h1V4.5ZM4.5 8a.5.5 0 0 1 .5-.5h5.626l-.48-.48a.5.5 0 0 1 .708-.707l1.333 1.333a.5.5 0 0 1 0 .708l-1.333 1.333a.5.5 0 0 1-.708-.707l.48-.48H5a.5.5 0 0 1-.5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.5 6.75c0-.69.56-1.25 1.25-1.25h3c.69 0 1.25.56 1.25 1.25V10h1.5V6.75A2.75 2.75 0 0 0 8.75 4h-3A2.75 2.75 0 0 0 3 6.75v10.5A2.75 2.75 0 0 0 5.75 20h3a2.75 2.75 0 0 0 2.75-2.75V14H10v3.25c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25V6.75Zm9.5 0c0-.69.56-1.25 1.25-1.25h3c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25V14h-1.5v3.25A2.75 2.75 0 0 0 15.25 20h3A2.75 2.75 0 0 0 21 17.25V6.75A2.75 2.75 0 0 0 18.25 4h-3a2.75 2.75 0 0 0-2.75 2.75V10H14V6.75ZM6.75 12a.75.75 0 0 1 .75-.75h8.44l-.72-.72a.75.75 0 1 1 1.06-1.06l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H7.5a.75.75 0 0 1-.75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMoveTo };
var IconMoreCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 9.666 0 4.833 4.833 0 0 1-9.666 0ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167ZM8.833 8a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Zm1.667.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM6.333 8a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM13.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm2.5 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM9.5 12A1.25 1.25 0 1 1 7 12a1.25 1.25 0 0 1 2.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMoreCircle };
var IconMoreVertical = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm0 6a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMoreVertical };
var IconMusic = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.167 2.667a2.5 2.5 0 0 0-2.5 2.5v5.666a2.5 2.5 0 0 0 2.5 2.5h5.666a2.5 2.5 0 0 0 2.5-2.5V5.167a2.5 2.5 0 0 0-2.5-2.5H5.167Zm-1.5 2.5a1.5 1.5 0 0 1 1.5-1.5h5.666a1.5 1.5 0 0 1 1.5 1.5v5.666a1.5 1.5 0 0 1-1.5 1.5H5.167a1.5 1.5 0 0 1-1.5-1.5V5.167ZM7.657 6a.5.5 0 0 0-1 0v4.222a.5.5 0 1 0 1 0V6Zm1.676.861a.5.5 0 1 0-1 0v2.5a.5.5 0 0 0 1 0v-2.5ZM11 7.556a.5.5 0 0 0-1 0v.888a.5.5 0 0 0 1 0v-.888ZM6 7.75a.5.5 0 0 0-1 0v.722a.5.5 0 0 0 1 0V7.75Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.75 4A3.75 3.75 0 0 0 4 7.75v8.5A3.75 3.75 0 0 0 7.75 20h8.5A3.75 3.75 0 0 0 20 16.25v-8.5A3.75 3.75 0 0 0 16.25 4h-8.5ZM5.5 7.75A2.25 2.25 0 0 1 7.75 5.5h8.5a2.25 2.25 0 0 1 2.25 2.25v8.5a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25v-8.5ZM11.485 9a.75.75 0 0 0-1.5 0v6.333a.75.75 0 0 0 1.5 0V9ZM14 10.292a.75.75 0 1 0-1.5 0v3.75a.75.75 0 0 0 1.5 0v-3.75Zm2.5 1.041a.75.75 0 0 0-1.5 0v1.334a.75.75 0 0 0 1.5 0v-1.334Zm-7.5.292a.75.75 0 0 0-1.5 0v1.083a.75.75 0 0 0 1.5 0v-1.083Z',
      fill: 'currentColor'
    }));
  }
});
export { IconMusic };
var IconNotifications = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.333c-2.298.002-4.333 2.063-4.333 4.384v2.028l-.66 1.8C2.674 11.296 3.3 12 4 12h2.2c.076.367.27.695.52.946.325.324.78.554 1.28.554s.955-.23 1.28-.554c.25-.25.444-.58.52-.946h2.227c.74 0 1.284-.737.966-1.454l-.66-1.801V6.61c0-1.128-.529-2.195-1.315-2.973C10.232 2.859 9.152 2.333 8 2.333ZM8.747 12H7.253a.958.958 0 0 0 .175.239c.17.17.381.261.572.261.19 0 .402-.091.572-.261A.958.958 0 0 0 8.747 12Zm-4.08-5.283c0-1.78 1.597-3.382 3.333-3.384.848 0 1.684.391 2.315 1.015.63.625 1.018 1.447 1.018 2.263v2.222a.5.5 0 0 0 .03.172l.697 1.902.017.041c.007.015.006.021.006.022a.02.02 0 0 1-.003.01.04.04 0 0 1-.015.012.078.078 0 0 1-.038.008H4a.09.09 0 0 1-.075-.034.03.03 0 0 1-.005-.01s0-.003.003-.008a.5.5 0 0 0 .017-.04l.696-1.903a.5.5 0 0 0 .03-.172V6.717Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.5c-3.448.002-6.5 3.094-6.5 6.575v3.042l-.989 2.701C4.011 16.945 4.951 18 6 18h3.301a2.84 2.84 0 0 0 .78 1.419c.487.486 1.17.831 1.919.831.75 0 1.432-.345 1.919-.831a2.84 2.84 0 0 0 .78-1.419h3.341c1.11 0 1.927-1.106 1.449-2.181l-.989-2.702v-3.2c0-1.693-.794-3.293-1.972-4.46C15.348 4.289 13.728 3.5 12 3.5ZM13.121 18h-2.242c.065.126.153.248.263.358.255.255.572.392.858.392.286 0 .603-.137.858-.392.11-.11.198-.232.263-.358ZM7 10.075C7 7.406 9.397 5.002 12 5c1.272 0 2.527.586 3.472 1.523C16.42 7.46 17 8.693 17 9.917v3.333c0 .088.015.175.046.258l1.044 2.853.026.061c.01.021.009.032.009.033a.03.03 0 0 1-.005.014.06.06 0 0 1-.023.019.117.117 0 0 1-.057.012H6a.136.136 0 0 1-.113-.05.047.047 0 0 1-.007-.015l.004-.012a.76.76 0 0 0 .026-.062l1.044-2.853A.75.75 0 0 0 7 13.25v-3.175Zm-1.12 6.361v-.001.001Z',
      fill: 'currentColor'
    }));
  }
});
export { IconNotifications };
var IconOpenIn = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9 2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V4.56L9.03 8.03a.75.75 0 0 1-1.06-1.06l3.47-3.47H9.75A.75.75 0 0 1 9 2.75ZM5 3h2v1.5H5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9H13v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13 4.75a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.97 5.97a.75.75 0 1 1-1.06-1.06l5.97-5.97h-3.69a.75.75 0 0 1-.75-.75ZM8 6.5h2V5H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2h-1.5v2a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 16V8A1.5 1.5 0 0 1 8 6.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconOpenIn };
var IconOverview = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.833 4.465c0-.349.283-.632.632-.632h7.237c.349 0 .631.283.631.632v7.237a.631.631 0 0 1-.631.631H4.465a.631.631 0 0 1-.632-.631V4.465Zm.632-1.632c-.901 0-1.632.73-1.632 1.632v7.237c0 .9.73 1.631 1.632 1.631h7.237c.9 0 1.631-.73 1.631-1.631V4.465c0-.901-.73-1.632-1.631-1.632H4.465Zm.98 4.667a.5.5 0 0 0 0 1h5.277a.5.5 0 1 0 0-1H5.444Zm-.5-1.167a.5.5 0 0 1 .5-.5h5.277a.5.5 0 1 1 0 1H5.444a.5.5 0 0 1-.5-.5Zm.5 2.834a.5.5 0 1 0 0 1h3.61a.5.5 0 0 0 0-1h-3.61Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 6.477c0-.54.437-.977.977-.977h11.046c.54 0 .977.437.977.977v11.046c0 .54-.437.977-.977.977H6.477a.977.977 0 0 1-.977-.977V6.477ZM6.477 4A2.477 2.477 0 0 0 4 6.477v11.046A2.477 2.477 0 0 0 6.477 20h11.046A2.477 2.477 0 0 0 20 17.523V6.477A2.477 2.477 0 0 0 17.523 4H6.477ZM8 11a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Zm-.75-1.75A.75.75 0 0 1 8 8.5h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM8 13.5A.75.75 0 0 0 8 15h6a.75.75 0 0 0 0-1.5H8Z',
      fill: 'currentColor'
    }));
  }
});
export { IconOverview };
var IconPageCarousel = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.333 3.167c.184 0 .334.149.334.333v.167H6.333V3.5c0-.184.15-.333.334-.333h2.666Zm-4 .5V3.5c0-.736.597-1.333 1.334-1.333h2.666c.737 0 1.334.597 1.334 1.333v.167C11.403 3.667 12 4.264 12 5v.333c.736 0 1.333.597 1.333 1.334v6c0 .736-.597 1.333-1.333 1.333H4a1.333 1.333 0 0 1-1.333-1.333v-6c0-.737.597-1.334 1.333-1.334V5c0-.736.597-1.333 1.333-1.333ZM11 5a.333.333 0 0 0-.333-.333H5.333A.333.333 0 0 0 5 5v.333h6V5ZM4.5 6.333H12c.184 0 .333.15.333.334v6A.333.333 0 0 1 12 13H4a.333.333 0 0 1-.333-.333v-6c0-.184.149-.334.333-.334h.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14 4.75a.5.5 0 0 1 .5.5v.25h-5v-.25a.5.5 0 0 1 .5-.5h4ZM8 5.5v-.25a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v.25a2 2 0 0 1 2 2V8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2v-.5a2 2 0 0 1 2-2Zm8.5 2A.5.5 0 0 0 16 7H8a.5.5 0 0 0-.5.5V8h9v-.5Zm1.5 2H6a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPageCarousel };
var IconPanelAssetViewer = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382ZM6 5.333v5.334c0 .368.298.666.667.666h2.666a.667.667 0 0 0 .667-.666V5.333a.667.667 0 0 0-.667-.666H6.667A.667.667 0 0 0 6 5.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM9 8v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPanelAssetViewer };
var IconPanelComments = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382Zm-3 .84v5.556c0 .307.25.555.556.555h.889a.555.555 0 0 0 .555-.555V5.222a.556.556 0 0 0-.555-.555h-.89a.556.556 0 0 0-.555.555Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM14 7.833v8.334c0 .46.373.833.833.833h1.334c.46 0 .833-.373.833-.833V7.833A.833.833 0 0 0 16.167 7h-1.334a.833.833 0 0 0-.833.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPanelComments };
var IconPanelHeader = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.667 4.667c0-.184.149-.334.333-.334h8c.184 0 .333.15.333.334v6.666a.334.334 0 0 1-.333.334H4a.333.333 0 0 1-.333-.334V4.667ZM4 3.333c-.736 0-1.333.597-1.333 1.334v6.666c0 .737.597 1.334 1.333 1.334h8c.736 0 1.333-.597 1.333-1.334V4.667c0-.737-.597-1.334-1.333-1.334H4Zm1.833 2a.833.833 0 0 0 0 1.667h4.334a.833.833 0 0 0 0-1.667H5.833Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 7a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V7ZM6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6Zm2.75 3a1.25 1.25 0 1 0 0 2.5h6.5a1.25 1.25 0 1 0 0-2.5h-6.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPanelHeader };
var IconPanelSidebarNavigation = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382Zm-7.666.84v5.556c0 .307.248.555.555.555h.89a.556.556 0 0 0 .555-.555V5.222a.556.556 0 0 0-.556-.555h-.889a.556.556 0 0 0-.555.555Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM7 7.833v8.334c0 .46.373.833.833.833h1.334c.46 0 .833-.373.833-.833V7.833A.833.833 0 0 0 9.167 7H7.833A.833.833 0 0 0 7 7.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPanelSidebarNavigation };
var IconPanelTimeline = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382Zm-1.555 4.951H5.222a.556.556 0 0 0-.555.556v.889c0 .307.248.555.555.555h5.556a.555.555 0 0 0 .555-.555v-.89a.556.556 0 0 0-.555-.555Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM16.167 14H7.833a.833.833 0 0 0-.833.833v1.334c0 .46.373.833.833.833h8.334c.46 0 .833-.373.833-.833v-1.334a.833.833 0 0 0-.833-.833Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPanelTimeline };
var IconPending = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.833 14a.5.5 0 0 1-.5-.5v-1.167A4.665 4.665 0 0 1 6.273 8a4.665 4.665 0 0 1-2.94-4.333V2.5a.5.5 0 0 1 .5-.5h8.334a.5.5 0 0 1 .5.5v1.167A4.665 4.665 0 0 1 9.727 8a4.665 4.665 0 0 1 2.94 4.333V13.5a.5.5 0 0 1-.5.5H3.833Zm.5-1.667V13h7.334v-.667a3.666 3.666 0 0 0-2.64-3.518.5.5 0 0 1-.36-.48v-.67a.5.5 0 0 1 .36-.48 3.666 3.666 0 0 0 2.64-3.518V3H4.333v.667a3.666 3.666 0 0 0 2.64 3.518.5.5 0 0 1 .36.48v.67a.5.5 0 0 1-.36.48 3.666 3.666 0 0 0-2.64 3.518ZM8 6.5A2.5 2.5 0 0 1 5.5 4h5A2.5 2.5 0 0 1 8 6.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.75 21a.75.75 0 0 1-.75-.75V18.5A6.997 6.997 0 0 1 9.41 12 6.997 6.997 0 0 1 5 5.5V3.75A.75.75 0 0 1 5.75 3h12.5a.75.75 0 0 1 .75.75V5.5a6.997 6.997 0 0 1-4.41 6.5A6.997 6.997 0 0 1 19 18.5v1.75a.75.75 0 0 1-.75.75H5.75Zm.75-2.5v1h11v-1a5.5 5.5 0 0 0-3.96-5.277.75.75 0 0 1-.54-.72v-1.006a.75.75 0 0 1 .54-.72A5.5 5.5 0 0 0 17.5 5.5v-1h-11v1a5.5 5.5 0 0 0 3.96 5.277.75.75 0 0 1 .54.72v1.006a.75.75 0 0 1-.54.72A5.5 5.5 0 0 0 6.5 18.5ZM12 9.75A3.75 3.75 0 0 1 8.25 6h7.5A3.75 3.75 0 0 1 12 9.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPending };
var IconPeople = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm8.657 4.918.365.341-.365-.34Zm1.95.002-.366.34.366-.34Zm.344 1.017.498.036-.498-.036Zm-.403.94.366.341-.366-.34Zm-1.831 0-.366.341.366-.34Zm-.403-.94.499-.036-.5.036ZM12.227 12l.003-.5h-.003v.5ZM6.93 12v-.5h-.003l.003.5Zm5.738-.213.394.308.003-.004-.397-.304Zm.113-.247-.49-.101.49.1Zm-.006-.271-.486.119.001.002.485-.121Zm-1.213-1.64-.262.427.262-.426Zm-3.968.01-.263-.426.263.425Zm-1.212 1.628.484.124v-.003l-.484-.12Zm-.007.272-.49.1.49-.1Zm.112.247-.397.303.003.004.394-.307ZM4.831 5.36l.366.34-.366-.34Zm1.415 0-.366.342.366-.341Zm.25.739.499.036-.499-.036Zm-.292.682.366.341-.366-.34Zm-1.33 0-.365.341.366-.34ZM4.583 6.1l.5-.036-.5.036Zm5.05-2.093c-.5 0-.986.19-1.341.57l.731.682a.815.815 0 0 1 .61-.252v-1Zm1.34.572a1.815 1.815 0 0 0-1.34-.572v1c.245 0 .459.092.609.254l.732-.682Zm.477 1.393a1.836 1.836 0 0 0-.476-1.393l-.732.682c.15.162.229.387.21.64l.998.071Zm-.535 1.246c.318-.342.502-.785.535-1.245l-.997-.072c-.018.244-.115.47-.27.636l.732.68Zm-1.281.576c.503 0 .955-.226 1.281-.576l-.732-.681a.753.753 0 0 1-.55.257v1ZM8.35 7.22c.326.349.778.575 1.282.575v-1a.757.757 0 0 1-.551-.258l-.73.683Zm-.536-1.247c.033.46.218.905.536 1.246l.732-.681a1.041 1.041 0 0 1-.27-.636l-.998.07Zm.476-1.394c-.358.384-.511.89-.476 1.394l.998-.07a.838.838 0 0 1 .21-.643l-.732-.681Zm3.936 6.922H6.93v1h5.297v-1Zm.028-.006a.055.055 0 0 1-.025.006l-.005 1c.161 0 .32-.035.465-.105l-.435-.9Zm.02-.015a.056.056 0 0 1-.02.015l.435.9c.146-.07.273-.172.372-.3l-.788-.615Zm.016-.04a.107.107 0 0 1-.02.044l.794.608a1.11 1.11 0 0 0 .206-.45l-.98-.202Zm0-.049a.11.11 0 0 1 0 .049l.98.202c.033-.164.03-.332-.011-.494l-.97.243Zm-.991-1.334c.518.318.854.777.99 1.332l.97-.238a3.133 3.133 0 0 0-1.436-1.946l-.524.852Zm-1.722-.45c.661 0 1.254.162 1.722.45l.524-.852c-.646-.397-1.425-.598-2.246-.598v1Zm-1.72.457c.465-.288 1.076-.457 1.72-.457v-1c-.808 0-1.606.21-2.247.607l.526.85Zm-.991 1.325c.136-.546.471-1.003.99-1.325l-.527-.85c-.728.452-1.231 1.121-1.433 1.934l.97.241Zm-.002.05a.107.107 0 0 1 .001-.047l-.969-.247c-.041.162-.045.33-.012.495l.98-.2Zm.02.044a.107.107 0 0 1-.02-.043l-.98.2c.034.163.104.317.205.45l.795-.607Zm.017.012a.057.057 0 0 1-.02-.016l-.789.615c.1.128.227.23.372.301l.437-.9Zm.025.006a.057.057 0 0 1-.025-.006l-.437.9c.146.07.306.107.467.106l-.005-1ZM5.539 4.562c-.398 0-.788.151-1.074.458l.732.682a.454.454 0 0 1 .342-.14v-1Zm1.073.46a1.454 1.454 0 0 0-1.073-.46v1c.142 0 .26.053.341.14l.732-.68Zm.383 1.113a1.47 1.47 0 0 0-.383-1.114l-.732.682a.47.47 0 0 1 .117.361l.998.071Zm-.425.988a1.62 1.62 0 0 0 .425-.987l-.998-.072a.621.621 0 0 1-.16.378l.733.681Zm-1.03.462c.407 0 .77-.183 1.03-.462l-.732-.681a.41.41 0 0 1-.299.143v1Zm-1.03-.461c.258.277.621.461 1.03.461v-1a.413.413 0 0 1-.3-.144l-.73.683Zm-.426-.99c.025.365.172.717.425.99l.732-.682a.618.618 0 0 1-.16-.378l-.997.07Zm.381-1.114a1.47 1.47 0 0 0-.381 1.115l.997-.07a.472.472 0 0 1 .116-.363l-.732-.682Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm12.985 7.378.549.51-.55-.51Zm2.925.002-.549.51.55-.51Zm.516 1.525.748.054-.748-.054Zm-.604 1.41.549.512-.549-.511Zm-2.747.001-.549.511v.001l.549-.512Zm-.604-1.411.748-.053-.748.053ZM18.34 18l.004-.75h-.004V18Zm-7.947 0v-.75h-.004l.004.75Zm8.315-.083.326.675-.326-.675Zm.293-.237.591.462.005-.006-.596-.456Zm.16-.777-.728.178.001.005.728-.183Zm-1.82-2.458-.392.639.393-.64Zm-5.951.012-.395-.637.395.637Zm-1.818 2.444.726.185.001-.004-.727-.18Zm-.01.407-.735.15.735-.15Zm.168.37-.596.455.005.007.591-.462Zm.294.238.328-.675-.328.675ZM7.247 8.041l.548.511-.548-.51Zm2.123.002-.55.51.55-.51Zm.374 1.107.748.054-.748-.054Zm-.438 1.024.549.51-.55-.51Zm-1.994 0-.549.51.001.002.548-.512Zm-.438-1.025.748-.052-.748.052ZM5.367 15.75V15h-.004l.004.75Zm-.268-.06-.327.674.327-.675Zm-.213-.173-.597.455.005.006.592-.461Zm-.123-.27.735-.15-.735.15Zm.007-.294.727.185.001-.004-.728-.181Zm1.32-1.774-.395-.638.395.638Zm4.32-.009-.394.639.393-.639Zm4.039-7.16c-.752 0-1.48.285-2.013.856l1.098 1.023a1.22 1.22 0 0 1 .915-.378v-1.5Zm2.01.859a2.723 2.723 0 0 0-2.01-.858v1.5c.367 0 .687.138.912.38l1.098-1.022Zm.715 2.09a2.754 2.754 0 0 0-.715-2.09L15.361 7.89c.227.243.344.581.317.96l1.496.108Zm-.803 1.868a3.066 3.066 0 0 0 .803-1.868l-1.496-.108a1.567 1.567 0 0 1-.405.954l1.098 1.022Zm-1.922.864c.755 0 1.433-.339 1.922-.864l-1.098-1.022c-.24.257-.533.386-.824.386v1.5Zm-1.922-.863c.489.523 1.167.863 1.922.863v-1.5c-.29 0-.585-.13-.826-.387l-1.096 1.024Zm-.804-1.87c.049.69.326 1.357.803 1.87l1.098-1.023a1.561 1.561 0 0 1-.405-.953l-1.496.106Zm.713-2.092c-.537.576-.767 1.336-.713 2.092l1.496-.106c-.027-.385.09-.723.315-.963l-1.098-1.023Zm5.905 10.384h-7.947v1.5h7.947v-1.5Zm.041-.008a.084.084 0 0 1-.037.008l-.008 1.5c.242.001.48-.053.698-.158l-.653-1.35Zm.03-.024a.085.085 0 0 1-.03.024l.654 1.35c.217-.106.408-.26.557-.45l-1.181-.924Zm.025-.06a.162.162 0 0 1-.03.066l1.19.912c.153-.199.258-.43.309-.675l-1.47-.303Zm-.002-.072a.163.163 0 0 1 .002.072l1.469.303a1.67 1.67 0 0 0-.016-.741l-1.455.366Zm-1.485-2.002c.777.477 1.28 1.165 1.484 1.997l1.457-.357c-.301-1.23-1.057-2.242-2.155-2.918l-.786 1.278Zm-2.582-.674c.99 0 1.88.242 2.582.674l.786-1.278c-.969-.596-2.138-.896-3.369-.896v1.5Zm-2.582.685c.698-.433 1.615-.685 2.582-.685v-1.5c-1.213 0-2.41.314-3.372.91l.79 1.275ZM10.3 17.082c.204-.82.707-1.505 1.486-1.987l-.79-1.275c-1.093.677-1.848 1.681-2.151 2.9l1.455.362Zm-.002.076a.161.161 0 0 1 .002-.072l-1.454-.37a1.66 1.66 0 0 0-.018.742l1.47-.3Zm.03.065a.16.16 0 0 1-.03-.065l-1.47.3c.05.245.155.476.307.675l1.193-.91Zm.025.018a.086.086 0 0 1-.03-.024l-1.183.923c.149.19.34.345.558.451l.655-1.35Zm.037.009a.084.084 0 0 1-.037-.009l-.655 1.35c.218.106.458.16.7.159l-.008-1.5ZM8.31 6.843a2.18 2.18 0 0 0-1.612.687l1.097 1.022a.682.682 0 0 1 .514-.209v-1.5Zm1.609.689a2.182 2.182 0 0 0-1.61-.689v1.5c.213 0 .39.08.512.21l1.098-1.021Zm.573 1.671a2.204 2.204 0 0 0-.573-1.671L8.82 8.554a.706.706 0 0 1 .175.543l1.496.106Zm-.637 1.481c.38-.407.598-.935.637-1.48l-1.496-.108a.932.932 0 0 1-.24.567l1.099 1.021Zm-1.546.693c.612 0 1.157-.275 1.546-.692L8.757 9.663c-.14.15-.3.214-.448.214v1.5Zm-1.545-.691c.389.416.933.691 1.545.691v-1.5a.619.619 0 0 1-.449-.215l-1.096 1.024Zm-.638-1.484c.038.547.257 1.075.637 1.483l1.098-1.022a.928.928 0 0 1-.24-.566l-1.495.105Zm.572-1.672a2.205 2.205 0 0 0-.572 1.672l1.496-.105a.707.707 0 0 1 .173-.545L6.698 7.53ZM5.363 15c.022 0 .043.005.063.014l-.654 1.35c.186.09.391.137.599.136L5.363 15Zm.063.014c.02.01.037.024.05.041l-1.182.923c.128.163.291.295.478.386l.654-1.35Zm.056.048c.008.01.014.023.016.036l-1.47.3c.043.208.132.404.261.574l1.193-.91Zm.016.036a.09.09 0 0 1 0 .04l-1.454-.37a1.41 1.41 0 0 0-.016.63l1.47-.3Zm0 .036c.135-.54.465-.994.987-1.318l-.79-1.275c-.836.518-1.418 1.291-1.652 2.23l1.455.363Zm.987-1.317c.47-.292 1.098-.467 1.765-.467v-1.5c-.913 0-1.82.236-2.555.691l.79 1.276Zm1.765-.467c.687 0 1.294.168 1.766.459l.786-1.278c-.74-.455-1.626-.68-2.552-.68v1.5Zm0 1.65H5.367v1.5H8.25V15Zm1.442 0H8.25v1.5h1.442V15Zm.324-1.191c.261.16.471.353.633.57l1.202-.898a3.749 3.749 0 0 0-1.049-.95l-.786 1.278Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPeople };
var IconPermissions = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.361c-.721 0-1.306.585-1.306 1.306v.72h2.612v-.72C9.306 3.946 8.72 3.36 8 3.36ZM5.694 5.383v.004h-.888c-.737 0-1.334.597-1.334 1.333v5.278c0 .736.597 1.333 1.334 1.333h6.388c.737 0 1.334-.597 1.334-1.333V6.72c0-.736-.597-1.333-1.334-1.333h-.888v-.72a2.306 2.306 0 1 0-4.612 0v.716Zm-.888 1.004a.333.333 0 0 0-.334.333v5.278c0 .184.15.333.334.333h6.388c.185 0 .334-.15.334-.333V6.72a.333.333 0 0 0-.334-.333H4.806Zm4.027 2.972a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 5.042A1.958 1.958 0 0 0 10.042 7v1.08h3.916V7A1.958 1.958 0 0 0 12 5.042ZM8.542 8.075v.005H7.208a2 2 0 0 0-2 2v7.917a2 2 0 0 0 2 2h9.584a2 2 0 0 0 2-2V10.08a2 2 0 0 0-2-2h-1.334V7a3.458 3.458 0 1 0-6.916 0v1.075ZM7.208 9.58a.5.5 0 0 0-.5.5v7.917a.5.5 0 0 0 .5.5h9.584a.5.5 0 0 0 .5-.5V10.08a.5.5 0 0 0-.5-.5H7.208Zm6.042 4.458a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPermissions };
var IconPersonCircleAdd = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.353 6.667A4.835 4.835 0 0 1 12.833 8a4.819 4.819 0 0 1-1.45 3.452 3.68 3.68 0 0 0-.869-.736c-.721-.444-1.593-.668-2.514-.668-.238 0-.474.016-.707.047a4.035 4.035 0 0 1 .017 1.01c.224-.038.455-.057.69-.057.761 0 1.447.185 1.99.52.237.146.44.316.61.507a4.845 4.845 0 0 1-3.81.605 4.016 4.016 0 0 1-.66.847 5.833 5.833 0 1 0-3.84-6.723 4.005 4.005 0 0 1 1.063-.137Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8.062 5.527c-.425 0-.822.16-1.108.467-.288.31-.42.724-.39 1.156.029.4.189.78.458 1.068.276.296.644.473 1.04.473s.763-.177 1.039-.473c.268-.288.428-.668.457-1.068a1.52 1.52 0 0 0-.39-1.154 1.493 1.493 0 0 0-1.106-.469Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.333 14a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Zm0-5.5a.5.5 0 0 1 .5.5v1.167H5a.5.5 0 1 1 0 1H3.833v1.166a.5.5 0 1 1-1 0v-1.166H1.667a.5.5 0 0 1 0-1h1.166V9a.5.5 0 0 1 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.03 10a7.25 7.25 0 1 1 12.045 7.178 5.519 5.519 0 0 0-1.304-1.104c-1.082-.666-2.39-1.003-3.77-1.003-.357 0-.712.025-1.062.072a6.05 6.05 0 0 1 .025 1.513A6.325 6.325 0 0 1 12 16.571c1.142 0 2.17.28 2.985.78.356.22.66.475.914.762A7.216 7.216 0 0 1 12 19.25c-.627 0-1.235-.08-1.815-.229a6.026 6.026 0 0 1-.99 1.27A8.76 8.76 0 0 0 12 20.75a8.75 8.75 0 1 0-8.566-10.544A6.008 6.008 0 0 1 5 10h.03Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M12.092 8.29c-.637 0-1.232.24-1.662.701-.431.464-.629 1.087-.583 1.734.042.6.282 1.17.686 1.602.414.444.966.71 1.56.71.593 0 1.145-.266 1.559-.71a2.63 2.63 0 0 0 .685-1.601c.046-.645-.153-1.267-.585-1.732a2.24 2.24 0 0 0-1.66-.703Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8.25a.75.75 0 0 1 .75.75v1.75H7.5a.75.75 0 0 1 0 1.5H5.75v1.75a.75.75 0 0 1-1.5 0v-1.75H2.5a.75.75 0 0 1 0-1.5h1.75V13.5a.75.75 0 0 1 .75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonCircleAdd };
var IconPersonStack = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.333 2a.5.5 0 0 0 0 1h5.334a.5.5 0 0 0 0-1H5.333ZM3.5 4.167a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5ZM3 7.22c0-.49.397-.887.889-.887h8.222c.492 0 .889.397.889.887v4.887c0 .493-.4.893-.889.893h-1.559a2.202 2.202 0 0 0-.907-1.053c-.462-.284-1.03-.434-1.645-.434-.602 0-1.187.157-1.646.441A2.22 2.22 0 0 0 5.449 13h-1.56A.893.893 0 0 1 3 12.107V7.22Zm.889-1.887A1.887 1.887 0 0 0 2 7.22v4.887C2 13.147 2.844 14 3.889 14h8.222A1.893 1.893 0 0 0 14 12.107V7.22a1.887 1.887 0 0 0-1.889-1.887H3.89Zm4.156 2c-.414 0-.8.155-1.08.455a1.48 1.48 0 0 0-.378 1.126c.028.389.184.76.445 1.04.27.288.628.461 1.013.461.386 0 .744-.172 1.012-.46.262-.282.417-.652.445-1.04.03-.42-.099-.823-.38-1.125a1.454 1.454 0 0 0-1.077-.457Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3a.75.75 0 0 0 0 1.5h8A.75.75 0 0 0 16 3H8ZM5.25 6.25A.75.75 0 0 1 6 5.5h12A.75.75 0 0 1 18 7H6a.75.75 0 0 1-.75-.75Zm-.75 4.58c0-.735.596-1.33 1.333-1.33h12.334a1.33 1.33 0 0 1 1.333 1.33v7.33c0 .74-.6 1.34-1.333 1.34h-2.338a3.303 3.303 0 0 0-1.361-1.579c-.693-.426-1.547-.651-2.468-.651-.903 0-1.78.235-2.469.662-.63.39-1.093.927-1.357 1.568h-2.34A1.34 1.34 0 0 1 4.5 18.16v-7.33ZM5.833 8A2.83 2.83 0 0 0 3 10.83v7.33A2.84 2.84 0 0 0 5.833 21h12.334A2.84 2.84 0 0 0 21 18.16v-7.33A2.83 2.83 0 0 0 18.167 8H5.833Zm6.235 3c-.621 0-1.2.233-1.62.682-.42.452-.612 1.058-.567 1.689.04.583.275 1.139.668 1.56.403.432.94.692 1.519.692.578 0 1.115-.26 1.518-.692a2.56 2.56 0 0 0 .668-1.56c.045-.628-.15-1.234-.57-1.686A2.181 2.181 0 0 0 12.067 11Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonStack };
var IconPersonCircle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 13.333A5.333 5.333 0 1 0 8 2.666a5.333 5.333 0 0 0 0 10.667Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M11.221 12.065a3.098 3.098 0 0 0-.969-.923c-.632-.39-1.411-.595-2.252-.595-.824 0-1.624.215-2.253.604-.397.246-.72.555-.962.914m3.277-6.538c-.425 0-.822.16-1.108.467-.288.31-.42.724-.39 1.156.029.4.189.78.458 1.068.276.296.644.473 1.04.473s.763-.177 1.039-.473c.268-.288.428-.668.457-1.068a1.52 1.52 0 0 0-.39-1.154 1.493 1.493 0 0 0-1.106-.469Z',
      stroke: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M16.831 18.098a4.646 4.646 0 0 0-1.453-1.385c-.948-.584-2.117-.892-3.378-.892-1.237 0-2.437.322-3.38.906a4.708 4.708 0 0 0-1.443 1.37M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-9.57-3.009c.43-.461 1.025-.7 1.662-.7a2.24 2.24 0 0 1 1.66.703c.432.465.631 1.087.585 1.732a2.63 2.63 0 0 1-.685 1.601c-.414.444-.966.71-1.56.71-.593 0-1.145-.266-1.56-.71a2.624 2.624 0 0 1-.685-1.602c-.046-.647.152-1.27.583-1.734Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconPersonCircle };
var IconPerson = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm11.008 12.333.002-.5h-.002v.5Zm-6.015 0v-.5H4.99l.003.5Zm-.502-.236-.398.303.004.004.394-.307Zm-.127-.28-.49.1.49-.1Zm.007-.308.484.123.001-.003-.485-.12Zm1.376-1.85-.263-.425.263.425Zm4.505-.01-.262.426.262-.426Zm1.377 1.86-.485.12v.003l.486-.122Zm.007.309.49.1-.49-.1Zm-.128.28.394.308.003-.004-.397-.304ZM6.954 4.3l.365.341-.365-.34Zm-.39 1.156.5-.035-.5.035Zm.458 1.068-.366.341.366-.34Zm2.079 0 .366.341-.366-.34Zm.457-1.067.499.036-.499-.036Zm-.39-1.155-.366.34.366-.34Zm1.84 7.531H4.993v1h6.015v-1Zm-6.018 0c-.047 0-.06-.007-.058-.006l-.437.9c.177.085.354.107.5.106l-.005-1Zm-.058-.006a.132.132 0 0 1-.047-.037l-.788.614c.106.137.243.247.398.323l.437-.9Zm-.044-.033a.19.19 0 0 1-.035-.077l-.98.2c.036.175.112.34.22.483l.795-.606Zm-.035-.077a.19.19 0 0 1 .002-.085l-.969-.247a1.19 1.19 0 0 0-.012.531l.98-.2Zm.003-.088c.16-.638.551-1.171 1.154-1.545l-.526-.85c-.813.503-1.373 1.25-1.598 2.154l.97.241Zm1.154-1.545c.54-.335 1.248-.529 1.99-.529v-1c-.906 0-1.8.235-2.516.679l.526.85ZM8 9.555c.761 0 1.447.186 1.99.52l.524-.851C9.793 8.78 8.921 8.555 8 8.555v1Zm1.99.52c.602.37.995.906 1.154 1.554l.971-.238c-.224-.914-.784-1.665-1.601-2.167l-.524.851Zm1.155 1.557a.19.19 0 0 1 .001.085l.98.202a1.191 1.191 0 0 0-.012-.531l-.97.244Zm.001.085a.19.19 0 0 1-.035.077l.794.608c.11-.142.184-.307.22-.483l-.979-.202Zm-.032.073a.131.131 0 0 1-.046.037l.436.9c.155-.075.291-.185.398-.32l-.788-.617Zm-.046.037c.002-.001-.011.007-.058.006l-.005 1c.146.001.323-.02.499-.106l-.436-.9ZM7.32 4.641a.993.993 0 0 1 .743-.308v-1c-.552 0-1.085.209-1.474.626l.731.682Zm-.256.78a1.02 1.02 0 0 1 .256-.78l-.731-.682a2.02 2.02 0 0 0-.522 1.532l.997-.07Zm.325.763a1.25 1.25 0 0 1-.325-.763l-.997.07c.036.509.24.998.59 1.374l.732-.681Zm.674.314a.926.926 0 0 1-.675-.315l-.73.683c.358.384.854.632 1.405.632v-1Zm.673-.314a.922.922 0 0 1-.673.314v1c.55 0 1.046-.248 1.405-.633l-.732-.681Zm.324-.763a1.254 1.254 0 0 1-.324.763l.732.68a2.25 2.25 0 0 0 .59-1.371l-.998-.072Zm-.257-.778c.185.199.28.474.257.778l.998.071a2.017 2.017 0 0 0-.523-1.53l-.732.68Zm-.74-.31c.295 0 .556.112.74.31l.732-.682a1.993 1.993 0 0 0-1.472-.628v1Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'm16.511 18.5.004-.75h-.004v.75Zm-9.022 0v-.75h-.004l.004.75Zm-.753-.355-.596.455.005.007.591-.462Zm-.18-.882.727.185.001-.004-.728-.181Zm2.065-2.775-.395-.637.395.637Zm6.757-.014-.393.639.393-.639Zm2.066 2.79-.728.18v.004l.728-.183Zm-.182.883.59.462.006-.006-.596-.456ZM10.43 6.45l.55.512-.55-.512Zm-.583 1.734.748-.053-.748.053Zm.686 1.603-.55.51.002.002.548-.512Zm3.119 0 .549.51-.55-.51Zm.685-1.602.748.054-.748-.054Zm-.585-1.732-.55.511.55-.51Zm2.76 11.297H7.488v1.5h9.022v-1.5Zm-9.027 0c-.07 0-.09-.01-.087-.01l-.655 1.35c.264.128.53.161.75.16l-.008-1.5Zm-.087-.01a.2.2 0 0 1-.07-.056l-1.183.923c.16.204.364.37.598.483l.655-1.35Zm-.065-.05a.284.284 0 0 1-.053-.115l-1.47.3c.054.263.167.511.33.725l1.193-.91Zm-.053-.115a.284.284 0 0 1 .003-.127l-1.453-.37c-.067.26-.073.533-.02.797l1.47-.3Zm.004-.13c.239-.958.827-1.759 1.732-2.32l-.79-1.274c-1.22.755-2.06 1.874-2.397 3.23l1.455.363Zm1.731-2.32c.811-.501 1.871-.792 2.985-.792v-1.5c-1.36 0-2.7.352-3.774 1.018l.79 1.275ZM12 14.334c1.142 0 2.17.279 2.985.78l.786-1.277c-1.082-.666-2.39-1.003-3.77-1.003v1.5Zm2.985.78c.904.556 1.493 1.359 1.73 2.33l1.458-.357c-.336-1.37-1.176-2.497-2.402-3.25l-.786 1.277Zm1.732 2.335c.01.041.011.085.003.127l1.469.303a1.786 1.786 0 0 0-.017-.796l-1.455.366Zm.003.127a.285.285 0 0 1-.053.116l1.19.912c.164-.213.277-.461.332-.725l-1.47-.303Zm-.048.11a.197.197 0 0 1-.07.056l.654 1.35c.233-.113.437-.278.597-.482l-1.181-.924Zm-.07.056c.004-.002-.017.01-.087.009l-.007 1.5c.219.001.484-.031.748-.159l-.654-1.35ZM10.98 6.96c.277-.296.666-.461 1.114-.461V5c-.829 0-1.628.313-2.211.94l1.097 1.022Zm-.384 1.17c-.033-.461.108-.873.384-1.17L9.882 5.94c-.588.632-.842 1.465-.783 2.298l1.496-.106Zm.486 1.145a1.875 1.875 0 0 1-.486-1.145L9.1 8.237a3.37 3.37 0 0 0 .885 2.06l1.098-1.021Zm1.011.47c-.36 0-.721-.16-1.011-.471l-1.096 1.024c.538.576 1.281.948 2.107.948v-1.5Zm1.01-.47c-.288.31-.648.47-1.01.47v1.5c.826 0 1.57-.37 2.108-.948l-1.097-1.023Zm.487-1.145a1.881 1.881 0 0 1-.487 1.145l1.099 1.021a3.38 3.38 0 0 0 .884-2.058L13.59 8.13Zm-.386-1.167c.278.299.419.711.386 1.168l1.496.106c.06-.833-.197-1.665-.785-2.296l-1.098 1.022Zm-1.11-.464c.442 0 .833.167 1.11.464L14.3 5.942A2.99 2.99 0 0 0 12.091 5v1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPerson };
var IconPin = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 7c0 1.39-.893 2.772-2.06 3.94A13.58 13.58 0 0 1 8 12.18a13.58 13.58 0 0 1-1.44-1.24C5.394 9.771 4.5 8.39 4.5 7c0-1.859 1.512-3.5 3.5-3.5s3.5 1.641 3.5 3.5ZM13 7c0 4-5 7-5 7s-5-3-5-7c0-2.645 2.143-5 5-5s5 2.355 5 5ZM8 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.5 10c0 2.819-1.476 5.221-3.106 7.002A17.825 17.825 0 0 1 12 19.172a17.606 17.606 0 0 1-2.394-2.17C7.976 15.222 6.5 12.819 6.5 10c0-2.917 2.37-5.5 5.5-5.5s5.5 2.583 5.5 5.5Zm1.5 0c0 6.706-7 11-7 11s-7-4.294-7-11c0-3.704 3-7 7-7s7 3.296 7 7Zm-7 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPin };
var IconPlay = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.984 4.576c0-.943 1.013-1.54 1.838-1.083l6.18 3.424a1.238 1.238 0 0 1 0 2.166l-6.18 3.424a1.238 1.238 0 0 1-1.838-1.083V4.576Zm1.284-.083a.095.095 0 0 0-.141.083v6.848c0 .072.078.119.141.083l6.18-3.424a.095.095 0 0 0 0-.166m0 0-6.18-3.424',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.976 6.864c0-1.415 1.52-2.31 2.757-1.624l9.27 5.136c1.276.707 1.276 2.541 0 3.248l-9.27 5.136c-1.238.686-2.757-.209-2.757-1.624V6.864Zm1.927-.125a.143.143 0 0 0-.212.125v10.272c0 .109.116.178.212.125l9.27-5.136a.143.143 0 0 0 0-.25m0 0L7.903 6.74',
      fill: 'currentColor'
    }));
  }
});
export { IconPlay };
var IconPlus = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 6.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPlus };
var IconPower = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 3a.5.5 0 0 0-1 0v4.444a.5.5 0 1 0 1 0V3ZM6.275 5.008a.5.5 0 1 0-.438-.9 4.944 4.944 0 1 0 4.327 0 .5.5 0 0 0-.439.9 3.945 3.945 0 1 1-3.45 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 4.5a.75.75 0 0 0-1.5 0v6.667a.75.75 0 0 0 1.5 0V4.5ZM9.412 7.511a.75.75 0 1 0-.657-1.348 7.416 7.416 0 1 0 6.49 0 .75.75 0 0 0-.657 1.348 5.917 5.917 0 1 1-5.176 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPower };
var IconProject = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.998 3.5h-1.656l.462 1.5h1.694V4a.5.5 0 0 0-.5-.5Zm-5.156 0h1.931L9.235 5H7.304l-.462-1.5Zm-2.84 0h1.271L5.735 5H3.502V4a.5.5 0 0 1 .5-.5ZM2 5h.003V4a2 2 0 0 1 2-2h7.996a2 2 0 0 1 2 2v1H14v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2l.002-5.5h-.003V5Zm10.5 7V6.5H3.501L3.5 12a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5ZM9.377 9.084a.5.5 0 0 1 0 .832l-1.599 1.066A.5.5 0 0 1 7 10.566V8.434a.5.5 0 0 1 .777-.416l1.599 1.066Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.997 5.5h-1.929l1.333 2h2.096V7a1.5 1.5 0 0 0-1.5-1.5Zm-7.429 0h3.697l1.334 2H10.9l-1.333-2Zm-2.565 0h.762l1.334 2H5.503V7a1.5 1.5 0 0 1 1.5-1.5ZM4 7.5h.004V7a3 3 0 0 1 3-3h9.994a3 3 0 0 1 3 3v.5H20V9h-.002L20 17a3 3 0 0 1-3 3H7.001a3 3 0 0 1-3-3l.002-8h-.004V7.5ZM18.5 17l-.002-8H5.503L5.5 17A1.5 1.5 0 0 0 7 18.5h9.998a1.5 1.5 0 0 0 1.5-1.5Zm-4.57-4.143a.75.75 0 0 1 0 1.286l-2.793 1.675A.75.75 0 0 1 10 15.175v-3.35a.75.75 0 0 1 1.136-.643l2.792 1.675Z',
      fill: 'currentColor'
    }));
  }
});
export { IconProject };
var IconRecent = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 3.167a4.826 4.826 0 0 0-3.896 1.972h.813a.5.5 0 1 1 0 1H2.972a.5.5 0 0 1-.5-.5V3.694a.5.5 0 0 1 1 0v.628A5.833 5.833 0 1 1 2.166 8a.5.5 0 1 1 1 0A4.833 4.833 0 1 0 8 3.167Zm.361 2.194a.5.5 0 1 0-1 0v3.333a.5.5 0 0 0 .5.5h2.222a.5.5 0 0 0 0-1H8.361V5.361Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.24 7.24 0 0 0-5.844 2.958h1.219a.75.75 0 0 1 0 1.5H4.458a.75.75 0 0 1-.75-.75V5.542a.75.75 0 1 1 1.5 0v.941A8.75 8.75 0 1 1 3.25 12a.75.75 0 0 1 1.5 0A7.25 7.25 0 1 0 12 4.75Zm.542 3.292a.75.75 0 0 0-1.5 0v5c0 .414.335.75.75.75h3.333a.75.75 0 0 0 0-1.5h-2.583v-4.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconRecent };
var IconRectangleAngled = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.27 3.513a1.633 1.633 0 0 0-1.155 2l1.412 5.267c.155.578.61.995 1.153 1.127a1.634 1.634 0 0 0 1.62 1.426h5.4c.902 0 1.633-.73 1.633-1.633V6.3c0-.902-.73-1.633-1.633-1.633h-.839l-.374-1.397a1.633 1.633 0 0 0-2-1.154L3.27 3.513Zm6.556 1.154L9.52 3.529a.633.633 0 0 0-.776-.448L3.53 4.48a.633.633 0 0 0-.448.776l1.412 5.266c.03.114.092.21.174.283V6.3c0-.902.73-1.633 1.633-1.633h3.526ZM5.666 6.3c0-.35.284-.633.634-.633h5.4c.35 0 .633.283.633.633v5.4c0 .35-.283.633-.633.633H6.3a.633.633 0 0 1-.633-.633V6.3Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.906 5.27a2.45 2.45 0 0 0-1.733 3l2.117 7.9a2.37 2.37 0 0 0 1.73 1.691A2.45 2.45 0 0 0 9.45 20h8.1A2.45 2.45 0 0 0 20 17.55v-8.1A2.45 2.45 0 0 0 17.55 7h-1.259l-.56-2.094a2.45 2.45 0 0 0-3.001-1.733L4.906 5.27ZM14.739 7l-.458-1.706a.95.95 0 0 0-1.163-.672L5.294 6.72a.95.95 0 0 0-.672 1.163l2.117 7.9c.046.17.139.315.261.424V9.45A2.45 2.45 0 0 1 9.45 7h5.289ZM8.5 9.45a.95.95 0 0 1 .95-.95h8.1a.95.95 0 0 1 .95.95v8.1a.95.95 0 0 1-.95.95h-8.1a.95.95 0 0 1-.95-.95v-8.1Z',
      fill: 'currentColor'
    }));
  }
});
export { IconRectangleAngled };
var IconRepeat = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.52 2.647a.5.5 0 0 0-.707.707l.813.813H4.3c-.902 0-1.633.731-1.633 1.633v.367a.5.5 0 1 0 1 0V5.8c0-.35.283-.633.633-.633h7.326l-.813.813a.5.5 0 1 0 .707.707l1.667-1.667a.5.5 0 0 0 0-.707L11.52 2.647ZM5.187 10.02a.5.5 0 0 0-.707-.707l-1.663 1.663a.514.514 0 0 0-.103.145.498.498 0 0 0-.047.21v.002a.51.51 0 0 0 .03.175.498.498 0 0 0 .116.179l1.667 1.667a.5.5 0 1 0 .707-.707l-.813-.814h6.66c.901 0 1.633-.73 1.633-1.633v-.367a.5.5 0 0 0-1 0v.367c0 .35-.284.633-.634.633h-6.66l.814-.813Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.463 3.807a.75.75 0 0 1 .817.163l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5A.75.75 0 0 1 16 9.5V7.75H7.75A2.25 2.25 0 0 0 5.5 10v.25a.75.75 0 0 1-1.5 0V10a3.75 3.75 0 0 1 3.75-3.75H16V4.5a.75.75 0 0 1 .463-.693ZM15.25 17.75A3.75 3.75 0 0 0 19 14v-.25a.75.75 0 0 0-1.5 0V14a2.25 2.25 0 0 1-2.25 2.25H8V14.5a.75.75 0 0 0-1.28-.53l-2.494 2.493a.752.752 0 0 0-.006 1.067l2.5 2.5A.75.75 0 0 0 8 19.5v-1.75h7.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconRepeat };
var IconReply = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.361 4.389a.139.139 0 0 0-.139.139v3.185L8 9.064l2.778-1.351V4.528a.139.139 0 0 0-.139-.14H5.361Zm6.25.69v-.551a.972.972 0 0 0-.972-.972H5.361a.972.972 0 0 0-.972.972v.55l-1.333.794a1.25 1.25 0 0 0-.612 1.074v4.248c0 .997.809 1.806 1.806 1.806h7.5c.997 0 1.806-.809 1.806-1.806V6.946c0-.44-.233-.849-.611-1.074l-1.334-.793Zm0 .97v1.259l1.078-.525a.417.417 0 0 0-.17-.195l-.908-.54Zm1.111 1.645-4.54 2.208a.417.417 0 0 1-.364 0l-4.54-2.208v3.5c0 .537.435.973.972.973h7.5a.972.972 0 0 0 .972-.973v-3.5Zm-9.411-.91 1.078.524v-1.26l-.907.54a.416.416 0 0 0-.171.195Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.042 5.5a.083.083 0 0 0-.084.083v5.908L12 13.458l4.042-1.967V9.4L7.958 7.614l8.084 1.785V5.583a.083.083 0 0 0-.084-.083H8.042Zm9.5 2.048V5.583c0-.874-.709-1.583-1.584-1.583H8.042c-.875 0-1.584.709-1.584 1.583v1.964L4.52 8.7a2 2 0 0 0-.978 1.72v6.372a2.834 2.834 0 0 0 2.833 2.833h11.25a2.834 2.834 0 0 0 2.833-2.833V10.42a2 2 0 0 0-.977-1.72l-1.94-1.152Zm0 1.745v.438l1.171.258-1.171-.696Zm0 .438v1.03l1.317-.64a.5.5 0 0 0-.145-.131l-1.172-.26Zm1.416 2.01-6.63 3.225a.75.75 0 0 1-.656 0l-6.63-3.225v5.05c0 .737.597 1.334 1.333 1.334h11.25c.736 0 1.333-.597 1.333-1.333V11.74ZM5.14 10.12l1.318.64V9.293l-1.172.697a.5.5 0 0 0-.146.132Z',
      fill: 'currentColor'
    }));
  }
});
export { IconReply };
var IconSave = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8a.5.5 0 0 1 .5-.5h4.126L5.48 6.354a.5.5 0 1 1 .707-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 1 1-.707-.708L6.626 8.5H2.5A.5.5 0 0 1 2 8Zm4.167 4.833a.5.5 0 0 1 .5-.5h5.5c.46 0 .833-.373.833-.833v-7a.833.833 0 0 0-.833-.833h-5.5a.5.5 0 1 1 0-1h5.5c1.012 0 1.833.82 1.833 1.833v7c0 1.012-.82 1.833-1.833 1.833h-5.5a.5.5 0 0 1-.5-.5ZM10.833 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM9.5 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 12a.75.75 0 0 1 .75-.75h6.19L8.22 9.53a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H3.75A.75.75 0 0 1 3 12Zm6.25 7.25a.75.75 0 0 1 .75-.75h8.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25H10A.75.75 0 0 1 10 4h8.25A2.75 2.75 0 0 1 21 6.75v10.5A2.75 2.75 0 0 1 18.25 20H10a.75.75 0 0 1-.75-.75Zm5-6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2.75 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSave };
var IconSelect = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.382 2.969a.5.5 0 1 0 0 1h.647a.5.5 0 1 0 0-1h-.647Zm2.089.5a.5.5 0 0 1 .5-.5h.647a.5.5 0 1 1 0 1h-.647a.5.5 0 0 1-.5-.5Zm3.09-.5a.5.5 0 1 0 0 1c.075 0 .181.04.286.18.104.139.184.355.184.614a.5.5 0 0 0 1 0c0-.455-.138-.886-.384-1.215-.247-.329-.626-.58-1.087-.58Zm1.47 8.591a.5.5 0 1 0-1 0 .47.47 0 0 1-.47.471.5.5 0 1 0 0 1 1.47 1.47 0 0 0 1.47-1.47Zm-4.56.971a.5.5 0 0 1 .5-.5h.647a.5.5 0 0 1 0 1h-.647a.5.5 0 0 1-.5-.5Zm-2.09-.5a.5.5 0 0 0 0 1h.648a.5.5 0 1 0 0-1h-.647ZM3.47 5.881a.5.5 0 0 1 .5.5v.648a.5.5 0 0 1-1 0v-.647a.5.5 0 0 1 .5-.5Zm.5 3.09a.5.5 0 0 0-1 0v.647a.5.5 0 1 0 1 0v-.647Zm8.562-3.09a.5.5 0 0 1 .5.5v.648a.5.5 0 1 1-1 0v-.647a.5.5 0 0 1 .5-.5Zm.5 3.09a.5.5 0 1 0-1 0v.647a.5.5 0 0 0 1 0v-.647ZM2.97 4.763c0-.99.803-1.794 1.795-1.794a.5.5 0 1 1 0 1 .795.795 0 0 0-.795.794.5.5 0 0 1-1 0Zm1 6.797a.5.5 0 1 0-1 0c0 .461.25.84.58 1.087.328.246.76.384 1.215.384a.5.5 0 1 0 0-1c-.26 0-.476-.08-.616-.184-.14-.105-.18-.211-.18-.287Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.412 4.002a.75.75 0 0 0 0 1.5h1.035a.75.75 0 1 0 0-1.5H9.412Zm3.391.75a.75.75 0 0 1 .75-.75h1.035a.75.75 0 0 1 0 1.5h-1.035a.75.75 0 0 1-.75-.75Zm4.892-.75a.75.75 0 0 0 0 1.5c.14 0 .323.074.498.307.174.233.305.589.305 1.014a.75.75 0 0 0 1.5 0c0-.718-.218-1.398-.605-1.914-.388-.517-.98-.907-1.698-.907Zm2.303 13.693a.75.75 0 1 0-1.5 0c0 .443-.36.803-.803.803a.75.75 0 0 0 0 1.5 2.303 2.303 0 0 0 2.303-2.303Zm-7.195 1.553a.75.75 0 0 1 .75-.75h1.035a.75.75 0 0 1 0 1.5h-1.035a.75.75 0 0 1-.75-.75Zm-3.391-.75a.75.75 0 0 0 0 1.5h1.035a.75.75 0 1 0 0-1.5H9.412Zm-4.66-9.836a.75.75 0 0 1 .75.75v1.035a.75.75 0 0 1-1.5 0V9.412a.75.75 0 0 1 .75-.75Zm.75 4.891a.75.75 0 0 0-1.5 0v1.035a.75.75 0 0 0 1.5 0v-1.035Zm13.746-4.891a.75.75 0 0 1 .75.75v1.035a.75.75 0 0 1-1.5 0V9.412a.75.75 0 0 1 .75-.75Zm.75 4.891a.75.75 0 0 0-1.5 0v1.035a.75.75 0 0 0 1.5 0v-1.035ZM4.002 6.823a2.82 2.82 0 0 1 2.821-2.82.75.75 0 0 1 0 1.5c-.73 0-1.32.59-1.32 1.32a.75.75 0 0 1-1.5 0Zm1.5 10.872a.75.75 0 1 0-1.5 0c0 .718.39 1.31.907 1.698.516.387 1.196.605 1.914.605a.75.75 0 1 0 0-1.5c-.425 0-.781-.13-1.014-.305-.233-.175-.307-.359-.307-.498Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSelect };
var IconShare = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.53 1.97a.75.75 0 0 0-1.06 0L5.803 3.636a.75.75 0 0 0 1.06 1.061l.387-.386V9.5a.75.75 0 1 0 1.5 0V4.31l.386.387a.75.75 0 1 0 1.061-1.06L8.53 1.97ZM5.005 6.917a.422.422 0 0 0-.422.421v4.324c0 .232.19.421.422.421h5.99a.422.422 0 0 0 .422-.421V7.338a.422.422 0 0 0-.422-.421h-.245a.75.75 0 0 1 0-1.5h.245c1.061 0 1.922.86 1.922 1.921v4.324c0 1.06-.86 1.921-1.922 1.921h-5.99a1.922 1.922 0 0 1-1.922-1.921V7.338c0-1.06.86-1.921 1.922-1.921h.245a.75.75 0 1 1 0 1.5h-.245Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.53 3.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v8.69a.75.75 0 0 0 1.5 0V5.56l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5ZM7.508 10c-.557 0-1.008.451-1.008 1.008v6.484c0 .557.451 1.008 1.008 1.008h8.984c.557 0 1.008-.451 1.008-1.008v-6.484c0-.557-.451-1.008-1.008-1.008H15a.75.75 0 0 1 0-1.5h1.492A2.508 2.508 0 0 1 19 11.008v6.484A2.508 2.508 0 0 1 16.492 20H7.508A2.508 2.508 0 0 1 5 17.492v-6.484A2.508 2.508 0 0 1 7.508 8.5H9A.75.75 0 0 1 9 10H7.508Z',
      fill: 'currentColor'
    }));
  }
});
export { IconShare };
var IconSheetCollapseLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382Zm-3 .84v5.556c0 .307.249.555.556.555h.889a.555.555 0 0 0 .555-.555V5.222a.556.556 0 0 0-.555-.555h-.89a.556.556 0 0 0-.555.555ZM5.957 8.5H8.25a.5.5 0 0 0 0-1H5.957l.813-.813a.5.5 0 0 0-.707-.707L4.396 7.646a.5.5 0 0 0 0 .708l1.667 1.666a.5.5 0 1 0 .707-.707L5.957 8.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM14 16.167c0 .46.373.833.833.833h1.334c.46 0 .833-.373.833-.833V7.833A.833.833 0 0 0 16.167 7h-1.334a.833.833 0 0 0-.833.833v8.334ZM8.936 11.25l1.22-1.22a.75.75 0 1 0-1.061-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h3.44a.75.75 0 0 0 0-1.5h-3.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSheetCollapseLeft };
var IconSheetCollapseRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.382 2.667c-.947 0-1.715.768-1.715 1.715v7.236c0 .947.768 1.715 1.715 1.715h7.236c.947 0 1.715-.768 1.715-1.715V4.382c0-.947-.768-1.715-1.715-1.715H4.382Zm-.715 1.715c0-.395.32-.715.715-.715h7.236c.395 0 .715.32.715.715v7.236c0 .395-.32.715-.715.715H4.382a.715.715 0 0 1-.715-.715V4.382Zm3 .84v5.556a.556.556 0 0 1-.556.555h-.889a.556.556 0 0 1-.555-.555V5.222c0-.307.248-.555.555-.555h.89c.306 0 .555.248.555.555ZM10.043 7.5l-.813-.813a.5.5 0 1 1 .707-.707l1.667 1.666a.5.5 0 0 1 0 .708L9.937 10.02a.5.5 0 1 1-.707-.707l.813-.813H7.75a.5.5 0 1 1 0-1h2.293Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.573 4A2.573 2.573 0 0 0 4 6.573v10.854A2.573 2.573 0 0 0 6.573 20h10.854A2.573 2.573 0 0 0 20 17.427V6.573A2.573 2.573 0 0 0 17.427 4H6.573ZM5.5 6.573c0-.593.48-1.073 1.073-1.073h10.854c.593 0 1.073.48 1.073 1.073v10.854c0 .593-.48 1.073-1.073 1.073H6.573c-.593 0-1.073-.48-1.073-1.073V6.573Zm4.5 1.26v8.334c0 .46-.373.833-.833.833H7.833A.833.833 0 0 1 7 16.167V7.833c0-.46.373-.833.833-.833h1.334c.46 0 .833.373.833.833Zm5.064 3.417-1.22-1.22a.75.75 0 1 1 1.061-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22h-3.44a.75.75 0 0 1 0-1.5h3.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSheetCollapseRight };
var IconSheetCollapse = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 0 1-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236Zm.715 1.715a.715.715 0 0 0-.715-.715H4.382a.715.715 0 0 0-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382ZM5.056 11.5h.888a.556.556 0 0 0 .556-.556V5.056a.556.556 0 0 0-.556-.556h-.888a.556.556 0 0 0-.556.556v5.888c0 .307.249.556.556.556Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.104 6.604a.5.5 0 1 0-.708-.708L7.648 7.645a.498.498 0 0 0 0 .71l1.748 1.749a.5.5 0 0 0 .707-.708L9.207 8.5h2.043a.5.5 0 0 0 0-1H9.207l.896-.896Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.427 4A2.573 2.573 0 0 1 20 6.573v10.854A2.573 2.573 0 0 1 17.427 20H6.573A2.573 2.573 0 0 1 4 17.427V6.573A2.573 2.573 0 0 1 6.573 4h10.854ZM18.5 6.573c0-.593-.48-1.073-1.073-1.073H6.573C5.98 5.5 5.5 5.98 5.5 6.573v10.854c0 .593.48 1.073 1.073 1.073h10.854c.593 0 1.073-.48 1.073-1.073V6.573ZM7 7.833v8.334c0 .46.373.833.833.833h1.334c.46 0 .833-.373.833-.833V7.833A.833.833 0 0 0 9.167 7H7.833A.833.833 0 0 0 7 7.833Zm6.686 3.417 1.22-1.22a.75.75 0 1 0-1.061-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h3.44a.75.75 0 0 0 0-1.5h-3.44Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSheetCollapse };
var IconShield = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M7.763 12.805c-.909-.432-4.126-2.32-4.345-7.435a.563.563 0 0 1 .508-.583c1.492-.155 2.784-.94 3.494-1.458a.981.981 0 0 1 1.161 0c.71.519 2.002 1.303 3.494 1.458.296.031.52.284.508.583-.22 5.115-3.437 7.003-4.345 7.435a.55.55 0 0 1-.475 0Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M11.644 19.208c-1.363-.649-6.189-3.48-6.517-11.153a.845.845 0 0 1 .762-.874c2.238-.233 4.176-1.41 5.24-2.187a1.472 1.472 0 0 1 1.743 0c1.064.778 3.002 1.954 5.24 2.187.444.046.78.426.762.874-.328 7.673-5.154 10.504-6.517 11.153a.825.825 0 0 1-.713 0Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconShield };
var IconShieldExclamationmark = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm8.334 1.934.003.002.015.013.064.054a8.812 8.812 0 0 0 1.245.837c.838.464 1.968.91 3.2.91a.5.5 0 0 1 .5.5h-.5.5v3.407c0 .937-.199 2.178-.957 3.419-.761 1.245-2.063 2.454-4.21 3.358a.5.5 0 0 1-.388 0c-2.147-.904-3.449-2.114-4.21-3.358a6.533 6.533 0 0 1-.957-3.42V4.25h.5-.5a.5.5 0 0 1 .5-.5c1.232 0 2.362-.446 3.2-.91a8.812 8.812 0 0 0 1.245-.837l.064-.054.015-.013.003-.002a.5.5 0 0 1 .668 0ZM3.64 4.73v2.926c0 .799.17 1.848.81 2.897.618 1.01 1.693 2.054 3.551 2.875 1.858-.821 2.933-1.865 3.55-2.875a5.527 5.527 0 0 0 .811-2.898V4.73c-1.26-.101-2.371-.565-3.184-1.015A9.812 9.812 0 0 1 8 2.95l-.082.062a9.81 9.81 0 0 1-1.095.704C6.01 4.165 4.9 4.63 3.64 4.73ZM8 6.638a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332Zm.5 1a.5.5 0 0 0-1 0v3.056a.5.5 0 0 0 1 0V7.64Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.501 2.9a.75.75 0 0 0-1.002 0l-.004.004-.022.02a10.041 10.041 0 0 1-.49.39c-.347.256-.851.601-1.475.947-1.256.695-2.95 1.364-4.8 1.364a.75.75 0 0 0-.75.75h.75-.75v5.109c0 1.407.299 3.268 1.436 5.129 1.142 1.867 3.095 3.681 6.315 5.038a.75.75 0 0 0 .582 0c3.22-1.357 5.174-3.17 6.315-5.038a9.799 9.799 0 0 0 1.436-5.13V6.376a.75.75 0 0 0-.75-.75c-1.85 0-3.544-.67-4.8-1.364a13.222 13.222 0 0 1-1.474-.949 10.119 10.119 0 0 1-.49-.389l-.023-.02-.004-.002Zm6.04 4.195c-1.89-.152-3.557-.847-4.776-1.522A14.73 14.73 0 0 1 12 4.423l-.123.093c-.388.29-.949.673-1.642 1.057-1.22.675-2.887 1.37-4.777 1.522v4.388c0 1.199.254 2.773 1.216 4.346C7.6 17.346 9.213 18.91 12 20.142c2.787-1.232 4.4-2.797 5.326-4.313a8.3 8.3 0 0 0 1.216-4.346V7.095ZM12 9.957a1 1 0 1 0 0-1.998 1 1 0 0 0 0 1.998Zm.75 1.5a.75.75 0 1 0-1.5 0v4.584a.75.75 0 0 0 1.5 0v-4.583Z',
      fill: 'currentColor'
    }));
  }
});
export { IconShieldExclamationmark };
var IconSkipAhead = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.354 3.646a.5.5 0 0 0-.817.544A4.5 4.5 0 1 0 12.5 8.667a.5.5 0 0 0-1 0A3.5 3.5 0 1 1 7.518 5.2a.5.5 0 0 0 .836.487l.666-.667a.5.5 0 0 0 0-.707l-.666-.667Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm9.778 5.333.666-.666L9.778 4',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.53 5.47a.75.75 0 0 0-1.224.815A6.75 6.75 0 1 0 18.75 13a.75.75 0 0 0-1.5 0 5.25 5.25 0 1 1-5.973-5.2.75.75 0 0 0 1.253.73l1-1a.75.75 0 0 0 0-1.06l-1-1Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm14.667 8 1-1-1-1',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconSkipAhead };
var IconSkipBack = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.646 3.646a.5.5 0 0 1 .817.544A4.5 4.5 0 1 1 3.5 8.667a.5.5 0 0 1 1 0A3.5 3.5 0 1 0 8.482 5.2a.5.5 0 0 1-.836.487L6.98 5.02a.5.5 0 0 1 0-.707l.666-.667Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm6.222 5.333-.667-.666L6.223 4',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.47 5.47a.75.75 0 0 1 1.224.815A6.75 6.75 0 1 1 5.25 13a.75.75 0 0 1 1.5 0 5.25 5.25 0 1 0 5.973-5.2.75.75 0 0 1-1.253.73l-1-1a.75.75 0 0 1 0-1.06l1-1Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm9.333 8-1-1 1-1',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconSkipBack };
var IconShuffle = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.854 2.813a.5.5 0 0 0-.854.354v1.166h-1.723a2.5 2.5 0 0 0-1.93.911L7 6.88 5.653 5.244a2.5 2.5 0 0 0-1.93-.91H2.5a.5.5 0 0 0 0 1h1.223c.448 0 .873.2 1.158.546l1.471 1.787-1.471 1.787A1.5 1.5 0 0 1 3.723 10H2.5a.5.5 0 0 0 0 1h1.223a2.5 2.5 0 0 0 1.93-.91L7 8.452l1.347 1.636a2.5 2.5 0 0 0 1.93.911H12v1.167a.5.5 0 0 0 .854.353l1.666-1.666a.5.5 0 0 0 0-.707L12.854 8.48a.5.5 0 0 0-.854.353V10h-1.723a1.5 1.5 0 0 1-1.158-.546L7.648 7.667 9.119 5.88a1.5 1.5 0 0 1 1.158-.547H12V6.5a.5.5 0 0 0 .854.354l1.666-1.667a.5.5 0 0 0 0-.707l-1.666-1.667Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.28 4.22a.75.75 0 0 0-1.28.53V6.5h-2.584a3.75 3.75 0 0 0-2.895 1.366L10.5 10.32 8.479 7.866A3.75 3.75 0 0 0 5.584 6.5H3.75a.75.75 0 1 0 0 1.5h1.834c.673 0 1.31.3 1.737.82l2.207 2.68-2.207 2.68a2.25 2.25 0 0 1-1.737.82H3.75a.75.75 0 0 0 0 1.5h1.834a3.75 3.75 0 0 0 2.895-1.366L10.5 12.68l2.021 2.454a3.75 3.75 0 0 0 2.895 1.366H18v1.75a.75.75 0 0 0 1.28.53l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 0 0-1.28.53V15h-2.584c-.673 0-1.31-.3-1.737-.82l-2.207-2.68 2.207-2.68A2.25 2.25 0 0 1 15.416 8H18v1.75a.75.75 0 0 0 1.28.53l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconShuffle };
var IconSkipToEnd = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.065 3.647a1.167 1.167 0 0 0-1.732 1.02v6.849c0 .889.955 1.45 1.732 1.02l.01-.006 5.843-3.421a1.15 1.15 0 0 0 .582-.84V12a.5.5 0 1 0 1 0V4a.5.5 0 0 0-1 0v3.914a1.15 1.15 0 0 0-.582-.84L5.076 3.653l-.01-.006Zm-.732 1.02c0-.125.134-.205.244-.147l5.84 3.42.01.006a.167.167 0 0 1 0 .291l-.01.006-5.84 3.42a.167.167 0 0 1-.244-.147V4.668Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.598 5.47A1.75 1.75 0 0 0 5 7.002v10.272a1.75 1.75 0 0 0 2.598 1.531l.008-.004.008-.005 8.763-5.132c.506-.284.797-.758.873-1.26V18a.75.75 0 0 0 1.5 0V6a.75.75 0 0 0-1.5 0v5.871a1.726 1.726 0 0 0-.873-1.26L7.614 5.48l-.008-.005-.008-.004ZM6.5 7.002c0-.188.2-.308.366-.221l8.76 5.13.007.005.008.004a.25.25 0 0 1 0 .437l-.008.004-.007.005-8.76 5.13a.25.25 0 0 1-.366-.222V7.001Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSkipToEnd };
var IconSort = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.417 3.194a.5.5 0 0 0 0 1h5.277a.5.5 0 1 0 0-1H3.417Zm7.222 2.084a.5.5 0 0 1 .5.5v5.876l1.09-1.09a.5.5 0 1 1 .708.706l-1.944 1.945a.5.5 0 0 1-.708 0L8.341 11.27a.5.5 0 1 1 .707-.707l1.09 1.091V5.778a.5.5 0 0 1 .5-.5Zm-7.722.639a.5.5 0 0 1 .5-.5h4.166a.5.5 0 0 1 0 1H3.417a.5.5 0 0 1-.5-.5Zm.5 1.722a.5.5 0 0 0 0 1h3.055a.5.5 0 0 0 0-1H3.417Zm-.5 2.722a.5.5 0 0 1 .5-.5H5.36a.5.5 0 0 1 0 1H3.417a.5.5 0 0 1-.5-.5Zm.5 1.722a.5.5 0 0 0 0 1h.833a.5.5 0 1 0 0-1h-.833Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.125 4.792a.75.75 0 1 0 0 1.5h7.917a.75.75 0 0 0 0-1.5H5.125Zm10.833 3.125a.75.75 0 0 1 .75.75v8.814l1.637-1.636a.75.75 0 0 1 1.06 1.06l-2.916 2.917a.75.75 0 0 1-1.061 0l-2.917-2.917a.75.75 0 1 1 1.061-1.06l1.636 1.636V8.667a.75.75 0 0 1 .75-.75Zm-11.583.958a.75.75 0 0 1 .75-.75h6.25a.75.75 0 0 1 0 1.5h-6.25a.75.75 0 0 1-.75-.75Zm.75 2.583a.75.75 0 0 0 0 1.5h4.583a.75.75 0 1 0 0-1.5H5.125Zm-.75 4.084a.75.75 0 0 1 .75-.75h2.917a.75.75 0 0 1 0 1.5H5.125a.75.75 0 0 1-.75-.75Zm.75 2.583a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5h-1.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSort };
var IconSkipToStart = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.768 3.647a1.167 1.167 0 0 1 1.732 1.02v6.849c0 .889-.954 1.45-1.732 1.02l-.01-.006-5.843-3.42a1.15 1.15 0 0 1-.582-.84V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 1 0v3.914c.05-.335.245-.65.582-.84l5.843-3.421.01-.006Zm.732 1.02a.167.167 0 0 0-.244-.147l-5.84 3.42-.01.006a.167.167 0 0 0 0 .291l.01.006 5.84 3.42a.167.167 0 0 0 .244-.147V4.668Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.152 5.47a1.75 1.75 0 0 1 2.598 1.531v10.272a1.75 1.75 0 0 1-2.598 1.531l-.008-.004-.008-.005-8.763-5.132a1.726 1.726 0 0 1-.873-1.26V18A.75.75 0 0 1 5 18V6a.75.75 0 0 1 1.5 0v5.871a1.73 1.73 0 0 1 .873-1.26l8.763-5.131.008-.005.008-.004Zm1.098 1.531a.25.25 0 0 0-.366-.221l-8.76 5.13-.007.005-.008.004a.25.25 0 0 0 0 .437l.008.004.007.005 8.76 5.13a.25.25 0 0 0 .366-.222V7.001Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSkipToStart };
var IconSport = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.583 3.184a4.835 4.835 0 0 0-4.388 4.292A5.62 5.62 0 0 1 6.88 9.12a5.62 5.62 0 0 1 1.644 3.685 4.835 4.835 0 0 0 4.292-4.388A5.619 5.619 0 0 1 9.22 6.779a5.625 5.625 0 0 1-1.638-3.595Zm1.005.018a4.618 4.618 0 0 0 1.34 2.87 4.618 4.618 0 0 0 2.87 1.34 4.836 4.836 0 0 0-4.21-4.21ZM7.523 12.81A4.835 4.835 0 0 1 3.19 8.478a4.62 4.62 0 0 1 2.983 1.349c.83.83 1.28 1.896 1.35 2.983ZM2.167 8a5.833 5.833 0 1 1 11.666 0A5.833 5.833 0 0 1 2.167 8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.375 4.777a7.252 7.252 0 0 0-6.583 6.437 8.43 8.43 0 0 1 5.529 2.466 8.428 8.428 0 0 1 2.465 5.528 7.252 7.252 0 0 0 6.437-6.583 8.427 8.427 0 0 1-5.391-2.457 8.428 8.428 0 0 1-2.457-5.391Zm1.507.026a6.928 6.928 0 0 0 2.01 4.305 6.927 6.927 0 0 0 4.305 2.01 7.253 7.253 0 0 0-6.315-6.315Zm-1.598 14.412a7.252 7.252 0 0 1-6.499-6.498A6.93 6.93 0 0 1 9.26 14.74a6.929 6.929 0 0 1 2.024 4.475ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSport };
var IconSpeaker = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.67 3.919 9.03 5.28a3.833 3.833 0 0 1-2.45.886h-.913a.333.333 0 0 0-.334.333v3c0 .184.15.333.334.333h.913c.895 0 1.762.313 2.45.886l1.64 1.362V3.919Zm-.291-1.059a.778.778 0 0 1 1.29.585v9.11a.778.778 0 0 1-1.29.585L8.39 11.488a2.833 2.833 0 0 0-1.81-.655h-.914A1.333 1.333 0 0 1 4.333 9.5v-3c0-.736.597-1.333 1.334-1.333h.913c.662 0 1.302-.232 1.811-.655L10.38 2.86Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm16.004 5.878-2.458 2.044A5.75 5.75 0 0 1 9.87 9.25H8.5a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 .5.5h1.37a5.75 5.75 0 0 1 3.676 1.328l2.458 2.044V5.878Zm-.436-1.587c.75-.66 1.936-.13 1.936.876v13.665c0 1.007-1.186 1.538-1.936.877l-2.981-2.477a4.25 4.25 0 0 0-2.717-.982H8.5a2 2 0 0 1-2-2v-4.5a2 2 0 0 1 2-2h1.37a4.25 4.25 0 0 0 2.717-.982l2.981-2.477Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSpeaker };
var IconStar = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.389a.75.75 0 0 1 .67.414l1.355 2.71 3.228.496a.75.75 0 0 1 .416 1.271l-2.231 2.232.498 3.235a.75.75 0 0 1-1.088.78L8 12.04l-2.848 1.486a.75.75 0 0 1-1.088-.779l.498-3.235L2.331 7.28a.75.75 0 0 1 .416-1.271l3.228-.497 1.354-2.709A.75.75 0 0 1 8 2.39Zm0 2.427L7.143 6.53a.75.75 0 0 1-.557.406l-2.148.33L5.891 8.72a.75.75 0 0 1 .211.644l-.33 2.147 1.881-.981a.75.75 0 0 1 .694 0l1.88.98-.33-2.146a.75.75 0 0 1 .212-.644l1.453-1.454-2.148-.33a.75.75 0 0 1-.557-.406L8 4.816Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 3.958a.75.75 0 0 1 .67.415l2.12 4.236 5.032.775a.75.75 0 0 1 .417 1.271l-3.482 3.482.776 5.04a.75.75 0 0 1-1.088.78L12 17.637l-4.445 2.32a.75.75 0 0 1-1.088-.78l.776-5.04-3.482-3.482a.75.75 0 0 1 .417-1.271l5.033-.775 2.118-4.236A.75.75 0 0 1 12 3.958Zm0 2.427-1.62 3.242a.75.75 0 0 1-.558.406l-3.953.608 2.703 2.704a.75.75 0 0 1 .211.644l-.608 3.953 3.478-1.815a.75.75 0 0 1 .694 0l3.478 1.815-.608-3.953a.75.75 0 0 1 .211-.644l2.703-2.704-3.953-.608a.75.75 0 0 1-.557-.406L12 6.385Z',
      fill: 'currentColor'
    }));
  }
});
export { IconStar };
var IconSupport = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.667 5.222c0-.505.393-.889.847-.889h6.972c.454 0 .847.384.847.89v4.721c0 .506-.393.89-.847.89h-2.93a.5.5 0 0 0-.306.104l-2.428 1.877v-1.482a.5.5 0 0 0-.5-.5h-.808c-.454 0-.847-.383-.847-.889V5.222Zm.847-1.889c-1.034 0-1.847.86-1.847 1.89v4.721c0 1.03.813 1.89 1.847 1.89h.308v1.444c0 .615.708 1.027 1.237.618l2.668-2.063h2.759c1.034 0 1.847-.86 1.847-1.889V5.222c0-1.028-.813-1.889-1.847-1.889H4.514ZM6.056 8a.555.555 0 1 0 0-1.11.555.555 0 0 0 0 1.11Zm3.888 0a.555.555 0 1 0 0-1.11.555.555 0 0 0 0 1.11Zm-1.388-.556a.555.555 0 1 1-1.111 0 .555.555 0 0 1 1.11 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 7.833c0-.758.59-1.333 1.271-1.333h10.458c.68 0 1.271.575 1.271 1.333v7.084c0 .758-.59 1.333-1.271 1.333h-4.395a.75.75 0 0 0-.459.157l-3.641 2.815V17a.75.75 0 0 0-.75-.75H6.77c-.68 0-1.271-.575-1.271-1.333V7.833ZM6.771 5C5.219 5 4 6.29 4 7.833v7.084c0 1.543 1.22 2.833 2.771 2.833h.463v2.167c0 .922 1.061 1.54 1.855.926l4.001-3.093h4.139c1.552 0 2.771-1.29 2.771-2.833V7.833C20 6.29 18.78 5 17.229 5H6.771Zm2.312 7a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Zm5.834 0a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Zm-2.084-.833a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconSupport };
var IconSsoSettings = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm8.334 1.934.003.002.015.013.064.054a8.811 8.811 0 0 0 1.245.837c.838.464 1.968.91 3.2.91a.5.5 0 0 1 .5.5h-.5.5v3.407c0 .937-.199 2.178-.957 3.419-.761 1.245-2.063 2.454-4.21 3.358a.5.5 0 0 1-.388 0c-2.147-.904-3.449-2.114-4.21-3.358a6.533 6.533 0 0 1-.957-3.42V4.25h.5-.5a.5.5 0 0 1 .5-.5c1.232 0 2.362-.446 3.2-.91a8.812 8.812 0 0 0 1.245-.837l.064-.054.015-.013.003-.002a.5.5 0 0 1 .668 0ZM3.64 4.73v2.926c0 .799.17 1.848.81 2.897.618 1.01 1.693 2.054 3.551 2.875 1.858-.821 2.933-1.865 3.55-2.875a5.527 5.527 0 0 0 .811-2.898V4.73c-1.26-.101-2.371-.565-3.184-1.015A9.812 9.812 0 0 1 8 2.95l-.082.062a9.966 9.966 0 0 1-1.095.704c-.813.45-1.924.914-3.184 1.015Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12 20.958c6.187-2.605 7.292-6.87 7.292-9.475V6.375C15.245 6.375 12 3.458 12 3.458S8.755 6.375 4.708 6.375v5.108c0 2.606 1.105 6.87 7.292 9.475Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconSsoSettings };
var IconTag = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.556 3.333a1.889 1.889 0 0 0-1.89 1.89v5.555a1.89 1.89 0 0 0 1.89 1.889H8.85a2.17 2.17 0 0 0 1.506-.61l2.753-2.66.006-.006a1.97 1.97 0 0 0 0-2.782l-.006-.006-2.753-2.66a2.166 2.166 0 0 0-1.505-.61H4.556Zm-.89 1.89a.89.89 0 0 1 .89-.89H8.85c.302 0 .593.118.81.328l2.75 2.657a.97.97 0 0 1 0 1.363l-2.75 2.657a1.17 1.17 0 0 1-.811.329H4.556a.889.889 0 0 1-.89-.89V5.223ZM11.334 8A.667.667 0 1 1 10 8a.667.667 0 0 1 1.333 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.833 5A2.834 2.834 0 0 0 4 7.833v8.334A2.834 2.834 0 0 0 6.833 19h6.442c.843 0 1.653-.328 2.26-.913l4.128-3.992.01-.008a2.954 2.954 0 0 0 0-4.174l-.01-.009-4.128-3.99A3.25 3.25 0 0 0 13.275 5H6.834ZM5.5 7.833c0-.736.597-1.333 1.333-1.333h6.443c.454 0 .89.176 1.216.492l4.124 3.986c.56.564.56 1.48 0 2.044l-4.124 3.986a1.754 1.754 0 0 1-1.217.492H6.833A1.334 1.334 0 0 1 5.5 16.167V7.833ZM17 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTag };
var IconTextAlignCenter = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M2.5 8h11M3.333 3.833h9.334m-8 8.334h6.666',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.25 5.75A.75.75 0 0 1 5 5h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm4 5.5A.75.75 0 0 0 7 19h10a.75.75 0 0 0 0-1.5H7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTextAlignCenter };
var IconTextAlignLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M2.5 8h11m-11-4.167h9.333M2.5 12.167h6.667',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M3.75 12h16.5M3.75 5.75h14m-14 12.5h10',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconTextAlignLeft };
var IconTextCursor = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M11.111 13.333V2.667',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.315 4c.307 0 .555.249.555.556v.463a.556.556 0 0 1-1.006.324H6.389v5.564h.231a.556.556 0 0 1 0 1.111H5a.556.556 0 1 1 0-1.11h.278V5.342H3.674a.555.555 0 0 1-1.007-.324v-.463a.556.556 0 0 1 1.007-.324h4.19c.1-.14.265-.232.45-.232Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M12.167 2.5H9.944m2.223 11H9.944',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.167 3.75a.75.75 0 0 1 .75-.75h3.333a.75.75 0 0 1 0 1.5h-.833v15h.833a.75.75 0 0 1 0 1.5h-3.333a.75.75 0 0 1 0-1.5h1v-15h-1a.75.75 0 0 1-.75-.75Zm-.861 3.083a.833.833 0 0 0-1.51-.486H5.51A.832.832 0 0 0 4 6.833v.695a.833.833 0 0 0 1.51.486h2.407v8.347H7.5a.833.833 0 0 0 0 1.667h2.43a.833.833 0 1 0 0-1.667h-.347V8.014h2.212a.832.832 0 0 0 1.51-.486v-.695Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTextCursor };
var IconTextAlignRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M13.5 8h-11m11-4.167H4.167m9.333 8.334H6.833',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M20.25 12H3.75m16.5-6.25h-14m14 12.5h-10',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconTextAlignRight };
var IconTimer = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M4.229 4.229A5.333 5.333 0 1 0 8 2.667c-.049 0-.096.005-.144.006v.859m.005 4.329L5.64 5.64',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.847 3.255c.036-.002.092-.005.153-.005a8.75 8.75 0 1 1-6.187 2.563.75.75 0 1 1 1.06 1.06 7.25 7.25 0 1 0 5.66-2.104v.528a.75.75 0 0 1-1.5 0V4.01a.75.75 0 0 1 .733-.75c.017 0 .033-.002.067-.004h.014ZM7.928 7.928a.75.75 0 0 1 1.06 0l3.075 3.074a1 1 0 1 1-1.061 1.06L7.928 8.99a.75.75 0 0 1 0-1.061Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTimer };
var IconTrademark = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.361 8a4.639 4.639 0 1 1 9.278 0A4.639 4.639 0 0 1 3.36 8ZM8 2.361A5.639 5.639 0 1 0 8 13.64 5.639 5.639 0 0 0 8 2.36ZM6.333 4.722a.5.5 0 0 0-.5.5v5.556a.5.5 0 0 0 1 0V9.333H8.14c.032 0 .064 0 .096-.002l1.31 1.747a.5.5 0 0 0 .8-.6L9.264 9.04A2.305 2.305 0 0 0 8.14 4.722H6.334Zm.5 1v2.611H8.14a1.306 1.306 0 1 0 0-2.61H6.833Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.042 12a6.958 6.958 0 1 1 13.916 0 6.958 6.958 0 0 1-13.916 0ZM12 3.542a8.458 8.458 0 1 0 0 16.916 8.458 8.458 0 0 0 0-16.916ZM9.5 7.083a.75.75 0 0 0-.75.75v8.334a.75.75 0 0 0 1.5 0V14h1.958l.144-.003 1.965 2.62a.75.75 0 0 0 1.2-.9l-1.618-2.158a3.458 3.458 0 0 0-1.69-6.476H9.5Zm.75 1.5V12.5h1.958a1.958 1.958 0 1 0 0-3.917H10.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTrademark };
var IconTransport = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 2.306a.5.5 0 0 0-1 0v.888H5.361c-.583 0-1.055.473-1.055 1.056v2.425l-1.575.426a.5.5 0 0 0-.33.68l.81 1.888.268 1.608a.5.5 0 1 0 .986-.165l-.277-1.666a.5.5 0 0 0-.034-.115l-.606-1.415L8 6.712l4.452 1.204-.606 1.415a.494.494 0 0 0-.034.115l-.277 1.666a.5.5 0 1 0 .986.165l.268-1.608.81-1.889a.5.5 0 0 0-.33-.68l-1.575-.425V4.25c0-.583-.472-1.056-1.055-1.056H8.5v-.888Zm-.506 1.888a.576.576 0 0 0 .012 0h2.633c.03 0 .055.025.055.056v2.155L8.13 5.712a.5.5 0 0 0-.26 0l-2.564.693V4.25c0-.03.024-.056.055-.056h2.633Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M6.194 12.028s.573.555 1.806.555c1.232 0 1.806-.555 1.806-.555s.573.555 1.805.555c1.233 0 1.806-.555 1.806-.555m-10.834 0s.573.555 1.806.555c1.232 0 1.805-.555 1.805-.555',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 3.458a.75.75 0 0 0-1.5 0v1.334H8.042c-.875 0-1.584.708-1.584 1.583v3.637l-2.362.639a.75.75 0 0 0-.494 1.02l1.215 2.833.402 2.411a.75.75 0 0 0 1.48-.247l-.418-2.5a.751.751 0 0 0-.05-.172l-.91-2.122L12 10.069l6.679 1.805-.91 2.122a.75.75 0 0 0-.05.172l-.417 2.5a.75.75 0 0 0 1.48.247l.401-2.41 1.215-2.835a.75.75 0 0 0-.494-1.019l-2.362-.639V6.375c0-.875-.71-1.583-1.584-1.583H12.75V3.458Zm-.756 2.834h3.964c.046 0 .084.037.084.083v3.232l-3.846-1.04a.75.75 0 0 0-.392 0l-3.846 1.04V6.375c0-.046.037-.083.084-.083h3.952Zm-8.119 11.75c-.522.538-.522.538-.521.539l.001.002.003.002.007.006.017.016.051.045a3.91 3.91 0 0 0 .785.486c.54.252 1.324.487 2.365.487 1.041 0 1.826-.235 2.365-.487.13-.06.244-.122.344-.18.1.059.214.12.343.18.539.252 1.324.487 2.365.487 1.041 0 1.826-.235 2.365-.487.129-.06.243-.122.343-.18.1.059.215.12.344.18.539.252 1.324.487 2.365.487 1.04 0 1.826-.235 2.365-.487.268-.125.472-.253.616-.356a2.714 2.714 0 0 0 .22-.175l.017-.016.007-.006.003-.003.002-.001-.522-.54.522.54a.75.75 0 0 0-1.036-1.085l-.009.007a2.418 2.418 0 0 1-.455.276c-.353.165-.923.346-1.73.346-.808 0-1.377-.181-1.73-.346a2.418 2.418 0 0 1-.456-.276l-.008-.007a.75.75 0 0 0-1.029 0l-.009.007a1.403 1.403 0 0 1-.075.058 2.418 2.418 0 0 1-.38.218c-.353.165-.922.346-1.73.346-.808 0-1.377-.181-1.73-.346a2.419 2.419 0 0 1-.455-.276l-.009-.007a.75.75 0 0 0-1.029 0l-.008.007a2.417 2.417 0 0 1-.455.276c-.354.165-.923.346-1.73.346-.808 0-1.377-.181-1.73-.346a2.416 2.416 0 0 1-.456-.276l-.009-.007a.75.75 0 0 0-1.036 1.084l.522-.538Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTransport };
var IconTrash = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.972 3.556a2.028 2.028 0 1 1 4.056 0v.11h2.805a.5.5 0 1 1 0 1h-.456l-.727 7.211v.001a1.61 1.61 0 0 1-1.603 1.455H5.953a1.61 1.61 0 0 1-1.603-1.455l-.727-7.211h-.456a.5.5 0 1 1 0-1h2.805v-.111Zm-1.344 1.11.717 7.113v.002c.03.313.294.552.608.552h4.094a.61.61 0 0 0 .608-.552v-.002l.717-7.112H4.628Zm4.4-1.11v.11H6.972v-.11a1.028 1.028 0 1 1 2.056 0Zm-1.5 3.11a.5.5 0 1 0-1 0v4.167a.5.5 0 1 0 1 0V6.667Zm1.444-.5a.5.5 0 0 1 .5.5v4.167a.5.5 0 1 1-1 0V6.667a.5.5 0 0 1 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.958 5.333a3.041 3.041 0 1 1 6.084 0V5.5h4.208a.75.75 0 0 1 0 1.5h-.684l-1.09 10.816v.001A2.416 2.416 0 0 1 15.07 20H8.93a2.417 2.417 0 0 1-2.406-2.183v-.001L5.434 7H4.75a.75.75 0 0 1 0-1.5h4.208v-.167ZM6.941 7l1.076 10.669v.003c.046.47.44.828.913.828h6.14a.916.916 0 0 0 .912-.828v-.003L17.058 7H6.941Zm6.6-1.667V5.5h-3.083v-.167a1.541 1.541 0 1 1 3.084 0ZM11.292 10a.75.75 0 0 0-1.5 0v6.25a.75.75 0 1 0 1.5 0V10Zm2.167-.75a.75.75 0 0 1 .75.75v6.25a.75.75 0 1 1-1.5 0V10a.75.75 0 0 1 .75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTrash };
var IconTranscode = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 2.5a.5.5 0 0 0-1 0v2.333a.5.5 0 0 0 .5.5h2.333a.5.5 0 1 0 0-1H4.601A4.98 4.98 0 0 1 8 3c1.162 0 2.23.396 3.08 1.06a.5.5 0 0 0 .616-.787A5.976 5.976 0 0 0 8 2a5.978 5.978 0 0 0-4 1.528V2.5Zm6.167 8.167a.5.5 0 1 0 0 1h1.232A4.981 4.981 0 0 1 8 13a4.976 4.976 0 0 1-3.08-1.06.5.5 0 0 0-.616.787A5.975 5.975 0 0 0 8 14a5.978 5.978 0 0 0 4-1.528V13.5a.5.5 0 0 0 1 0v-2.333a.5.5 0 0 0-.5-.5h-2.333ZM3 6.833a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-.5 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.167 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM14 9.167a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-.5-1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-.167-2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 3.75a.75.75 0 0 0-1.5 0v3.5c0 .414.336.75.75.75h3.5a.75.75 0 0 0 0-1.5H6.9a7.471 7.471 0 0 1 5.1-2c1.743 0 3.345.594 4.619 1.59a.75.75 0 0 0 .924-1.18A8.964 8.964 0 0 0 12 3a8.968 8.968 0 0 0-6 2.292V3.75ZM15.25 16a.75.75 0 0 0 0 1.5h1.849a7.47 7.47 0 0 1-5.099 2 7.464 7.464 0 0 1-4.619-1.59.75.75 0 1 0-.924 1.18A8.963 8.963 0 0 0 12 21a8.967 8.967 0 0 0 6-2.292v1.542a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75h-3.5ZM4.5 10.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM3.75 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm1.75 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm15.5-2.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75-2.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM20 7.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTranscode };
var IconTurnArrowDownRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 13.333A5.333 5.333 0 1 1 8 2.667a5.333 5.333 0 0 1 0 10.666Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M9.217 10.01V6.86A1.859 1.859 0 0 0 7.36 5C6.332 5 5.5 5.807 5.5 6.833',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm10.833 9.217-1.616 1.616-1.616-1.616',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 1 0 14.5 7.25 7.25 0 0 1 0-14.5ZM20.75 12a8.75 8.75 0 1 0-17.5 0 8.75 8.75 0 0 0 17.5 0Zm-9.712-5.25a3.538 3.538 0 0 1 3.538 3.538v4.151l1.144-1.144a.75.75 0 1 1 1.06 1.061l-2.424 2.424a.75.75 0 0 1-1.06 0l-2.425-2.424a.75.75 0 0 1 1.06-1.06l1.145 1.143v-4.151a2.038 2.038 0 0 0-2.038-2.038c-1.14 0-2.038.888-2.038 2a.75.75 0 0 1-1.5 0c0-1.967 1.597-3.5 3.538-3.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTurnArrowDownRight };
var IconUnarchived = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm4.654 2.568-.347 1.296 8.372 2.243.347-1.296-8.372-2.243Zm-.908-.474a.786.786 0 0 1 .967-.546l8.772 2.35a.786.786 0 0 1 .564.957l-.462 1.726a.784.784 0 0 1-.92.557v4.306c0 1.061-.888 1.89-1.943 1.89H5.276c-1.055 0-1.943-.829-1.943-1.89v-4.11a.5.5 0 1 1 1 0v4.11c0 .474.404.89.943.89h5.448c.539 0 .943-.416.943-.89V6.871L3.848 4.776a.786.786 0 0 1-.564-.956l.462-1.726ZM6.75 7.361a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1h-2.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.982 3.852 6.46 5.796l12.557 3.365.52-1.944L6.983 3.852Zm-1.363-.71c.176-.658.853-.98 1.451-.82l13.157 3.526c.598.16 1.023.777.847 1.435L20.38 9.87c-.169.632-.8.954-1.38.835v6.46C19 18.759 17.668 20 16.086 20H7.914C6.332 20 5 18.758 5 17.167V11a.75.75 0 0 1 1.5 0v6.167c0 .71.606 1.333 1.414 1.333h8.172c.808 0 1.414-.624 1.414-1.333v-6.86L5.773 7.165c-.598-.16-1.024-.777-.847-1.435l.693-2.588Zm4.506 7.9a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5h-3.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconUnarchived };
var IconTurnArrowDownLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 13.333A5.333 5.333 0 1 0 8 2.667a5.333 5.333 0 0 0 0 10.666Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M6.783 10.01V6.86C6.783 5.832 7.615 5 8.64 5c1.027 0 1.859.807 1.859 1.833',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'm5.167 9.217 1.616 1.616 1.616-1.616',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm9.712-5.25a3.538 3.538 0 0 0-3.538 3.538v4.151L8.28 13.295a.75.75 0 1 0-1.06 1.061l2.424 2.424a.75.75 0 0 0 1.06 0l2.425-2.424a.75.75 0 0 0-1.06-1.06l-1.145 1.143v-4.151c0-1.126.913-2.038 2.038-2.038 1.139 0 2.038.888 2.038 2a.75.75 0 0 0 1.5 0c0-1.967-1.598-3.5-3.538-3.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconTurnArrowDownLeft };
var IconUploads = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.833c-1.594 0-2.657 1.035-3.101 2.122-1.36.274-2.732 1.407-2.732 3.08 0 1.735 1.625 3.132 3.273 3.132H6a.5.5 0 0 0 0-1h-.56c-1.168 0-2.273-1.019-2.273-2.132 0-1.145 1.048-2.022 2.153-2.134a.5.5 0 0 0 .428-.353C6.011 4.676 6.798 3.833 8 3.833c1.252 0 2.405 1.015 2.574 2.741a.5.5 0 0 0 .472.45c.362.02.831.171 1.2.449.36.27.587.63.587 1.08 0 .947-.858 1.614-1.846 1.614H10a.5.5 0 1 0 0 1h.987c1.358 0 2.846-.948 2.846-2.614 0-.84-.444-1.47-.986-1.879a3.358 3.358 0 0 0-1.332-.594C11.169 4.156 9.745 2.833 8 2.833Zm0 4a.5.5 0 0 0-.316.113l-1.663 1.33a.5.5 0 1 0 .625.781l.854-.683v4.96a.5.5 0 1 0 1 0v-4.96l.854.683a.5.5 0 1 0 .625-.78L8.315 6.944a.498.498 0 0 0-.312-.112H8Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.25c-2.39 0-3.986 1.551-4.652 3.183-2.04.41-4.098 2.11-4.098 4.62 0 2.601 2.438 4.697 4.91 4.697H9a.75.75 0 0 0 0-1.5h-.84c-1.752 0-3.41-1.528-3.41-3.197 0-1.719 1.572-3.033 3.23-3.2a.75.75 0 0 0 .642-.53C9.016 7.014 10.198 5.75 12 5.75c1.878 0 3.607 1.522 3.862 4.112a.75.75 0 0 0 .707.675 3.473 3.473 0 0 1 1.8.672c.539.407.881.946.881 1.62 0 1.42-1.287 2.421-2.77 2.421H15a.75.75 0 0 0 0 1.5h1.48c2.037 0 4.27-1.422 4.27-3.92 0-1.261-.666-2.206-1.479-2.819a5.037 5.037 0 0 0-1.999-.89C16.754 6.233 14.618 4.25 12 4.25Zm0 6a.747.747 0 0 0-.474.169L9.03 12.414a.75.75 0 1 0 .937 1.172l1.282-1.026V20a.75.75 0 0 0 1.5 0v-7.44l1.281 1.026a.75.75 0 0 0 .938-1.172l-2.497-1.997A.747.747 0 0 0 12 10.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconUploads };
var IconUnlock = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.694 4.667a1.306 1.306 0 1 1 2.612 0 .5.5 0 0 0 1 0 2.306 2.306 0 1 0-4.612 0V6h-.388c-.737 0-1.334.597-1.334 1.333V12c0 .736.597 1.333 1.334 1.333h5.388c.737 0 1.334-.597 1.334-1.333V7.333c0-.736-.597-1.333-1.334-1.333h-4V4.667ZM4.972 7.333c0-.184.15-.333.334-.333h5.388c.185 0 .334.15.334.333V12c0 .184-.15.333-.334.333H5.306A.333.333 0 0 1 4.972 12V7.333Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.042 7a1.958 1.958 0 1 1 3.916 0 .75.75 0 1 0 1.5 0 3.458 3.458 0 1 0-6.916 0v2h-.584a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8.084a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-6V7Zm-2.584 4a.5.5 0 0 1 .5-.5h8.084a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H7.958a.5.5 0 0 1-.5-.5v-7Z',
      fill: 'currentColor'
    }));
  }
});
export { IconUnlock };
var IconVideoScrub = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 2.5a.5.5 0 0 0-1 0V4H4.62a2.333 2.333 0 0 0-2.334 2.333v3.334A2.333 2.333 0 0 0 4.619 12H7.5v1.5a.5.5 0 0 0 1 0V12h2.881a2.333 2.333 0 0 0 2.333-2.333V6.333A2.333 2.333 0 0 0 11.381 4H8.5V2.5ZM7.5 5H4.62c-.737 0-1.334.597-1.334 1.333v3.334c0 .736.597 1.333 1.333 1.333H7.5V5Zm1 6V5h2.881c.736 0 1.333.597 1.333 1.333v3.334c0 .736-.597 1.333-1.333 1.333H8.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 3.75a.75.75 0 0 0-1.5 0V6H6.929a3.5 3.5 0 0 0-3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h4.321v2.25a.75.75 0 0 0 1.5 0V18h4.321a3.5 3.5 0 0 0 3.5-3.5v-5a3.5 3.5 0 0 0-3.5-3.5H12.75V3.75Zm-1.5 3.75H6.929a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4.321v-9Zm1.5 9v-9h4.321a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H12.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconVideoScrub };
var IconVideo = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.667 2.667a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V4.667a2 2 0 0 0-2-2H4.667Zm-1 2a1 1 0 0 1 1-1h6.666a1 1 0 0 1 1 1v6.666a1 1 0 0 1-1 1H4.667a1 1 0 0 1-1-1V4.667Zm1.5-.334a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm1.333.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm1.333.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-5.166 5.834a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm1.333.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm1.333.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM7.255 6.493A.167.167 0 0 0 7 6.634v2.732c0 .13.144.21.255.141l2.186-1.366a.167.167 0 0 0 0-.282L7.255 6.493Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7ZM5.5 7A1.5 1.5 0 0 1 7 5.5h10A1.5 1.5 0 0 1 18.5 7v10a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 17V7Zm2.25-.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2 .75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm3.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2 .75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM7.75 16a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2 .75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM13.5 16a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2 .75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm-4.617-7.01a.25.25 0 0 0-.383.211v4.098a.25.25 0 0 0 .383.212l3.278-2.049a.25.25 0 0 0 0-.424l-3.278-2.049Z',
      fill: 'currentColor'
    }));
  }
});
export { IconVideo };
var IconWand = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.246 2.16c.024-.09.151-.09.175 0l.118.438a.75.75 0 0 0 .53.53l.438.118c.09.024.09.151 0 .175l-.439.118a.75.75 0 0 0-.529.53l-.118.438c-.024.09-.151.09-.175 0l-.119-.439a.75.75 0 0 0-.529-.529l-.439-.118c-.09-.024-.09-.151 0-.175l.44-.119a.75.75 0 0 0 .528-.529l.119-.439Zm6.234.217c-.04-.15-.253-.15-.293 0l-.197.731a1.25 1.25 0 0 1-.882.882l-.731.197c-.15.04-.15.252 0 .293l.731.197c.43.115.766.451.882.882l.197.73c.04.15.252.15.293 0l.197-.73a1.25 1.25 0 0 1 .882-.882l.73-.197c.15-.04.15-.253 0-.293l-.73-.197a1.25 1.25 0 0 1-.882-.882l-.197-.731ZM7.547 6.372 6.386 7.564l-.81-.81a.834.834 0 0 1 .588-1.42c.214 0 .427.082.59.243l.793.795Zm5.543 6.717a.824.824 0 0 1-.587.244.825.825 0 0 1-.588-.244L6.976 8.151 8.137 6.96l4.953 4.955a.831.831 0 0 1 0 1.175ZM5.47 8.843l-.078-.292c-.016-.06-.101-.06-.117 0l-.079.292a.5.5 0 0 1-.353.353l-.292.079c-.06.016-.06.1 0 .117l.292.079a.5.5 0 0 1 .353.352l.079.293c.016.06.1.06.117 0l.079-.293a.5.5 0 0 1 .352-.352l.293-.08c.06-.015.06-.1 0-.116l-.293-.079a.5.5 0 0 1-.352-.353Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.868 3.24a.137.137 0 0 1 .264 0l.177.657c.104.387.407.69.794.794l.658.177c.134.037.134.227 0 .264l-.658.177c-.387.104-.69.407-.794.794l-.177.658c-.037.134-.227.134-.264 0l-.177-.658a1.125 1.125 0 0 0-.794-.794l-.658-.177c-.134-.037-.134-.227 0-.264l.658-.177c.387-.104.69-.407.794-.794l.177-.658Zm9.351.325c-.06-.224-.378-.224-.438 0l-.296 1.097a1.875 1.875 0 0 1-1.323 1.323l-1.097.296c-.224.06-.224.378 0 .438l1.097.296c.645.174 1.15.678 1.323 1.323l.296 1.097c.06.224.378.224.438 0l.296-1.097a1.875 1.875 0 0 1 1.323-1.323l1.097-.296c.224-.06.224-.378 0-.438l-1.097-.296a1.875 1.875 0 0 1-1.323-1.323l-.296-1.097ZM11.322 9.56 9.58 11.347l-1.214-1.214a1.252 1.252 0 0 1 0-1.766 1.247 1.247 0 0 1 1.767 0l1.189 1.193Zm8.314 10.075a1.237 1.237 0 0 1-.881.366c-.32 0-.636-.12-.882-.366l-7.408-7.407 1.742-1.787 7.43 7.432a1.247 1.247 0 0 1 0 1.762Zm-11.43-6.37-.117-.438c-.024-.09-.152-.09-.176 0l-.118.439a.75.75 0 0 1-.53.53l-.438.117c-.09.024-.09.152 0 .176l.439.118a.75.75 0 0 1 .53.53l.117.438c.024.09.152.09.176 0l.118-.439a.75.75 0 0 1 .53-.53l.438-.117c.09-.024.09-.152 0-.176l-.439-.118a.75.75 0 0 1-.53-.53Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWand };
var IconWarning = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.83 3.329c.51-.92 1.83-.92 2.34 0l4.3 7.768a1.338 1.338 0 0 1-1.17 1.986H3.7a1.338 1.338 0 0 1-1.17-1.986l4.3-7.768Zm.875.484-4.3 7.768a.338.338 0 0 0 .295.502h8.6c.257 0 .42-.276.296-.502l-4.3-7.768a.337.337 0 0 0-.591 0ZM8 5.694a.5.5 0 0 1 .5.5v2.778a.5.5 0 1 1-1 0V6.194a.5.5 0 0 1 .5-.5Zm.667 4.973a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.245 4.993c.764-1.38 2.746-1.38 3.51 0l6.45 11.652c.74 1.337-.225 2.98-1.754 2.98H5.55c-1.53 0-2.495-1.643-1.755-2.98l6.45-11.652Zm1.313.726-6.45 11.653a.507.507 0 0 0 .442.753h12.9a.507.507 0 0 0 .444-.753L12.442 5.72a.506.506 0 0 0-.886 0ZM12 8.542a.75.75 0 0 1 .75.75v4.166a.75.75 0 0 1-1.5 0V9.292a.75.75 0 0 1 .75-.75ZM13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWarning };
var IconWatermarkAlignCenter = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.833 2C2.821 2 2 2.82 2 3.833v8.334C2 13.179 2.82 14 3.833 14h8.334C13.179 14 14 13.18 14 12.167V3.833C14 2.821 13.18 2 12.167 2H3.833ZM3 3.833c0-.46.373-.833.833-.833h8.334c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H3.833A.833.833 0 0 1 3 12.167V3.833ZM11.333 8A.667.667 0 1 1 10 8a.667.667 0 0 1 1.333 0ZM8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM6 8a.667.667 0 1 1-1.333 0A.667.667 0 0 1 6 8Zm1.333 2.667a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0ZM8 6a.667.667 0 1 1 0-1.333A.667.667 0 0 1 8 6Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75ZM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75ZM17 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm1-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWatermarkAlignCenter };
var IconWatermarkAlignLeft = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.833 2C2.821 2 2 2.82 2 3.833v8.334C2 13.179 2.82 14 3.833 14H7.5c1.012 0 1.833-.82 1.833-1.833V3.833C9.333 2.821 8.513 2 7.5 2H3.833ZM3 3.833c0-.46.373-.833.833-.833H7.5c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H3.833A.833.833 0 0 1 3 12.167V3.833Zm10.136.991a.5.5 0 0 1 .864.343v5.666a.5.5 0 0 1-.864.343l-2.667-2.833a.5.5 0 0 1 0-.686l2.667-2.833Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h5.5A2.75 2.75 0 0 0 14 18.25V5.75A2.75 2.75 0 0 0 11.25 3h-5.5ZM4.5 5.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25V5.75Zm15.203 1.486A.75.75 0 0 1 21 7.75v8.5a.75.75 0 0 1-1.297.514l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWatermarkAlignLeft };
var IconWatermarkAlignRight = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.5 2c-1.013 0-1.833.82-1.833 1.833v8.334c0 1.012.82 1.833 1.833 1.833h3.667C13.179 14 14 13.18 14 12.167V3.833C14 2.821 13.18 2 12.167 2H8.5Zm-.833 1.833c0-.46.373-.833.833-.833h3.667c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H8.5a.833.833 0 0 1-.833-.833V3.833Zm-5.351.869a.501.501 0 0 1 .548.122l2.667 2.833a.5.5 0 0 1 0 .686l-2.667 2.833A.502.502 0 0 1 2 10.833V5.167a.5.5 0 0 1 .316-.465Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.75 3A2.75 2.75 0 0 0 10 5.75v12.5A2.75 2.75 0 0 0 12.75 21h5.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3h-5.5ZM11.5 5.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25V5.75ZM3.473 7.053a.752.752 0 0 1 .824.183l4 4.25a.75.75 0 0 1 0 1.028l-4 4.25a.752.752 0 0 1-.823.184A.75.75 0 0 1 3 16.25v-8.5a.75.75 0 0 1 .474-.697Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWatermarkAlignRight };
var IconWatermarkId = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.667 4.278c0-.89.721-1.611 1.61-1.611h.834a.5.5 0 1 1 0 1h-.833a.611.611 0 0 0-.611.61v.834a.5.5 0 0 1-1 0v-.833Zm7.72-1.111a.5.5 0 0 1 .5-.5h.833c.89 0 1.611.721 1.611 1.61v.834a.5.5 0 0 1-1 0v-.833a.611.611 0 0 0-.611-.611h-.833a.5.5 0 0 1-.5-.5Zm2.944 7.72a.5.5 0 1 0-1 0v.833a.611.611 0 0 1-.611.611h-.833a.5.5 0 1 0 0 1h.833a1.61 1.61 0 0 0 1.611-1.611v-.833Zm-10.164-.72a.5.5 0 0 1 .5.5v.833a.61.61 0 0 0 .61.611h.834a.5.5 0 0 1 0 1h-.833A1.61 1.61 0 0 1 2.667 11.5v-.833a.5.5 0 0 1 .5-.5ZM8 4.794a.57.57 0 0 1 .54.393l1.527 4.722a.567.567 0 1 1-1.078.349l-.233-.72H7.244l-.233.72a.567.567 0 1 1-1.078-.349l.355-1.096a.563.563 0 0 1 .01-.03L7.46 5.187A.567.567 0 0 1 8 4.794Zm0 2.408.39 1.204h-.78L8 7.202Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.417 4A2.417 2.417 0 0 0 4 6.417v1.25a.75.75 0 0 0 1.5 0v-1.25c0-.507.41-.917.917-.917h1.25a.75.75 0 0 0 0-1.5h-1.25Zm9.913 0a.75.75 0 0 0 0 1.5h1.25c.506 0 .917.41.917.917v1.25a.75.75 0 1 0 1.5 0v-1.25A2.417 2.417 0 0 0 17.58 4h-1.25Zm2.917 11.58a.75.75 0 0 1 .75.75v1.25a2.417 2.417 0 0 1-2.417 2.417h-1.25a.75.75 0 0 1 0-1.5h1.25c.506 0 .917-.41.917-.917v-1.25a.75.75 0 0 1 .75-.75ZM5.5 16A.75.75 0 0 0 4 16v1.25a2.417 2.417 0 0 0 2.417 2.417h1.25a.75.75 0 0 0 0-1.5h-1.25a.917.917 0 0 1-.917-.917V16ZM12 7.192a.85.85 0 0 1 .809.588l2.291 7.083a.85.85 0 1 1-1.617.524l-.349-1.079h-2.268l-.349 1.079a.85.85 0 1 1-1.617-.524l.532-1.644a.832.832 0 0 1 .014-.045l1.745-5.394A.85.85 0 0 1 12 7.192Zm-.584 5.416h1.168L12 10.803l-.584 1.805Z',
      fill: 'currentColor'
    }));
  }
});
export { IconWatermarkId };
var IconWaveform = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M8 7.167v1.666m1.667-3.055v4.444m1.666-7.055v9.666M4.667 3.167v9.666m1.666-7.055v4.444M13 6.612v2.777M3.02 6.61v2.78',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      d: 'M12 10.75v2.5m2.5-4.583v6.666M17 4.75v14.5M7 4.75v14.5M9.5 8.667v6.666m10-5.416v4.166M4.53 9.917v4.166',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }));
  }
});
export { IconWaveform };
var IconX = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.197 4.136a.75.75 0 1 0-1.06 1.061L6.938 8l-2.803 2.803a.75.75 0 0 0 1.061 1.06L8 9.062l2.803 2.803a.75.75 0 0 0 1.06-1.061L9.062 8l2.803-2.803a.75.75 0 0 0-1.061-1.06L8 6.938 5.197 4.136Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.53 6.47a.75.75 0 0 0-1.06 1.06L10.94 12l-4.47 4.47a.75.75 0 1 0 1.06 1.06L12 13.06l4.47 4.47a.75.75 0 1 0 1.06-1.06L13.06 12l4.47-4.47a.75.75 0 0 0-1.06-1.06L12 10.94 7.53 6.47Z',
      fill: 'currentColor'
    }));
  }
});
export { IconX };
var IconZoomIn = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.667 6.975a3.308 3.308 0 1 1 6.615 0 3.308 3.308 0 0 1-6.615 0Zm3.308-4.308a4.308 4.308 0 1 0 2.672 7.687l2.833 2.833a.5.5 0 0 0 .707-.707l-2.833-2.833a4.308 4.308 0 0 0-3.38-6.98Zm-1.89 4.308a.5.5 0 0 1 .5-.5h.89v-.89a.5.5 0 0 1 1 0v.89h.888a.5.5 0 1 1 0 1h-.888v.888a.5.5 0 0 1-1 0v-.888h-.89a.5.5 0 0 1-.5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.5 10.462a4.962 4.962 0 1 1 9.924 0 4.962 4.962 0 0 1-9.924 0ZM10.462 4a6.462 6.462 0 1 0 4.008 11.53l4.25 4.25a.75.75 0 0 0 1.06-1.06l-4.25-4.25A6.462 6.462 0 0 0 10.462 4Zm-2.833 6.462a.75.75 0 0 1 .75-.75h1.333V8.379a.75.75 0 0 1 1.5 0v1.333h1.333a.75.75 0 1 1 0 1.5h-1.333v1.333a.75.75 0 0 1-1.5 0v-1.333H8.379a.75.75 0 0 1-.75-.75Z',
      fill: 'currentColor'
    }));
  }
});
export { IconZoomIn };
var IconZoomOut = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.975 3.667a3.308 3.308 0 1 0 0 6.615 3.308 3.308 0 0 0 0-6.615ZM2.667 6.975a4.308 4.308 0 1 1 7.687 2.672l2.833 2.833a.5.5 0 0 1-.707.707l-2.833-2.833a4.308 4.308 0 0 1-6.98-3.38Zm2.919-.5a.5.5 0 0 0 0 1h2.777a.5.5 0 1 0 0-1H5.586Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.462 5.5a4.962 4.962 0 1 0 0 9.924 4.962 4.962 0 0 0 0-9.924ZM4 10.462a6.462 6.462 0 1 1 11.53 4.008l4.25 4.25a.75.75 0 0 1-1.06 1.06l-4.25-4.25A6.462 6.462 0 0 1 4 10.462Zm4.379-.75a.75.75 0 1 0 0 1.5h4.166a.75.75 0 0 0 0-1.5H8.38Z',
      fill: 'currentColor'
    }));
  }
});
export { IconZoomOut };
var IconPersonCircleAddSemifill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.29 6.804a4.005 4.005 0 0 1 1.063-.137A4.835 4.835 0 0 1 12.833 8a4.819 4.819 0 0 1-1.454 3.456 3.678 3.678 0 0 0-.865-.732c-.721-.444-1.594-.669-2.514-.669a5.19 5.19 0 0 0-.706.048 3.988 3.988 0 0 1-1.164 3.424 5.833 5.833 0 1 0-3.84-6.723Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8.062 5a1.99 1.99 0 0 0-1.478.623c-.383.412-.559.965-.518 1.54.038.533.251 1.04.61 1.425.367.394.858.63 1.386.63.528 0 1.018-.236 1.385-.63.358-.385.571-.891.61-1.424a2.023 2.023 0 0 0-.52-1.54A1.99 1.99 0 0 0 8.061 5Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.333 14a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Zm0-5.5a.5.5 0 0 1 .5.5v1.167H5a.5.5 0 1 1 0 1H3.833v1.166a.5.5 0 1 1-1 0v-1.166H1.667a.5.5 0 0 1 0-1h1.166V9a.5.5 0 0 1 .5-.5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.434 10.206A6.008 6.008 0 0 1 5 10h.03a7.25 7.25 0 1 1 12.04 7.183 5.515 5.515 0 0 0-1.3-1.098c-1.08-.665-2.39-1.002-3.77-1.002a7.8 7.8 0 0 0-1.06.072 5.982 5.982 0 0 1-1.747 5.136A8.781 8.781 0 0 0 12 20.75a8.75 8.75 0 1 0-8.566-10.544ZM12.093 7.5c-.85 0-1.643.318-2.216.934-.576.618-.84 1.448-.778 2.311.056.8.377 1.56.914 2.137.552.59 1.288.946 2.08.946.791 0 1.527-.354 2.078-.947a3.507 3.507 0 0 0 .914-2.135c.061-.86-.204-1.689-.78-2.309-.57-.612-1.364-.937-2.212-.937ZM10 16a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-4.25-2.5a.75.75 0 0 0-1.5 0v1.75H2.5a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75H7.5a.75.75 0 0 0 0-1.5H5.75V13.5Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonCircleAddSemifill };
var IconPersonCircleSemifill = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.167 8a4.833 4.833 0 1 1 8.212 3.456 3.678 3.678 0 0 0-.865-.732c-.721-.444-1.594-.669-2.514-.669-.906 0-1.8.235-2.516.679a3.725 3.725 0 0 0-.859.726A4.819 4.819 0 0 1 3.167 8ZM8 2.167a5.833 5.833 0 1 0 0 11.666A5.833 5.833 0 0 0 8 2.167Z',
      fill: 'currentColor'
    }), /*#__PURE__*/React.createElement('path', {
      d: 'M8.062 5a1.99 1.99 0 0 0-1.478.623c-.383.412-.559.965-.518 1.54.038.533.251 1.04.61 1.425.367.394.858.63 1.386.63.528 0 1.018-.236 1.385-.63.358-.385.571-.891.61-1.424a2.023 2.023 0 0 0-.52-1.54A1.99 1.99 0 0 0 8.061 5Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 4.75a7.25 7.25 0 0 0-5.058 12.444l-.004-.004a5.586 5.586 0 0 1 1.288-1.09C9.3 15.436 10.64 15.084 12 15.084c1.38 0 2.69.337 3.77 1.002.498.306.934.674 1.299 1.098A7.25 7.25 0 0 0 12 4.75ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Zm6.627-3.566c.573-.616 1.365-.934 2.216-.934.848 0 1.642.325 2.211.937.577.62.842 1.45.781 2.31a3.507 3.507 0 0 1-.914 2.134c-.551.592-1.287.947-2.078.947-.792 0-1.528-.355-2.08-.946a3.498 3.498 0 0 1-.914-2.137c-.061-.863.202-1.693.778-2.311Z',
      fill: 'currentColor'
    }));
  }
});
export { IconPersonCircleSemifill };
var IconZoomTo100 = React.forwardRef(function (_param, ref) {
  var _size = _param.size,
      size = _size === void 0 ? 24 : _size,
      other = _objectWithoutProperties(_param, ['size']);

  if (size === 16 || size === '16') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.975 3.667a3.308 3.308 0 1 0 0 6.615 3.308 3.308 0 0 0 0-6.615ZM2.667 6.975a4.308 4.308 0 1 1 7.687 2.672l2.833 2.833a.5.5 0 0 1-.707.707l-2.833-2.833a4.308 4.308 0 0 1-6.98-3.38Zm5.047-1.036a.5.5 0 0 0-.773-.42l-.788.515a.5.5 0 0 0 .546.837l.015-.01V8a.5.5 0 0 0 1 0V5.939Z',
      fill: 'currentColor'
    }));
  }

  if (size === 24 || size === '24') {
    return /*#__PURE__*/React.createElement('svg', _objectSpread({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      ref: ref,
      focusable: false
    }, other), /*#__PURE__*/React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.462 5.5a4.962 4.962 0 1 0 0 9.924 4.962 4.962 0 0 0 0-9.924ZM4 10.462a6.462 6.462 0 1 1 11.53 4.008l4.25 4.25a.75.75 0 0 1-1.06 1.06l-4.25-4.25A6.462 6.462 0 0 1 4 10.462Zm7.446-1.554a.625.625 0 0 0-.966-.524l-1.183.771a.625.625 0 0 0 .683 1.047l.216-.14V12a.625.625 0 0 0 1.25 0V8.908Z',
      fill: 'currentColor'
    }));
  }
});
export { IconZoomTo100 };